export default {
	"access.organization.name": "Access to organization card",
	"access.user.card": "Access to user card",
	"action.customize.view": "Customize view",
	"action.default.view": "Default view",
	"action.viewcart": "View cart",
	"active": "Active",
	"add-suborg.add-suborg": "Add Sub Organization",
	"add-suborg.admin-info": "Administrator Information",
	"add-suborg.administrator": "Administrator",
	"add-suborg.confirmation": "Confirmation",
	"add-suborg.email": "Administrator email",
	"add-suborg.firstname": "Administrator first name",
	"add-suborg.id": "Organization ID",
	"add-suborg.intro": "For Arcelormittal Europe organization, select an existing organization or create a new one:",
	"add-suborg.lastname": "Administrator last name",
	"add-suborg.matchin-org-intro": "Use data from matching organization:",
	"add-suborg.matching-organizations": "Matching Organizations",
	"add-suborg.new-org-intro": "Create a new sub-organization from scratch:",
	"add-suborg.org-info": "Organization Information",
	"add-suborg.org-name": "Organization name",
	"add-suborg.organization-details": "Organization Details",
	"add-suborg.please-select": "Please select an option",
	"add-suborg.quick-search": "Search a user",
	"add-suborg.vat-num-already-exists": "Vat number already exist. Please give a new vat number",
	"add-suborg.vat-number": "VAT number",
	"add-user.add-user": "Add User",
	"add-user.admin-user": "Promote as administrator for this organization",
	"add-user.confirmation": "Confirmation",
	"add-user.email": "Email",
	"add-user.email-exist": "Email id already exist",
	"add-user.intro": "For Arcelormittal Europe organization, select an existing user or create a new one:",
	"add-user.matchin-users-intro": "Use data from matching users:",
	"add-user.matching-users": "Matching Users",
	"add-user.name": "Name",
	"add-user.new-user-intro": "  Create a new user from scratch:",
	"add-user.please-select": "Please select an option",
	"add-user.proceed-to-creation": "Proceed to creation",
	"add-user.referal-organization": "Referral organization",
	"add-user.required": "Mandatory",
	"add-user.services": "Services",
	"add-user.services-management": "Services Management",
	"add-user.user-creation": "User Creation",
	"add-user.user-email": "Email",
	"add-user.user-exists": "Selected user already exists for organization",
	"add-user.user-firstname": "First name",
	"add-user.user-informations": "User Information",
	"add-user.user-lastname": "Last name",
	"add-user.user-not-active": "Selected user not active",
	"add-user.user-type": "Type of user",
	"add.item.to.cart.error.msg": "Something went wrong with adding items to the cart, please try again after sometime.",
	"add.to.cart.label": "Add to Cart",
	"administrator.message": "is the Administrator of the organization :",
	"ag-grid.copy": "Copy",
	"ag-grid.copyWithHeaders": "Copy with Headers",
	"ag-grid.csvExport": "CSV Export",
	"ag-grid.excelExport": "Excel Export (.xlsx)&lrm;",
	"ag-grid.excelXmlExport": "Excel Export (.xml)&lrm;",
	"ag-grid.export": "Export",
	"ag-grid.paste": "Paste",
	"all.productsFamilies.not.available": "All productFamilies are not available",
	"application.procurement.supplier.rfqNumber": "Supplier RFQ number",
	"aqdb.N.of.dispatch.note": "N of Dispatch Note",
	"aqdb.ageing.duration": "Duration of ageing",
	"aqdb.ageing.temp": "Temperature of ageing",
	"aqdb.aluminium": "% Al",
	"aqdb.anisotropy.avg.r": "R average",
	"aqdb.anisotropy.direction": "Cutting Direction Compared to Rolling",
	"aqdb.anisotropy.r": "Value R",
	"aqdb.arsenic": "% Ar",
	"aqdb.article.reference": "Article reference",
	"aqdb.aspect.side.1": "Aspect side 1 code",
	"aqdb.aspect.side.2": "Aspect side 2 code",
	"aqdb.av.date": "Available date",
	"aqdb.avg.hardening.ratio": "Coefficient of Average Work Hardening",
	"aqdb.axis": "Axis",
	"aqdb.bakeHardening.with.elongation": "Bake-hardening with 2% elongation",
	"aqdb.bakeHardening.without.elongation": "Bake-hardening without elongation",
	"aqdb.base.product.number": "Base product number",
	"aqdb.base.product.release": "Base product release",
	"aqdb.batch": "Batch",
	"aqdb.batch.reference": "Batch reference",
	"aqdb.bend.indicator": "Code folding",
	"aqdb.boron": "% B",
	"aqdb.calcium": "% Ca",
	"aqdb.carbon": "% C",
	"aqdb.carbon.eq.formula": "Formula carbon-equivalent",
	"aqdb.carbon.equivalent": "Carbon equivalent",
	"aqdb.casting.date": "Casting date",
	"aqdb.casting.mill": "Casting Mill",
	"aqdb.cerium": "% Ce",
	"aqdb.chemical.characteristics": "Chemical characteristics",
	"aqdb.chemical.characteristics.cast.analysis": "Chemical characteristics - Cast analysis",
	"aqdb.chemical.characteristics.product.analysis": "Chemical characteristics - Product analysis",
	"aqdb.chemical.formula": "Another combination",
	"aqdb.chemical.surface.chemical.treatment.avg1": "Average value 1",
	"aqdb.chemical.surface.chemical.treatment.avg2": "Average value 2",
	"aqdb.chemical.surface.chemical.treatment.avg3": "Average value 3",
	"aqdb.chemical.surface.chemical.treatment.avg4": "Average value 4",
	"aqdb.chemical.surface.chemical.treatment.avg5": "Average value 5",
	"aqdb.chemical.surface.chemical.treatment.element1": "Chemical element 1",
	"aqdb.chemical.surface.chemical.treatment.element2": "Chemical element 2",
	"aqdb.chemical.surface.chemical.treatment.element3": "Chemical element 3",
	"aqdb.chemical.surface.chemical.treatment.element4": "Chemical element 4",
	"aqdb.chemical.surface.chemical.treatment.element5": "Chemical element 5",
	"aqdb.chemical.surface.chemical.treatment.type": "Type of chemical coating",
	"aqdb.chemical.surface.treatment": "Coating / Surface characteristics - Inorganic coating",
	"aqdb.chromium": "% Cr",
	"aqdb.coating.surface.face": "Face",
	"aqdb.coating.surface.side": "Side",
	"aqdb.code": "Code",
	"aqdb.combination.value": "Value combination",
	"aqdb.commercial.quality": "Commercial quality",
	"aqdb.complete.message": "Indicator of complete message",
	"aqdb.copper": "% Cu",
	"aqdb.customer.article.ref": "Customer Article Ref.",
	"aqdb.customer.product": "Customer product",
	"aqdb.customer.product.data": "Customer products data",
	"aqdb.datas.transmitted.on.certificate": "Data transmitted on certificate",
	"aqdb.date": "Date",
	"aqdb.date.chemical": "Identification Date",
	"aqdb.delivery.mill": "Delivery mill",
	"aqdb.description": "Technical Quality Label",
	"aqdb.dimensions.form": "Dimensions & Form",
	"aqdb.direction.L": "Longitudinal",
	"aqdb.direction.T": "Transverse",
	"aqdb.dis.elongation": "Lengthening distributed",
	"aqdb.dispatch.advice.number": "Dispatch advice number",
	"aqdb.dispatch.date": "Dispatch Date",
	"aqdb.erichsen.index": "Erichsen index",
	"aqdb.external.diameter": "External diameter of MU",
	"aqdb.face.appearance.code1": "Face appearance code 1",
	"aqdb.face.appearance.code2": "Face appearance code 2",
	"aqdb.family.group.code": "Family group code",
	"aqdb.flag.complete": "Complete",
	"aqdb.flag.incomplete": "Incomplete",
	"aqdb.form": "Form",
	"aqdb.format.actual": "Format (actual/ordered)",
	"aqdb.formula.cal02": "Formula CAL02",
	"aqdb.formula.cal15": "Formula CAL15",
	"aqdb.grade": "Grade",
	"aqdb.gross.weight": "Gross Weight",
	"aqdb.hardness.index": "Hardness number",
	"aqdb.hardness.type": "Condition of the hardness test",
	"aqdb.heat.number": "Heat N°'",
	"aqdb.hydrogen": "% H",
	"aqdb.induction.10000w": "Induction at 10000 W",
	"aqdb.induction.2500w": "Induction at 2500 W",
	"aqdb.induction.5000w": "Induction at 5000 W",
	"aqdb.internal.diameter": "Internal diameter of MU",
	"aqdb.label": "AQDB data",
	"aqdb.lead": "% Pb",
	"aqdb.level": "Palier",
	"aqdb.losses.15t": "Losses at 1,5 T",
	"aqdb.losses.1t": "Losses at 1 T",
	"aqdb.magnetic.characteristicList": "Magnetic characteristics",
	"aqdb.manganese": "% Mn",
	"aqdb.marked.identity": "Marked Identity",
	"aqdb.measure.type": "Measure type",
	"aqdb.measured.datas": "Measured data",
	"aqdb.mechanical.characteristics.anisotropy": "Mechanical characteristics - Anisotropy",
	"aqdb.mechanical.characteristics.bake.hardening": "Mechanical characteristics - Bake hardening",
	"aqdb.mechanical.characteristics.bending": "Mechanical characteristics - Bending",
	"aqdb.mechanical.characteristics.erichsen": "Mechanical characteristics - Erichsen",
	"aqdb.mechanical.characteristics.hardness": "Mechanical characteristics - Hardness",
	"aqdb.mechanical.characteristics.impact.resistance": "Mechanical characteristics - Resilience",
	"aqdb.mechanical.characteristics.tensile.test": "Mechanical characteristics - Tensile test",
	"aqdb.metal.coating.aluminium": "% Aluminium",
	"aqdb.metal.coating.average.quantity": "Average quantity",
	"aqdb.metal.coating.characteristics": "Coating / Surface characteristics - Metal coating",
	"aqdb.metal.coating.delta.phase": "Mass Phase Delta",
	"aqdb.metal.coating.dzeta.phase": "Mass Phase Dzeta",
	"aqdb.metal.coating.gamma.phase": "Mass Phase Gamma",
	"aqdb.metal.coating.iron.rate": "Iron rate in galvallia",
	"aqdb.metal.coating.lead": "% Lead",
	"aqdb.metal.coating.measure.type": "Type of measurement",
	"aqdb.metal.coating.nature": "Nature of metallic coating",
	"aqdb.metal.coating.nickel": "% Nickel",
	"aqdb.metal.coating.powdering": "Powdering",
	"aqdb.metal.coating.quantity.centre": "Quantity Centre",
	"aqdb.metal.coating.quantity.edge1": "Quantity Edge 1",
	"aqdb.metal.coating.quantity.edge2": "Quantity Edge 2",
	"aqdb.metal.coating.spangling": "Spangling",
	"aqdb.metal.unit": "Metal unit",
	"aqdb.metal.unit.date": "Metal Unit Identification Date",
	"aqdb.metal.unit.information": "Metal unit informations",
	"aqdb.metal.unit.mill": "Metal Unit Identification Mill",
	"aqdb.mill.cast": "Mill Cast Number",
	"aqdb.mill.cast.number": "Mill Cast Number",
	"aqdb.mill.code": "Receiving mill code",
	"aqdb.mill.description": "Mill",
	"aqdb.mill.internal.ref": "Mill internal reference",
	"aqdb.modelled.data": "Modelled data",
	"aqdb.molybdenum": "% Mo",
	"aqdb.mpa.unit": "megapascal (Mpa)",
	"aqdb.nature": "Nature",
	"aqdb.net.weight": "Net weight (t)",
	"aqdb.nickel": "% Ni",
	"aqdb.niobium": "% Nb",
	"aqdb.nitrogen": "% N2",
	"aqdb.no": "No",
	"aqdb.nominal.thickness": "Nominal thickness",
	"aqdb.nominal.width": "Nominal width",
	"aqdb.notch.average.crystallinity.index": "Average crystallinity index",
	"aqdb.notch.average.ductility.rate": "Average ductility rate",
	"aqdb.notch.average.energy": "Average energy (in Joules)",
	"aqdb.notch.crystallinity.index1": "Crystallinity index 1",
	"aqdb.notch.crystallinity.index2": "Crystallinity index 2",
	"aqdb.notch.crystallinity.index3": "Crystallinity index 3",
	"aqdb.notch.energy1": "Energy 1 (in Joules)",
	"aqdb.notch.energy2": "Energy 2 (in Joules)",
	"aqdb.notch.energy3": "Energy 3 (in Joules)",
	"aqdb.notch.percent.ductility1": "Ductility rate 1",
	"aqdb.notch.percent.ductility2": "Ductility rate 2",
	"aqdb.notch.percent.ductility3": "Ductility rate 3",
	"aqdb.organic.coating.bending": "Bending",
	"aqdb.organic.coating.brilliance": "Brilliance",
	"aqdb.organic.coating.characteristics": "Coating / Surface characteristics - Organic coating",
	"aqdb.organic.coating.colour": "Colour",
	"aqdb.organic.coating.delta.a": "Delta A",
	"aqdb.organic.coating.delta.b": "Delta B",
	"aqdb.organic.coating.delta.e": "Delta E",
	"aqdb.organic.coating.delta.l": "Delta L",
	"aqdb.organic.coating.nature": "Nature of organic coating",
	"aqdb.organic.coating.reticulation": "Reticulation",
	"aqdb.organic.coating.thickness": "Thickness",
	"aqdb.origin.mill": "Origin Mill",
	"aqdb.other.characteristics": "Other Characteristics",
	"aqdb.oui": "Oui",
	"aqdb.phosphorus": "% P",
	"aqdb.pos.across.length": "Position test-tube in the length of the product",
	"aqdb.pos.across.width": "Position test-tube in the width of the product",
	"aqdb.product.family": "Product family",
	"aqdb.quality.code": "Technical Quality Code",
	"aqdb.quality.data": "consult quality data",
	"aqdb.quality.label": "Technical Quality Label",
	"aqdb.quality.version": "Technical Quality Version",
	"aqdb.quarter": "Quarter",
	"aqdb.recipient": "Recipient",
	"aqdb.release": "Technical Quality Version",
	"aqdb.roughness.characteristics": "Coating / Surface characteristics - Roughness",
	"aqdb.roughness.cut.off": "Cut-Off",
	"aqdb.roughness.obtainment": "Method of obtainment",
	"aqdb.roughness.peaks": "Number of peaks",
	"aqdb.roughness.ra": "Ra",
	"aqdb.roughness.rt": "Rt",
	"aqdb.roughness.rz": "Rz",
	"aqdb.roughness.threshold": "Threshold",
	"aqdb.roughness.w": "W",
	"aqdb.sample.type": "Type of test-tube",
	"aqdb.segment": "Segment",
	"aqdb.segments.no": "Number of Segments",
	"aqdb.serial.number": "Serial number",
	"aqdb.shipping": "Shipping Information",
	"aqdb.silicium": "% Si",
	"aqdb.steel.condition": "State of Metal",
	"aqdb.sulphur": "% S",
	"aqdb.surface.cleanliness.carbon": "Surface carbon",
	"aqdb.surface.cleanliness.characteristics": "Coating / Surface characteristics - Surface cleanliness",
	"aqdb.surface.cleanliness.iron": "Surface iron",
	"aqdb.surface.mu": "Surface of MU",
	"aqdb.technical.grade": "Technical grade",
	"aqdb.temp.notch": "Temperature notch test",
	"aqdb.tensile.direction": "Direction",
	"aqdb.tensile.re.rm": "Re/Rm",
	"aqdb.tensile.total.lengthening": "Total Lengthening",
	"aqdb.tensile.ultimate.tensile.stress": "Ultimate Tensile Stress",
	"aqdb.tensile.work.hardening.coefficient": "Work-hardening coefficient",
	"aqdb.test.condition": "Condition of the test",
	"aqdb.test.number.anisotropy": "Number of the test of anisotropy",
	"aqdb.test.number.bakehardening": "Number of the test Bake Hardening",
	"aqdb.test.number.bending": "Number of the bending test",
	"aqdb.test.number.erichsen": "Number of the test of Erichsen",
	"aqdb.test.number.hardness": "Number of the Hardness test",
	"aqdb.test.number.res": "Number of the reslience test",
	"aqdb.test.number.tensile": "Number of the tensile test",
	"aqdb.test.steel.condition": "State of the test-tube",
	"aqdb.test.temp": "Temperature of the test",
	"aqdb.thickness.mm": "Thickness (mm)",
	"aqdb.tin": "% Sn",
	"aqdb.titanium": "% Ti",
	"aqdb.unit": "Unit",
	"aqdb.user": "User",
	"aqdb.value.cal02": "CAL02",
	"aqdb.value.cal15": "CAL15",
	"aqdb.vanadium": "% V",
	"aqdb.weight.mu": "Net weight/Gross weight",
	"aqdb.width.mm": "Width (mm)",
	"aqdb.yes": "Yes",
	"aqdb.yield.stress": "Yield Stress",
	"aqdb.zinc": "% Zn",
	"aqdb.zirconium": "% Zr",
	"arcelormittal.need4steel.action.next": "Next",
	"arcelormittal.need4steel.action.proceed.to.order.button": "Proceed to order",
	"arcelormittal.need4steel.entry": "ArcelorMittal Need4Steel®",
	"arcelormittal.need4steel.menu.entry": "ArcelorMittal Need4Steel",
	"attachment.limit.description": "PDF, DOC, XLS, PPT or images only. Max 20MB per file and max 3 files.",
	"auction-material.category.subcategory": "Cat/sub",
	"auction-material.details": "Material details",
	"auction-material.downgrading.reason": "Down grading reason",
	"auction-material.oil.type": "Oil type",
	"auction-offer.now-rows": "No opened auction offer available",
	"auction-offer.soldTo.changed.warning": "If you change the corporate name, all the bid details you have entered/modified in current session will be lost.",
	"auction.bid.list": "Auctions - Bid list",
	"auction.bid.week": "Bid week",
	"auction.bidding": "Auctions Bids on",
	"auction.bids": "Bids",
	"auction.bundle.number": "Bundle number",
	"auction.confirm.bid": "Confirm bid",
	"auction.confirmation": "Confirmation",
	"auction.dashboard": "Auctions dashboard",
	"auction.description": "Auction description",
	"auction.ended": "Ended",
	"auction.entry": "Auctions",
	"auction.main.steelgrade": "Main steelgrade (per volume)",
	"auction.market": "Market",
	"auction.mill": "Mill",
	"auction.my.auction.bids": "My Auction bids",
	"auction.name": "Auction name",
	"auction.new.offer.check": "Check new auction offer",
	"auction.offer.bid.awarded": "Awarded",
	"auction.offer.bid.pending": "Pending",
	"auction.offer.bid.rejected": "Rejected",
	"auction.offer.bundle": "Bundle",
	"auction.offer.clear.infos": "Clear infos",
	"auction.offer.customer.reference": "Customer reference",
	"auction.offer.customerref.mandatory": "Customer reference is mandatory",
	"auction.offer.delivery.address.mandatory": "Delivery address is mandatory",
	"auction.offer.effective.price": "Effective price",
	"auction.offer.exw.price": "EXW price €/t",
	"auction.offer.exwprice.mandatory": "Exw price is mandatory",
	"auction.offer.invoicing.in": "Invoicing in",
	"auction.offer.lanned.loading.date": "Planned loading date",
	"auction.offer.no.bids": "No bids available",
	"auction.offer.payment.condition": "Condition of payment",
	"auction.offer.tmode.mandatory": "Transport mode is mandatory",
	"auction.offer.transport.cost": "Transport cost",
	"auction.offer.transport.invoiced.conditions": "Transport invoiced conditions",
	"auction.offer.type.of.maritime.transport": "Type of Maritime Transport",
	"auction.overview": "Your auction overview this week",
	"auction.price.unit.et": "€/t",
	"auction.product.type": "Product Type",
	"auction.selection": "Auction selection",
	"auction.submit.not.authorized.internal": "Submit action not authorized in simulation or delegation mode",
	"auction.timer.days": "days",
	"auction.timer.endsin": "Ends in",
	"auction.timer.hours": "h",
	"auction.timer.minutes": "min",
	"auction.timer.weight.available": "Available",
	"auction.transport.price": "Transport cost (€/t)",
	"auction.weight.unit.gross": "gross",
	"auctions.menu": "Auctions",
	"auctions.opened": "auctions opened",
	"batch-card.all-documents": "All documents of this batch",
	"batch-card.batch-information": "Batch information",
	"batch-card.batch-status": "Batch status",
	"batch-card.certificate-display-all": "Display all certificates",
	"batch-card.create-call-off": "Start a new eCall-off",
	"batch-card.current-location": "Current location",
	"batch-card.customer-article-reference": "Customer article reference",
	"batch-card.customer-order-number": "Customer order number",
	"batch-card.data-not-found": "Batch data not found",
	"batch-card.date-available-for-dispatch": "Date available for dispatch",
	"batch-card.days-in-stock": "Number of days in stock",
	"batch-card.detailed-batch-status": "Detailed batch status",
	"batch-card.dispatch-advice-display-all": "Display all dispatch advices",
	"batch-card.document-date": "Date",
	"batch-card.document-number": "Document number",
	"batch-card.document-show": "Show document",
	"batch-card.document-type": "Type",
	"batch-card.final-use": "Final use",
	"batch-card.followup": "Follow-up",
	"batch-card.gross-weight": "Gross weight",
	"batch-card.heat-number": "Heat number",
	"batch-card.invoice-display-all": "Display all invoices",
	"batch-card.last-certificate": "Latest certificate",
	"batch-card.last-dispatch-advice": "Latest dispatch advice",
	"batch-card.last-documents": "Last documents",
	"batch-card.last-invoice": "Latest invoice",
	"batch-card.length": "Length (mm)",
	"batch-card.mill": "Mill",
	"batch-card.mill-order-number": "Mill order number",
	"batch-card.net-weight": "Net weight",
	"batch-card.package-serial-number": "Package serial number",
	"batch-card.planned-loading-date": "Planned loading date",
	"batch-card.shipments": "Shipments",
	"batch-card.steelgrade": "Steelgrade",
	"batch-card.stock-alert": "Stock alert",
	"batch-card.supplier-order-number": "Supplier order number",
	"batch-card.thickness": "Thickness (mm)",
	"batch-card.width": "Width (mm)",
	"batch-list.last-seen": "Last seen batches",
	"batch.card": "Batch card",
	"batch.card.article": "Article",
	"batch.card.customer": "Customer",
	"batch.card.dimensions": "Dimensions",
	"batch.card.final-use": "Final Use",
	"batch.card.go-to-the-order": "Go to the order",
	"batch.card.information": "Batch information",
	"batch.card.invoiced": "Invoiced",
	"batch.card.mill": "Mill",
	"batch.card.mill-order": "Mill Order",
	"batch.card.order": "Order",
	"batch.card.weight": "Weight",
	"batch.coil-length": "Coil length",
	"batch.current-location": "Current location",
	"batch.current.location": "Current location",
	"batch.date-for-dispatch": "Date available for dispatch",
	"batch.despatch.advice": "Dispatch advice",
	"batch.despatch.date": "Dispatch date",
	"batch.detailed-batch-status": "Detailed batch status",
	"batch.ecall-status": "eCall-off status",
	"batch.from.same.invoice": "Only batches from invoice number :",
	"batch.from.same.invoice.available": "are available for this claim",
	"batch.gross": "Gross weight",
	"batch.gross-t": "Gross weight (t)",
	"batch.heat-number": "Heat number",
	"batch.in-stock": "in stock",
	"batch.in-transit-detail": "In transit - Detail",
	"batch.invoice.date": "Invoice date",
	"batch.length": "Length",
	"batch.net": "Net weight",
	"batch.net-t": "Net weight (t)",
	"batch.not.invoiced": "Batch not invoiced",
	"batch.not.invoiced.select.other": "Please come back later to raise a quality issue on this material unit.",
	"batch.not.invoiced.sorry": "Sorry, the batch you have chosen is not yet invoiced",
	"batch.package-serial-number": "Package serial number",
	"batch.planned-loading-date": "Planned loading date",
	"batch.reference": "Batch",
	"batch.requested-delivery-date": "Requested delivery date for eCall-off",
	"batch.requested-delivery-date-from": "Requested delivery date from",
	"batch.requested-delivery-date-to": "Requested delivery date to",
	"batch.shipment.date": "Shipment date",
	"batch.shipto": "Ship to",
	"batch.status": "Batch status",
	"batch.supplier.invoice.number": "Invoice number",
	"batch.view.all": "View all batches",
	"batch.view.all.at": "View all batches at {{value}}",
	"batches.detailed.batch.status": "Detailed batch status",
	"batches.doc": "Doc",
	"batches.gross-t": "Gross (t)",
	"batches.net-t": "Net (t)",
	"batches.number.of.day.in.stock": "Nb of days in stock",
	"blocked-service-alert.plural": "Sorry, these services are currently unavailable for the moment, please try later: {{services}}",
	"blocked-service-alert.refresh": "Refresh",
	"blocked-service-alert.singular": "Sorry, this service is currently unavailable for the moment, please try later: {{service}}",
	"browse.files": "Browse files",
	"cancel.issue": "Cancel your issue",
	"card.no.selected": "no selected product",
	"card.prototype": "Prototype",
	"card.prototype.lastModificationdate": "Last modification date",
	"card.prototype.production": "Production",
	"card.selected": "{{value}} selected products",
	"cdd.in.date": "CDD in date",
	"cdd.in.week": "CDD in week",
	"chart-title.M1": "Jan",
	"chart-title.M10": "Oct",
	"chart-title.M11": "Nov",
	"chart-title.M12": "Dec",
	"chart-title.M2": "Feb",
	"chart-title.M3": "Mar",
	"chart-title.M4": "Apr",
	"chart-title.M5": "May",
	"chart-title.M6": "Jun",
	"chart-title.M7": "Jul",
	"chart-title.M8": "Aug",
	"chart-title.M9": "Sep",
	"chart-title.Q1": "Q1",
	"chart-title.Q2": "Q2",
	"chart-title.Q3": "Q3",
	"chart-title.Q4": "Q4",
	"chart-title.S1": "S1",
	"chart-title.S2": "S2",
	"check.new.offer": "Check new offers",
	"choose.customer.last.used": "Last selections:",
	"choose.customer.restrict": "Please restrict your scope while using SteelUser APP, as it's a customer dedidacted application.",
	"choose.customer.select": "As internal user you have to select the customer for which you want to display data",
	"choose.visibility.select": "Please select your visibility amongst the available options:",
	"claim-batch.receipt-date": "Receipt Date",
	"claim.action.plan.notif": "If needed, call your technical contact to receive a corrective action",
	"claim.add-batch-to-this-issue": "Add batch to this issue",
	"claim.add.attachment": "Add attachment",
	"claim.additional.costs.invalid": "Amount claimed for other cost must be valid",
	"claim.additional.costs.mandatory": "Amount claimed for other cost is mandatory",
	"claim.additional.costs.requested": "Additional costs requested",
	"claim.amount.for.other.costs": "Amount claimed for other costs",
	"claim.amount.previous.value": "Your previous value: {{value}}",
	"claim.amount.unit.error": "Invoice is expressed in:",
	"claim.archived": "Archived",
	"claim.attach.several.documents": "Attach one or several documents",
	"claim.attachment.error": "Your attachments was not uploaded correctly, please try again.",
	"claim.attachment.filename.error": "Please make sure that your filename is less than 80 characters",
	"claim.attachment.limit.zl": "Filename should be less than 80 characters",
	"claim.attachment.limit.zr": "Please provide all relevant details required to validate the claimed amount and quantity, such as the affected coil numbers, weight and any other supporting information. Providing complete and accurate information will help us process your claim quickly and efficiently. Filename should be less than 80 characters",
	"claim.attachment.mandatory": "Please add at least one attachment",
	"claim.attachment.uploading.error": "Some attachments are still uploading, please wait.",
	"claim.attachments": "Attachments",
	"claim.attachments.description": "Please add at least one photo or video that can help ArcelorMittal to provide feedbacks on your request",
	"claim.barcode.number": "Barcode number",
	"claim.batch": "Batch",
	"claim.batch.reference.mandatory": "Batch Reference is mandatory",
	"claim.batch.selection": "Batch selection",
	"claim.batches": "Batches",
	"claim.choose.defect": "Choose defect",
	"claim.claimtype.label": "Claim type",
	"claim.comment": "Comment",
	"claim.comment.mandatory": "Comment is mandatory",
	"claim.comment.placeholder": "Enter a brief comment to explain the quality issue. Try to be as detailed and accurate as possible.",
	"claim.contact.type.mandatory": "Contact type is mandatory",
	"claim.created": "Created",
	"claim.created.by": "Created by",
	"claim.current.status": "Current status",
	"claim.current.statusddot": "Current status:",
	"claim.dashboard.services": "My services",
	"claim.dashboard.services.claims": "Quality feedback",
	"claim.defect": "Defect",
	"claim.defect.mandatory": "Defect is mandatory",
	"claim.display-pending-drafts": "pending feedback(s)",
	"claim.display-saved-drafts": "draft(s) saved",
	"claim.first.batch.selection": "First batch selection",
	"claim.full.quantity": "Full quantity",
	"claim.go-back-to-batch-management": "Go back to batch management",
	"claim.guarantee.request": "REQUEST NEW GUARANTEE",
	"claim.impacted.quantity": "Impacted quantity",
	"claim.impacted.quantity.mandatory": "Impacted quantity is mandatory",
	"claim.impacted.quantity.minimum": "Please enter a valid quantity greater than or equal to 1.",
	"claim.impacted.quantity.t": "Impacted quantity (t)",
	"claim.last.modification": "Last modification",
	"claim.main.batch.remove": "Remove",
	"claim.main.batch.selected": "Selected Batch",
	"claim.material.costs": "Material costs",
	"claim.material.unit": "Material unit",
	"claim.multi.batch.related.order": "Related Order",
	"claim.no.attachment": "No attachment",
	"claim.no.reference": "No reference",
	"claim.no.sample.needed": "No sample needed for this defect.",
	"claim.not-existing-or-not-permission": "The claim doesn't exist or you don't have permission to access the claim information.",
	"claim.optional": "Optional",
	"claim.other.amount.cost": "Amount claimed for other costs",
	"claim.paid.amount": "Paid amount",
	"claim.placeholder.reference.number": "Customer reference number",
	"claim.quality.issue": "Claim",
	"claim.quality.issue.information": "Quality information",
	"claim.quality.issue.summary": "Quality summary",
	"claim.quantity.limit.error": "Requested quantity higher than invoiced quantity.",
	"claim.quantity.previous.value": "Your previous value: {{value}}",
	"claim.quantity.tons.error": "Impacted Quantity should be less than 1000 for unit: Metric tons",
	"claim.quantity.unit.error": "Invoice is expressed in:",
	"claim.raise-new-quality-issue": "Raise a quality issue",
	"claim.receipt.date.mandatory": "Receipt date is mandatory",
	"claim.reference.number": "Reference number",
	"claim.request.type": "Request type",
	"claim.requested.amount": "Requested amount",
	"claim.requested.material.costs": "Requested material costs",
	"claim.sample": "Sample will be sent to:",
	"claim.sample.agency": "Commercial contact",
	"claim.sample.cts": "Technical contact",
	"claim.sample.mandatory": "Sample is mandatory",
	"claim.sample.not": "I will not send a sample",
	"claim.sample.not.recommended": "(not recommended)",
	"claim.sample.other": "Other",
	"claim.sample.other.comment": "Enter the destination of the sample",
	"claim.status.created": "Created",
	"claim.total.amount": "Total evaluated amount",
	"claim.total.requested.amount": "Total requested amount",
	"claim.total.requested.calculated": "Total requested amount calculated",
	"claim.total.weight": "Total weight",
	"claim.type.filter.label": "Claim type",
	"claim.type.zl": "Customer claim ZL",
	"claim.type.zr": "Claim regularization ZR",
	"claim.visit": "Contact from ArcelorMittal",
	"claim.visit.text": "I want to be contacted by an ArcelorMittal contact.",
	"claim.warning": "Warning",
	"claim.warning.takenintoaccount": "Warning taken into account",
	"claim.zr.attachment.info": "Please always mention all affected batches and any additional relevant details (e.g., quantity per batch) to ensure smooth and efficient claim handling.",
	"coil.calculator.additional.data": "Additional data",
	"coil.calculator.all.other.coils": "All other coils",
	"coil.calculator.density.text": "It is based on a constant density of '7.85t/m³'.",
	"coil.calculator.inner.diameter": "Coil inner diameter",
	"coil.calculator.inner.diameter.label": "Coil inner diameter (mm)",
	"coil.calculator.inner.diameter.mandatory": "Coil inner diameter is mandatory",
	"coil.calculator.input.parameters": "Input parameters",
	"coil.calculator.length": "Coil length",
	"coil.calculator.length.label": "Coil length (m)",
	"coil.calculator.length.mandatory": "Coil length is mandatory",
	"coil.calculator.metallic.coating.thickness.label": "Metallic coating thickness (g/㎡)",
	"coil.calculator.metallic.coating.type.label": "Metallic coating type",
	"coil.calculator.metallic.coating.type.mandatory": "Metallic coating type is mandatory",
	"coil.calculator.no.result.text": "Please fill in all the fields to display results.",
	"coil.calculator.nominal.thickness.label": "Nominal thickness (mm)",
	"coil.calculator.nominal.thickness.mandatory": "Nominal thickness is mandatory",
	"coil.calculator.organic.coated.coils": "Organic coated coils",
	"coil.calculator.organic.coated.film.thickness.label": "Organic coated film thickness (μm)",
	"coil.calculator.outer.diameter": "Coil outer diameter",
	"coil.calculator.outer.diameter.label": "Coil outer diameter (mm)",
	"coil.calculator.outer.diameter.mandatory": "Coil outer diameter is mandatory",
	"coil.calculator.outer.less.than.inner.error": "Field smaller than inner Ø",
	"coil.calculator.product.information": "Product information",
	"coil.calculator.result": "Result",
	"coil.calculator.specific.weight": "Specific weight",
	"coil.calculator.specific.weight.label": "Specific weight (kg/mm)",
	"coil.calculator.specific.weight.mandatory": "Specific weight is mandatory",
	"coil.calculator.technical.feasibility.text": "The tool does not provide any technical feasibility at our mills of the calculated coils.",
	"coil.calculator.tool.text": "This coil calculator is a tool to help you calculating outer diameter, coil weight, coil length or specific weight.",
	"coil.calculator.total.paint.thickness.label": "Total paint thickness top + bottom (μm)",
	"coil.calculator.weight": "Coil weight",
	"coil.calculator.weight.label": "Coil weight (ton)",
	"coil.calculator.weight.mandatory": "Coil weight is mandatory",
	"coil.calculator.width.label": "Width (mm)",
	"coil.calculator.width.mandatory": "Width is mandatory",
	"comment.offer.set": "Comments :",
	"commercial-documents-da.enduser": "End user",
	"commercial-documents-da.heat": "Heat",
	"commercial-documents-da.serial": "Serial",
	"commercial-documents-da.supplier-article-reference": "Supplier article reference",
	"commercial-documents.all-my-documents": "My documents",
	"commercial-documents.amount": "Amount certified",
	"commercial-documents.batch-number": "Batch number",
	"commercial-documents.batches-details": "Batches details",
	"commercial-documents.ce.enduser": "End user",
	"commercial-documents.ce.serial-number": "Serial number",
	"commercial-documents.ce.supplier-article-reference": "Supplier article reference",
	"commercial-documents.certificate-card": "Certificate card",
	"commercial-documents.certificate-date": "Certificate date",
	"commercial-documents.certificate-number": "Certificate number",
	"commercial-documents.certificate-type": "Certificate type",
	"commercial-documents.customer": "Customer",
	"commercial-documents.customer-article-reference": "Customer article reference",
	"commercial-documents.customer-claim-reference": "Customer claim reference",
	"commercial-documents.customer-order-number": "Customer order number",
	"commercial-documents.date": "Document date",
	"commercial-documents.dimensions": "Dimensions",
	"commercial-documents.discount": "Discount",
	"commercial-documents.dispatch-advice-date": "Dispatch advice date",
	"commercial-documents.dispatch-advice-number": "Dispatch advice number",
	"commercial-documents.display-all-orders": "Display all orders",
	"commercial-documents.docsWithCreationDateGtLastConnectionDate": "Documents registered since your last connection",
	"commercial-documents.documents": "documents",
	"commercial-documents.download-cart": "Download cart",
	"commercial-documents.emptyHeatNumber": "N/A",
	"commercial-documents.endQuarter": "End Quarter",
	"commercial-documents.enduser": "End user",
	"commercial-documents.final-use": "Final use",
	"commercial-documents.general-information": "General information",
	"commercial-documents.heat-number": "Heat number",
	"commercial-documents.invoice": "Invoice",
	"commercial-documents.invoice-amount": "Invoice amount (total)",
	"commercial-documents.invoice-amount-without-vat": "Invoice amount without VAT(total)",
	"commercial-documents.invoice-card": "Invoice card",
	"commercial-documents.invoice-currency": "Invoice currency",
	"commercial-documents.invoice-date": "Invoice date",
	"commercial-documents.invoice-discount": "Invoice discount(total)",
	"commercial-documents.invoice-number": "Invoice number",
	"commercial-documents.invoice-quantity": "INVOICE QUANTITY",
	"commercial-documents.invoice-tax-amount": "Invoice tax amount(total)",
	"commercial-documents.invoice-type": "Invoice type",
	"commercial-documents.invoiced-quantity": "Invoiced quantity",
	"commercial-documents.invoiced-quantity-unit": "Invoiced quantity (unit)",
	"commercial-documents.line-status": "Line status",
	"commercial-documents.mill": "Mill",
	"commercial-documents.mill-order-number": "Mill order number",
	"commercial-documents.my-commercial-documents": "My commercial documents",
	"commercial-documents.number": "Document number",
	"commercial-documents.order-acknowledgement-date": "Order acknowledgement date",
	"commercial-documents.order-acknowledgement-number": "Order acknowledgement number",
	"commercial-documents.order-acknowledgement-type": "Order acknowledgement type",
	"commercial-documents.order-quantity": "Ordered quantity",
	"commercial-documents.order-reference": "Order reference",
	"commercial-documents.orderAcknowledgement-card": "Order acknowledgement",
	"commercial-documents.ordered-quantity": "Ordered quantity",
	"commercial-documents.orders-line-details": "Order line details",
	"commercial-documents.orders-number": "Order number",
	"commercial-documents.payer": "Payer",
	"commercial-documents.payer-vat-number": "Payer VAT number",
	"commercial-documents.payment-due-date": "Payment due date",
	"commercial-documents.payment-due-to": "Payment due to",
	"commercial-documents.payment-information": "Payment information",
	"commercial-documents.plant-invoice-number": "Plant invoice number",
	"commercial-documents.product": "Product",
	"commercial-documents.product-descriptions": "Product description",
	"commercial-documents.proforma": "Proforma",
	"commercial-documents.received-by-steeluser": "Received by SteelUser",
	"commercial-documents.rrp": "RRP type",
	"commercial-documents.shipto": "Ship to",
	"commercial-documents.soldto": "Sold to",
	"commercial-documents.steel-grade": "Steel grade",
	"commercial-documents.subtype": "Subtype",
	"commercial-documents.supplier-claim-reference": "Supplier claim reference",
	"commercial-documents.supplier-order-number": "Supplier order number",
	"commercial-documents.supplier-vat-number": "Supplier VAT number",
	"commercial-documents.tax": "Tax",
	"commercial-documents.transport-mode": "Transport mode",
	"commercial-documents.transport-reference": "Transport reference",
	"commercial-documents.type": "Document type",
	"commercial-documents.vat": "VAT",
	"commercial-documents.vat-percentage": "VAT percentage",
	"commercial-documents.weight": "Weight",
	"commercial-documents.without-vat": "Without VAT",
	"commercial-documents.xcarbsubtype": "XCarb® sub-type",
	"confirm.continue": "Do you want to continue?",
	"confirm.modified": "Last modified on",
	"confirm.respectively": "respectively.",
	"confirm.same.material": "There is another claim on the same material unit with reference to",
	"confirm.thanks": "Thank you, we have received your request.",
	"confirm.thanks.fastlane": "Thank you, we have received your request",
	"confirmation.message": "You will not be able to undo this action after confirmation.",
	"contact.us": "Contact E-business Support",
	"contactmail.popup.success.msg-line1": "Thanks, we have well received your message.",
	"contactmail.popup.success.msg-line2": "We will provide feedback as soon as possible.",
	"contactmail.submit.attachment.error.msg": "Sorry, something wrong with the attachment, try to reupload it",
	"contactmail.submit.error.msg": "Sorry, something wrong during the process. Try again later.",
	"contactmail.submit.session.error.msg": "Sorry, something wrong with your session, try to log again.",
	"continue.draft": "Continue your draft",
	"corrosion.A": "Atmospheric",
	"corrosion.S": "Soil Corrosion",
	"create.new.order": "Create a new order",
	"create.new.request": "CREATE A NEW REQUEST",
	"customer.share.view": "Share the view",
	"customer.simulation": "Select a customer",
	"dashboard.active.parameters": "Active Parameters",
	"dashboard.add-widget": "Add widget",
	"dashboard.add-widget-instruction": "Please select the widget you want to add",
	"dashboard.cancel": "Cancel",
	"dashboard.card.time-in-stock": "Time in stock",
	"dashboard.card.time-in-stock.time-to-call": "TIME TO CALL",
	"dashboard.card.time-in-stock.view-details": "View details",
	"dashboard.claims": "Claims",
	"dashboard.condition": "Condition:",
	"dashboard.customer-material-reference": "Customer material reference",
	"dashboard.customize-indicator": "Customize indicator",
	"dashboard.customize-information": "Customize information",
	"dashboard.delete.confirmation-question": "Do you really want to delete this widget?",
	"dashboard.documents-since-last-connection": "Documents registered since your last connection",
	"dashboard.drag-customer-article-here": "Drop customer article reference here",
	"dashboard.drag-drop-information": "Drag and drop values into the box on the right",
	"dashboard.drag-steelgrades-here": "Drop steelgrades here",
	"dashboard.efeasibility": "eFeasibility",
	"dashboard.efeasibility.add.new": "Ask for a new feasibility",
	"dashboard.indicator": "Indicator",
	"dashboard.information": "Information",
	"dashboard.key-indicator": "Key indicator",
	"dashboard.key-information": "Key information",
	"dashboard.my-business-overview": "My business overview",
	"dashboard.my.data": "My data",
	"dashboard.order-status": "Order status",
	"dashboard.orders": "Orders",
	"dashboard.rts-widget.title": "Stocks",
	"dashboard.rts-widget.tooltip": "Ready to ship quantity available for this product in all stocks",
	"dashboard.savechanges": "Save Changes",
	"dashboard.saving": "dashboard widgets is being saved ...",
	"dashboard.schedule.business.order-status": "Schedule business order status",
	"dashboard.spot.order-status": "Spot order status",
	"dashboard.steelgrade": "Steelgrade",
	"dashboard.validate": "Validate",
	"dashboard.view.more": "View more",
	"dashboard.widget-configuration": "Configuration",
	"dashboard.widget-preview": "Preview",
	"dashboard.widget.highest-stocks": "Top 5 highest stocks",
	"dashboard.widget.material-ready-to-ship": "Material ready to ship",
	"dashboard.without-value": "Without value",
	"datacenter-filter.LMD": "Modification date",
	"datacenter-filter.PO-Reception-date": "PO Reception date",
	"datacenter-filter.PO-Reception-week": "PO Reception week",
	"datacenter-filter.Proposed-Total-weight": "Proposed total weight",
	"datacenter-filter.Proposed-blank-weight": "Proposed blank weight",
	"datacenter-filter.Proposed-price": "Price Proposal",
	"datacenter-filter.additional-desc": "Additional item information",
	"datacenter-filter.back-office-customer": "Back office customer",
	"datacenter-filter.back-office-role": "Back office role",
	"datacenter-filter.batch-reference": "Batch reference",
	"datacenter-filter.batch-status": "Detailed batch status",
	"datacenter-filter.batches-not-delivered-gross": "Batches not yet delivered to final destination (Gross, t)",
	"datacenter-filter.batches-not-delivered-net": "Batches not yet delivered to final destination (net, t)",
	"datacenter-filter.bill-to": "Bill to",
	"datacenter-filter.carrier-name": "Carrier name",
	"datacenter-filter.cdd": "CDD (Week)",
	"datacenter-filter.cdd-date": "CDD",
	"datacenter-filter.chemical-passivation": "Chemical Passivation",
	"datacenter-filter.choice": "Choice",
	"datacenter-filter.coating": "Coating specification",
	"datacenter-filter.coilAxis": "CoilAxis",
	"datacenter-filter.collate-documents": "Collate Documents",
	"datacenter-filter.color-bottom-side": "Color bottom side",
	"datacenter-filter.color-category-bottom-side": "Color Category Bottom Side",
	"datacenter-filter.color-category-top-side": "Color Category Top Side",
	"datacenter-filter.color-top-side": "Color top side",
	"datacenter-filter.creation-date": "Creation date",
	"datacenter-filter.current-location": "Current location",
	"datacenter-filter.customer-article-reference": "Customer article reference",
	"datacenter-filter.customer-order-number": "Customer order number",
	"datacenter-filter.customer-order-number-without-item": "Customer order nr w/o item",
	"datacenter-filter.customer-req-name": "Customer request name",
	"datacenter-filter.customerRefusal": "Customer refusal comments",
	"datacenter-filter.data-sheet-bottom-side": "Organic data sheet bottom side",
	"datacenter-filter.data-sheet-top-side": "Organic data sheet top side",
	"datacenter-filter.date-available-for-dispatch": "Date available for dispatch",
	"datacenter-filter.delay": "Delay",
	"datacenter-filter.delivery-address": "Delivery address",
	"datacenter-filter.delivery-address-order": "Delivery address for order",
	"datacenter-filter.delivery-location": "Delivery location",
	"datacenter-filter.delivery-mode": "Delivery mode",
	"datacenter-filter.destination-address": "Destination Address",
	"datacenter-filter.destination-by-boat": "Destination by boat",
	"datacenter-filter.destination-name": "Destination Name",
	"datacenter-filter.detailed-batch-status": "Detailed batch status",
	"datacenter-filter.dimension": "Dim (mm)",
	"datacenter-filter.dispatch-advice": "Dispatch Advice",
	"datacenter-filter.dispatch-advice-date": "Dispatch advice date",
	"datacenter-filter.dispatch-advice-date-n1": "N-1 Dispatched date",
	"datacenter-filter.dispatch-advice-date-n2": "N-2 Dispatched date",
	"datacenter-filter.dispatch-advice-number": "Dispatch advice number",
	"datacenter-filter.dispatch-advice-number-n1": "N-1 Dispatch advice number",
	"datacenter-filter.dispatch-advice-number-n2": "N-2 Dispatch advice number",
	"datacenter-filter.dispatch-date": "Dispatch date",
	"datacenter-filter.easy-film-bottom": "EasyFilm Bottom",
	"datacenter-filter.easy-film-top": "EasyFilm Top",
	"datacenter-filter.end-user": "End user",
	"datacenter-filter.final-use": "Final use",
	"datacenter-filter.first-name": "First name",
	"datacenter-filter.form": "Form",
	"datacenter-filter.grade": "Grade",
	"datacenter-filter.gross-consignment": "Consign. (Gross, t)",
	"datacenter-filter.gross-first-batch": "First batch in stock (week)",
	"datacenter-filter.gross-in-transit-details": "In transit details(Gross, t)",
	"datacenter-filter.gross-last-batch": "Last batch in stock (week)",
	"datacenter-filter.heat-number": "Heat number",
	"datacenter-filter.hts-code": "hts code",
	"datacenter-filter.incoterm2": "Incoterm 2",
	"datacenter-filter.internal-diameter": "Internal Diameter",
	"datacenter-filter.interpretation-delivery-date": "Interpretation delivery date",
	"datacenter-filter.invalid-number": "Invalid number",
	"datacenter-filter.item-sold-to-party": "Item sold to party",
	"datacenter-filter.last-name": "Last name",
	"datacenter-filter.length": "Length (m)",
	"datacenter-filter.loading-program-number": "Loading program number",
	"datacenter-filter.material-not-avilable": "Material not available",
	"datacenter-filter.materialAvailability": "Material Availability",
	"datacenter-filter.mill": "Mill",
	"datacenter-filter.mill-order-number": "Mill order number",
	"datacenter-filter.net-consignment": "Consign. (Net, t)",
	"datacenter-filter.net-in-transit": "In transit (Net, t)",
	"datacenter-filter.net-in-transit-details": "In transit details(Net, t)",
	"datacenter-filter.net-ready-to-ship": "RTS (Net, t)",
	"datacenter-filter.nominal-gloss-bottom-side": "Nominal gloss bottom side",
	"datacenter-filter.nominal-gloss-top-side": "Nominal gloss top side",
	"datacenter-filter.oil-reference": "Oil Reference",
	"datacenter-filter.order-created-by": "Order created by",
	"datacenter-filter.order-creator": "Order creator",
	"datacenter-filter.order-item-status": "Order item status",
	"datacenter-filter.order-reason": "Order reason",
	"datacenter-filter.organic-structure-bottom-side": "Organic coating bottom side structure",
	"datacenter-filter.organic-structure-top-side": "Organic coating top side structure",
	"datacenter-filter.organization-city": "City",
	"datacenter-filter.organization-id": "Organization ID",
	"datacenter-filter.organization-name": "Organization name",
	"datacenter-filter.organization-role": "Role",
	"datacenter-filter.organization-service": "Organization service",
	"datacenter-filter.organization-status": "Organization status",
	"datacenter-filter.organization-suppliers": "Organization suppliers",
	"datacenter-filter.organization-type": "Organization type",
	"datacenter-filter.package-serial-number": "Package serial number",
	"datacenter-filter.paint-marking-for-sh": "Paint Marking (for SH)",
	"datacenter-filter.pattern-for-sh": "Pattern (for SH)",
	"datacenter-filter.planned-shipment-date": "Planned loading date",
	"datacenter-filter.ponumber": "PO Number",
	"datacenter-filter.price-unit": "Price unit",
	"datacenter-filter.produced-length-dimension": "Actual length",
	"datacenter-filter.producedDimension": "Produced Dim",
	"datacenter-filter.producedLength": "Produced length (m)",
	"datacenter-filter.producedThickness": "Produced thickness (mm)",
	"datacenter-filter.producedWidth": "Produced width (mm)",
	"datacenter-filter.product-category": "Product category",
	"datacenter-filter.product-description": "Product description",
	"datacenter-filter.proposed-coating": "Proposed coating",
	"datacenter-filter.proposed-inner-diameter": "Proposed inner diameter",
	"datacenter-filter.proposed-length": "Proposed length",
	"datacenter-filter.proposed-oiling": "Proposed oiling",
	"datacenter-filter.proposed-outside-diameter": "Proposed outer diameter",
	"datacenter-filter.proposed-packing": "Proposed packaging",
	"datacenter-filter.proposed-quantity": "Proposed quantity",
	"datacenter-filter.proposed-steelgrade": "Proposed steel grade",
	"datacenter-filter.proposed-thickness": "Proposed thickness",
	"datacenter-filter.proposed-unit": "Proposed quantity unit",
	"datacenter-filter.proposed-weight": "Proposed sheet weight",
	"datacenter-filter.proposed-width": "Proposed width",
	"datacenter-filter.protection": "Protection",
	"datacenter-filter.proto-name": "Prototype name",
	"datacenter-filter.proto-status": "Prototype status",
	"datacenter-filter.provisional-firm-item": "Provisional/Firm item",
	"datacenter-filter.quantity-unit": "Quantity Unit",
	"datacenter-filter.rdd": "RDD",
	"datacenter-filter.rdd-date": "RDD",
	"datacenter-filter.rdd-week": "RDD (week)",
	"datacenter-filter.ready-to-ship-date": "Date available for dispatch",
	"datacenter-filter.readyForDispatch": "Ready for dispatch at PO receipt (week)",
	"datacenter-filter.req-desc": "Request Description",
	"datacenter-filter.sales-quarter": "Sales quarter",
	"datacenter-filter.service-level": "Service level",
	"datacenter-filter.service-request": "Service request",
	"datacenter-filter.ship-to": "Ship to",
	"datacenter-filter.ship-to-address": "Delivery address",
	"datacenter-filter.shipment-reference-date": "Dispatch date",
	"datacenter-filter.shipping-date": "Shipping date",
	"datacenter-filter.shipping-week": "Expected shipping week",
	"datacenter-filter.sold-to": "Customer",
	"datacenter-filter.special-stock-partner": "Stock partner",
	"datacenter-filter.spot-or-schedule": "Spot or schedule",
	"datacenter-filter.standard": "Standard",
	"datacenter-filter.standard-steel-grade": "Steel grade",
	"datacenter-filter.steeluser-order-number": "Steeluser order number",
	"datacenter-filter.stockist": "Stockist",
	"datacenter-filter.supplier-rfq": "SupplierRfqNumber",
	"datacenter-filter.surface": "Surface",
	"datacenter-filter.thickness": "Thickness (mm)",
	"datacenter-filter.total-thickness-coating-bottom": "Total thickness coating bottom (G/M2)",
	"datacenter-filter.total-thickness-coating-top": "Total thickness coating top (G/M2)",
	"datacenter-filter.trademark-name-bottom-side": "Trademark name bottom side",
	"datacenter-filter.trademark-name-top-side": "Trademark name top side",
	"datacenter-filter.transport-mode": "Transport mode",
	"datacenter-filter.transport-mode-n1": "N-1 Transport mode",
	"datacenter-filter.transport-mode-n2": "N-2 Transport mode",
	"datacenter-filter.transport-reference": "Transport reference",
	"datacenter-filter.transport-reference-n1": "N-1 Transport reference",
	"datacenter-filter.transport-reference-n2": "N-2 Transport reference",
	"datacenter-filter.transportRef": "Transport reference",
	"datacenter-filter.ultrasonic-testing": "Ultrasonic Testing",
	"datacenter-filter.user-creation-date": "Creation date",
	"datacenter-filter.user-email": "Email",
	"datacenter-filter.user-first-name": "First name",
	"datacenter-filter.user-id": "Id",
	"datacenter-filter.user-last-name": "Last name",
	"datacenter-filter.user-organization-name": "Organization name",
	"datacenter-filter.user-role": "Role",
	"datacenter-filter.user-status": "Status",
	"datacenter-filter.users-city": "City",
	"datacenter-filter.users-countrycode": "Country",
	"datacenter-filter.width": "Width (mm)",
	"datacenter-filter.z-test-certificat": "Z-test Certificat",
	"datacenter-shipment.batch": "Batch",
	"datacenter-shipment.customer": "Customer",
	"datacenter-shipment.customer-article-reference": "Customer article reference",
	"datacenter-shipment.customer-order-number": "Customer order number",
	"datacenter-shipment.date-available-for-dispatch": "Date available for dispatch",
	"datacenter-shipment.dispatch-advice-date": "Dispatch advice date",
	"datacenter-shipment.dispatch-advice-number": "Dispatch advice number",
	"datacenter-shipment.grade": "Steel grade",
	"datacenter-shipment.gross-weight": "Gross weight (t)",
	"datacenter-shipment.mill": "Mill",
	"datacenter-shipment.net-weight": "Net weight (t)",
	"datacenter-shipment.ship-to": "Ship to",
	"datacenter-shipment.shipment-quantity-gross": "Shipment quantity (Gross, t)",
	"datacenter-shipment.shipment-quantity-net": "Shipment quantity (Net, t)",
	"datacenter-shipment.supplier-order-number": "Supplier order number",
	"datacenter-shipment.thickness": "Thickness (mm)",
	"datacenter-shipment.transport-mode": "Transport mode",
	"datacenter-shipment.transport-reference": "Transport reference",
	"datacenter-shipment.width": "Width (mm)",
	"datacenter.add-columns": "Add columns",
	"datacenter.all": "All",
	"datacenter.all-columns-added-to-grid": "All columns added to grid.",
	"datacenter.all-data-center": "All data center",
	"datacenter.annealed": "Annealed",
	"datacenter.apply": "Apply",
	"datacenter.aqdb": "eAQDB",
	"datacenter.aqdb-view": "Data center: eAQDB",
	"datacenter.at-reshipper-gross": "At reshipper (Gross, t)",
	"datacenter.at-reshipper-net": "At reshipper (Net, t)",
	"datacenter.balanced-not-produced": "Balanced not produced",
	"datacenter.batch": "Batches",
	"datacenter.batches": "Data center: Batches",
	"datacenter.calloff": "Data center : eCall-off",
	"datacenter.calloff-by-batch": "eCall-off by batch",
	"datacenter.calloff-by-volume": "eCall-off by volume",
	"datacenter.cancel": "Cancel",
	"datacenter.click-on-items-on-the-right": "Click on items on the right to add a filter",
	"datacenter.cold-rolled": "Cold rolled",
	"datacenter.columns": "Columns",
	"datacenter.commercial-documents": "Data center: Commercial documents",
	"datacenter.composite": "Composite",
	"datacenter.create-new-view": "Create new view",
	"datacenter.current-layout": "Current layout",
	"datacenter.customize-view": "Customize view",
	"datacenter.cutting-beveling": "Cutting and beveling",
	"datacenter.data-center": "Data center",
	"datacenter.data-center-shipments": "Data center: Shipments",
	"datacenter.default": "Default",
	"datacenter.delete": "Delete",
	"datacenter.do-you-want-remove": "Do you want remove the view",
	"datacenter.document": "Commercial documents",
	"datacenter.documents": "Documents",
	"datacenter.download-invoice": "Download invoice",
	"datacenter.drag-and-drop-item-hint": "Drag and drop an item to add or remove a column",
	"datacenter.drag-element-here-fixed": "Drag here to add fixed columns.",
	"datacenter.drag-element-here-hide": "Drag element here to hide columns in grid.",
	"datacenter.drag-element-here-scrollable": "Drag here to add scrollable columns.",
	"datacenter.edit-view": "Edit view",
	"datacenter.favorite.added": "View added to favorites",
	"datacenter.favorite.max-reached": "Maximum number of favorites reached. Remove an existing favorite before adding a new one.",
	"datacenter.favorite.removed": "View removed from favorites",
	"datacenter.favorite.update-error": "Unable to update favorite status",
	"datacenter.filter.clear": "Clear",
	"datacenter.filters": "Filters",
	"datacenter.fixed-columns": "Fixed columns (6 maximum)",
	"datacenter.fixed-columns-scrollable": "Fixed columns (10 maximum)",
	"datacenter.graph.first-bar-label": "Below - 30 days",
	"datacenter.graph.fourth-bar-label": "91 - Above",
	"datacenter.graph.second-bar-label": "31 - 60 days",
	"datacenter.graph.third-bar-label": "61 - 90 days",
	"datacenter.guarantee": "Data center : Guarantee",
	"datacenter.handed-over-to-planning": "Handed over to planning",
	"datacenter.hot-rolled": "Hot rolled",
	"datacenter.in-transit-gross": "In transit (Gross, t)",
	"datacenter.in-transit-to-customer-gross": "In transit to customer (Gross, t)",
	"datacenter.in-transit-to-customer-net": "In transit to customer (Net, t)",
	"datacenter.land-transit-gross": "Land transit (Gross, t)",
	"datacenter.land-transit-net": "Land transit (Net, t)",
	"datacenter.layout": "Layout",
	"datacenter.layout-sorting": "Layout and sorting",
	"datacenter.metallic-coated": "Metallic coated",
	"datacenter.minimal-quantity-for-this-item-is": "The minimal quantity for this item is",
	"datacenter.name-your-new-layout": "Name your new layout",
	"datacenter.nb-days-in-stock": "Nb days in stock",
	"datacenter.net-qty-delivered": "Delivered (Net, t)",
	"datacenter.net-qty-not-delivered": "Not Delivered (Net, t)",
	"datacenter.normalizing": "Normalizing",
	"datacenter.offer": "Offers",
	"datacenter.offer.subcategory": "Sub category",
	"datacenter.offers": "Data center: Offer Lines",
	"datacenter.on-vessel-gross": "On vessel (Gross, t)",
	"datacenter.on-vessel-net": "On vessel (Net, t)",
	"datacenter.open-needs": "Open Needs",
	"datacenter.or-save-as-a-new-view": "Or save as a new view",
	"datacenter.order": "Orders",
	"datacenter.ordered": "Ordered (t)",
	"datacenter.orders": "Data center: Orders",
	"datacenter.organic-coated": "Organic coated",
	"datacenter.organization": "Organizations",
	"datacenter.organizations": "Data center: Organizations",
	"datacenter.overseas-transit-gross": "Overseas transit (Gross, t)",
	"datacenter.overseas-transit-net": "Overseas transit (Net, t)",
	"datacenter.oxi-cutting": "Oxicutting",
	"datacenter.packing": "Packing",
	"datacenter.pickled": "Pickled",
	"datacenter.planned-casting": "Planned Casting",
	"datacenter.prematerial-ordered": "Prematerial ordered",
	"datacenter.prototypes": "Data center: Prototypes",
	"datacenter.qty-delivered": "Delivered (Gross, t)",
	"datacenter.qty-gross": "Gross (t)",
	"datacenter.qty-in-production": "WIP (t)",
	"datacenter.qty-in-transit": "In transit (t)",
	"datacenter.qty-net": "Net (t)",
	"datacenter.qty-not-delivered": "Not Delivered (Gross, t)",
	"datacenter.qty-ordered": "Ord (t)",
	"datacenter.qty-ready-to-ship": "Ready to ship (t)",
	"datacenter.quality": "Quality",
	"datacenter.quality-control": "Quality control (t)",
	"datacenter.quality-issues": "Data center: Quality issues",
	"datacenter.requested-quantity-is-greater-than-the-maximum-value": "The requested quantity is greater than the maximum value",
	"datacenter.reset-all-filters": "Reset all filters",
	"datacenter.result": "1 result",
	"datacenter.results": "{{value}} results",
	"datacenter.rolling-stand": "Rolling stand",
	"datacenter.rts-gross": "RTS (Gross, t)",
	"datacenter.save": "Save",
	"datacenter.save-as": "Save as ...",
	"datacenter.save-changes-in-the-view": "Save changes in the view",
	"datacenter.save-new-layout-as": "Save new layout as ...",
	"datacenter.save-new-view": "Save new view",
	"datacenter.save-the-view": "Save the view",
	"datacenter.schedule-business-order": "Schedule business orders",
	"datacenter.schedule-business-orders": "Data center: Schedule business orders",
	"datacenter.scrollable-columns": "Scrollable columns",
	"datacenter.select-a-view": "Select a view",
	"datacenter.selected": " ({{value}} selected)",
	"datacenter.shipment": "Shipments",
	"datacenter.shot-blasting": "Shot blasting",
	"datacenter.skin-pass": "Skin pass",
	"datacenter.slab": "Slab",
	"datacenter.slitting": "Slitting",
	"datacenter.sorting": "Sorting",
	"datacenter.stock-blocked-gross": "Stock blocked (Gross, t)",
	"datacenter.stock-blocked-net": "Stock blocked (Net, t)",
	"datacenter.total": "Total",
	"datacenter.users": "Data center: Users",
	"datacenter.view-load-error": "Unable to load datacenter view",
	"datacenter.view-name": "View name",
	"datacenter.view-name.duplicate.error": "A view with the name '{{viewName}}' already exists. Please choose a different name.",
	"datacenter.view-name.error": "View name must be unique",
	"datacenter.view-not-found": "View '{{viewName}}' not found",
	"datacenter.view.add-filters": "Add filters",
	"datacenter.you-have-too-many-fixed-columns-to-add-a-new-one": "You have too many fixed columns to add a new one",
	"datacenter.you-have-too-many-scroll-columns-to-add-a-new-one": "You have too many scrollable columns to add a new one",
	"datacenterview.Certificate": "Certificate",
	"datacenterview.DispatchAdvice": "Dispatch advice",
	"datacenterview.Invoice": "Invoice",
	"datacenterview.OrderAcknowledgment": "Order acknowledgement",
	"defect.CDCUS00A": "Dimensions",
	"defect.CDCUS00B": "Weight",
	"defect.CDCUS00C": "Surface aspect",
	"defect.CDCUS00D": "Coating Problem",
	"defect.CDCUS00E": "Welds",
	"defect.CDCUS00F": "Rust",
	"defect.CDCUS00G": "Flatness",
	"defect.CDCUS00H": "Mech Prop / Chemical analysis",
	"defect.CDCUS00I": "Problems when processing the metal",
	"defect.CDCUS00J": "Packaging",
	"defect.CDCUS00K": "Delivery Time",
	"defect.CDCUS00L": "Transport",
	"defect.CDCUS00M": "Label error",
	"defect.Z/CDCUS00A/0600": "Dimensions",
	"defect.Z/CDCUS00B/0100": "Coil Weight",
	"defect.Z/CDCUS00B/0200": "Shipped quantity (too much/less, difference with invoiced quantity …)",
	"defect.Z/CDCUS00C/0400": "Rust & Oxidation",
	"defect.Z/CDCUS00C/1400": "Surface aspect",
	"defect.Z/CDCUS00D/0500": "Coating Problem",
	"defect.Z/CDCUS00E/0400": "Welds",
	"defect.Z/CDCUS00F/0400": "Surface Protection (oil, film, …)",
	"defect.Z/CDCUS00G/0700": "Flatness",
	"defect.Z/CDCUS00H/0600": "Quality (mechanical properties, chemical analysis, …)",
	"defect.Z/CDCUS00I/0600": "Processing",
	"defect.Z/CDCUS00J/0900": "Presentation (packaging, label, coiling, …)",
	"defect.Z/CDCUS00K/0300": "Delivery Time",
	"defect.Z/CDCUS00L/0100": "Transport error (adress, mode)",
	"defect.Z/CDCUS00L/0600": "Transport Damage",
	"defect.Z/CDCUS00M/0300": "Technical Documentation (certificates, product description, bill of lading …)",
	"delete.draft": "Delete your draft",
	"delete.only-administrator": "It is not possible to delete this user because there is no other user in company.",
	"delivery-tracking.at-overseas-stock": "At overseas stock",
	"delivery-tracking.delivery-follow-up": "Delivery follow-up",
	"delivery-tracking.in-land-transit": "In land transit",
	"delivery-tracking.in-overseas-transit": "In overseas transit",
	"delivery-tracking.in-transit-to-customer": "In transit to customer",
	"delivery-tracking.order-and-delivery-overview": "Order and delivery overview",
	"delivery-tracking.stock-per-mill": "Stock per mill",
	"delivery-tracking.to-reshipper-in-land-transit-to-warehouse": "To reshipper / In land transit / To warehouse",
	"delivery-tracking.total": "Total",
	"delivery-tracking.view-details": "View all details",
	"delivery.status.late": "Late",
	"delivery.status.on-customer-time": "On customer time",
	"delivery.status.on-supplier-time": "On supplier time",
	"delivery.status.on-time": "On time",
	"dialog-upload-file": "Please upload a file",
	"dialog.all-column-added-to-grid": "All Columns added to grid",
	"dialog.apply": "Apply",
	"dialog.customize.view.title": "Choose the columns with a drag and drop",
	"dialog.delete.description": "Do you really want to remove this user",
	"dialog.delete.title": "Remove User",
	"dialog.drag-elements-here-hide": "Drag element to hide columns in grid",
	"dialog.drag-elements-here-scrollable": "Drag here to add columns in layout",
	"dialog.loose-data-message": "This action will remove all your data. Do you want to continue?",
	"dialog.select.batch": "Select Batch",
	"doc-ce-subtype.01": "2.1: Declaration of compliance with the order",
	"doc-ce-subtype.02": "2.1: Declaration of compliance with the order",
	"doc-ce-subtype.17": "3.1: Inspection certificate 3.1",
	"doc-ce-subtype.51": "2.2: Test Report",
	"doc-ce-subtype.52": "3.2: Inspection certificate 3.2",
	"doc-ce-subtype.car": "Chemical Analysis Report",
	"doc-ce-subtype.cconf": "Certificate of Compliance",
	"doc-ce-subtype.ccpu": "Test Certificate",
	"doc-ce-subtype.cem": "CE Marking",
	"doc-ce-subtype.ceran": "Test Certificate 2.2 Chem. Analysis",
	"doc-ce-subtype.cerre": "Certificate of reception",
	"doc-ce-subtype.cerus": "Certificate of reception",
	"doc-ce-subtype.cinsp": "Inspection certificate 3.2",
	"doc-ce-subtype.ctl": "Inspection report",
	"doc-ce-subtype.fcp": "Product characteristics sheet",
	"doc-ce-subtype.ohsas": "Safety report",
	"doc-in-subtype.AVOIR": "Credit Note",
	"doc-in-subtype.DEBIT": "Debit letter",
	"doc-in-subtype.FACTU": "Invoice",
	"doc-oa-subtype.N": "Changed",
	"doc-oa-subtype.O": "Original",
	"doc-xcarb-subtype.a": "Green Steel Certificate",
	"doc-xcarb-subtype.b": "Recycled and renewably produced",
	"doc-xcarb-subtype.c": "EcoSheetPilePlus",
	"doc-xcarb-subtype.d": "Steel Certificate",
	"doc-xcarb-subtype.e": "Steel certificate (factor:0.7)",
	"doc-xcarb-subtype.f": "Steel certificate (factor:1.0)",
	"doc-xcarb-subtype.g": "Steel certificate Integral",
	"doc-xcarb.amount": "Amount",
	"doc-xcarb.endquarter": "End quarter",
	"doc-xcarb.rrpDownloadLink": "RRP link",
	"doc-xcarb.rrpType": "RRP type",
	"document-card.data-not-found": "Document data not found",
	"download-detailed-report": "Download detailed report",
	"download.pdf-files": "Download PDF files",
	"draft.creationdate": "Creation date",
	"draft.deleted.successfully": "Your draft offer has properly been deleted",
	"draft.lastupdate": "Last update",
	"draft.selected.product": "Selected product",
	"draft.total.tons": "Total tons",
	"draft.value": "DRAFT",
	"draftoffer.list": "draft list",
	"draftorder.list": "draft list",
	"drafts.all.drafts": "All drafts",
	"drafts.has.been.deleted": "The draft has been deleted",
	"drafts.my.drafts": "My drafts",
	"drafts.no.draft": "No draft",
	"drafts.saved": "drafts saved",
	"drafts.search.drafts": "Search drafts",
	"drafts.sort.by.modification": "Sort by modification",
	"drafts.sort.by.reference": "Sort by reference",
	"drag.and.drop.files": "Drag and drop",
	"ecall-comment-grid": "Comment",
	"ecall-off-batch-cancellation-date": "Cancelled Date",
	"ecall-off-call-creater": "eCall-off creator",
	"ecall-off-card-gross-quantity": "Gross Quantity",
	"ecall-off-card-net-quantity": "Net Quantity",
	"ecall-off-creation-date": "Creation date",
	"ecall-off-information-box": "eCall-off information",
	"ecall-off.all-batches": "All batches",
	"ecall-off.apply-for-all": "Apply for all",
	"ecall-off.batch": "batch",
	"ecall-off.batches": "batches",
	"ecall-off.call-off": "eCall-off",
	"ecall-off.call-off-by-batch": "eCall-off by batch",
	"ecall-off.call-off-by-volume": "eCall-off by volume",
	"ecall-off.call-off-date": "eCall-off date",
	"ecall-off.call-off-follow-up": "eCall-off follow-up",
	"ecall-off.call-off-header-information": "eCall-off header information",
	"ecall-off.call-off-request": "eCall-off request",
	"ecall-off.callable-weight": "Total material available (To)",
	"ecall-off.called-batches": "Called batches",
	"ecall-off.called-order-items": "Called order items",
	"ecall-off.called-volume": "Called volume (To)",
	"ecall-off.canceled": "Cancelled date",
	"ecall-off.change-mills": "Change mills",
	"ecall-off.choose-batches": "Choose the batches you want to eCall-off",
	"ecall-off.choose-order-items": "Choose the order items you want to eCall-off",
	"ecall-off.closed-or-called": "Called",
	"ecall-off.comment_instruction": "Please fill in this field only if the eCall-off does not follow the standard process. Kindly, do not include messages such as “urgent”, “asap”, “thanks”, or similar. This field is intended only for exceptions to the normal flow.",
	"ecall-off.comment_placeholder": "This field should only be filled in if the eCall-off deviates from the standard flow and the information provided is new and not yet recorded elsewhere.",
	"ecall-off.copy-to": "Copy to",
	"ecall-off.customer-call-off-reference": "Customer eCall-off reference",
	"ecall-off.do-you-really-want-to-change-mills": "Do you really want to change mills",
	"ecall-off.ecall-card": "Ecall-off card",
	"ecall-off.exception": "Exception remark",
	"ecall-off.followup": "You will be able to view it in your My eCall-offs.",
	"ecall-off.information-entry": "eCall-off information entry",
	"ecall-off.last-call-off-demand": "Last eCall-off demand",
	"ecall-off.material-picking": "Material picking",
	"ecall-off.max": "Max {{value}}",
	"ecall-off.mill-section": "Mill selection",
	"ecall-off.my-ecalls": "My eCall-offs",
	"ecall-off.no-batches-found": "No batches found",
	"ecall-off.no-mills": "There are no mills with callable batches",
	"ecall-off.no-selected-batches": "no selected batches",
	"ecall-off.open-or-callable": "Callable",
	"ecall-off.order-items": "order items",
	"ecall-off.personnalize-your-call-off-informations": "Personalize your eCall-off information",
	"ecall-off.rdd-mode": "RDDC mode",
	"ecall-off.ready-to-call": "Your {{objects}} ready to call",
	"ecall-off.requested-date": "Requested date",
	"ecall-off.requested-date-weekend-warning": "The selected requested delivery date falls on a weekend",
	"ecall-off.requested-ship-to": "Requested Ship To",
	"ecall-off.required": "required",
	"ecall-off.see-card": "See card",
	"ecall-off.select-a-mill": "Select one mill to see your material ready-to-ship",
	"ecall-off.select-your-mill": "Select your Mill",
	"ecall-off.selected": "{{value}} selected",
	"ecall-off.selected-batches": "{{value}} selected batches",
	"ecall-off.selected-batches-only": "Selected batches only",
	"ecall-off.selected-only": "Selected only",
	"ecall-off.selection-will-be-rest": "The selection will be reset",
	"ecall-off.separate-email-addresses": "Please separate email addresses by <<;>> (semicolon)",
	"ecall-off.ship-to": "Ship To",
	"ecall-off.start-a-new-call-off": "START A NEW ECALL-OFF",
	"ecall-off.submit-call-off": "Submit your eCall-off request",
	"ecall-off.submitted.successfully": "Your eCall-off {{value}} has been submitted successfully.",
	"ecall-off.summary": "eCall-off summary",
	"ecall-off.supplier-call-off-reference": "Supplier eCall-off reference",
	"ecall-off.the": "The",
	"ecall-off.tons": "Tons",
	"ecall-off.total-called-weight": "Total called weight",
	"ecall-off.total-material-request": "Total material request",
	"ecall-off.type-your-comment": "Type your comment",
	"ecall-off.type-your-exception": "Type your exception remark",
	"ecall-off.unloading-reference": "Unloading reference",
	"ecall-off.view-batch-card": "View batch card",
	"ecall-off.your-batches-ready-to-call": "Your batches ready to call",
	"ecall-requested-deliverydate-from-grid": "Requested date from",
	"ecall-requested-deliverydate-to-grid": "Requested date to",
	"ecall-total-volume-called": "Total volume called",
	"ecall.batch.callCreator": "eCall-off creator",
	"ecall.exct-date-error": "You cannot choose exact date for the selected batches",
	"ecall.row.creation.date": "eCall-off creation date",
	"ecall.searchfield.extendable": "Quick search...",
	"edit.draft": "Edit drafts",
	"efeasibility-disclaimer": "While care has been taken regarding the available information about quality or usability of our materials, it only serves as a description. All notices, advices, recommendations, calculations and, more generally, any information you have access from Steel User are given for your guidance, within the framework of a best effort undertaking, and on the basis of our experience and the state of our last knowledge. However, any industrial application/order/implementation based on such content shall have to be validated by your usual contact at ArcelorMittal Group.",
	"efeasibility-disclaimer.end": "ArcelorMittal Group accepts no responsibility or liability for any errors or information which is found to be misleading.  The use of the information contained herein is at the user’s risk and no warranty is implied or expressed by ArcelorMittal Group with respect to the use of the information.\n",
	"efeasibility.excel.file.name": "Feasibility",
	"efeasibility.excel.template": "Get excel template",
	"efeasibility.template.error": "Please upload a file which follows the template provided by SteelUser application",
	"efeasibility.template.product.category.validation": "Product category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.product.sub.category.validation": "Product sub category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.soldtoname.validation": "Customer name is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.standard.steelgrade.validation": "Standard steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.steelgrade.validation": "Steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"elink.add.attachment": "Add attachment",
	"elink.category": "Category",
	"elink.comment": "Comment*",
	"elink.comment-is-required": "Comment is required",
	"elink.contact-mill": "Contact mill",
	"elink.copy-to": "Copy to",
	"elink.data-automatically-sent-with-the-mail": "Data automatically sent with the mail",
	"elink.delete": "Delete",
	"elink.dimension": "Dimensions (mm)",
	"elink.from": "From",
	"elink.invalid-email-format": "Invalid format of e-mail address",
	"elink.message": "Message",
	"elink.send": "Send",
	"elink.subject": "Subject",
	"email-message": "Email has been sent to confirm your new mail address",
	"end.date": "End date",
	"eoffer-From.month": "From month",
	"eoffer-Period.label": "Period",
	"eoffer-Period.type": "Period type",
	"eoffer-Period.type.custom": "For a custom interval",
	"eoffer-Period.type.month": "For a month interval",
	"eoffer-Period.type.quarter": "For a quarter interval",
	"eoffer-Period.type.semester": "For a semester interval",
	"eoffer-Period.type.year": "For a year interval",
	"eoffer-Quarter": "Quarter",
	"eoffer-Semester": "Semester",
	"eoffer-To.month": "To month",
	"eoffer-selected.period": "Selected period",
	"eoffer.Choose.the.split.of.quantities.by": "Choose the split of quantities by",
	"eoffer.accepted": "Accepted",
	"eoffer.action.default": "Default",
	"eoffer.action.delete": "Delete",
	"eoffer.action.duplicate": "Duplicate",
	"eoffer.action.new": "New",
	"eoffer.action.new.request": "Request",
	"eoffer.action.new.request.for-a-new": "for a new offer",
	"eoffer.additional.fields": "Additional characteristics",
	"eoffer.assistant": "Commercial contact (assistant)",
	"eoffer.available.fields": "Available characteristics",
	"eoffer.cancel": "Cancel",
	"eoffer.cart.finalise": "Finalise your cart",
	"eoffer.cart.input.request": "Input requested quantity, delivery date and other information",
	"eoffer.cart.volume.request": "Requested volume",
	"eoffer.choose.split.quantities.error": "Please choose the split of quantities.",
	"eoffer.choose.split.quantity.error": "Please Choose the split of quantities.",
	"eoffer.cockpit": "eOffer cockpit",
	"eoffer.comment": "Comment",
	"eoffer.comment.product.is": "Leave a comment for this product",
	"eoffer.confirm.thanks": "Thank you, we have received your request.",
	"eoffer.continue": "Continue",
	"eoffer.continue.draft": "Continue this draft",
	"eoffer.create.enduser": "End user",
	"eoffer.currency": "Currency",
	"eoffer.current.step": "Current step",
	"eoffer.customer": "Customer",
	"eoffer.datacenter.offerLines": "Data center: Offer lines",
	"eoffer.delivery.date": "Interpretation delivery date",
	"eoffer.dialog.clear.products": "If you change the Customer or Delivery address or End user, the products in the cart will be lost. Do you want to continue?",
	"eoffer.dialog.month": "Month",
	"eoffer.dialog.monthweek": "Month or week ",
	"eoffer.dialog.offer.remove.product": "Remove selected product, do you want to continue ?",
	"eoffer.dialog.offer.submission.error": "Error when submitting offer",
	"eoffer.dialog.pdm": "Prefered delivery mill",
	"eoffer.dialog.period": "Choose your period",
	"eoffer.dialog.quantity": "Quantity",
	"eoffer.dialog.requested.delivery.time": "Select your requested delivery time",
	"eoffer.dialog.reset.requested.delivery.time": "Modify the period and reset requested delivery times, do you want to continue ?",
	"eoffer.dialog.week": "Week",
	"eoffer.dialog.year": "Year",
	"eoffer.dimension.mm": "Dimensions (mm)",
	"eoffer.draft": "Draft",
	"eoffer.draft.edit.message.line": "to submit it to ArcelorMittal or delete it.",
	"eoffer.draft.edit.message.text": "You can edit it later in",
	"eoffer.draft.list.link": "your draft list",
	"eoffer.draft.saved.successfully": "Your offer request has been properly saved as draft.",
	"eoffer.drafts": "Drafts",
	"eoffer.enduser": "End-user",
	"eoffer.entry": "Offer entry",
	"eoffer.error.loading": "Unable to load parameter values",
	"eoffer.error.noenduser": "Sold-to {{value}} without end-user",
	"eoffer.error.noshipto": "Sold-to {{value}} without ship-to",
	"eoffer.error.noshiptoenduser": "Sold-to {{value}} without ship-to and end-user",
	"eoffer.error.nosoldto": "Sold-to not found",
	"eoffer.feasibility": "Feasibility",
	"eoffer.feasibility.no": "Refused",
	"eoffer.feasibility.pending": "Feasibility request in progress",
	"eoffer.feasibility.yes": "OK",
	"eoffer.field": "Characteristic",
	"eoffer.form": "Form",
	"eoffer.header.commercial.contacts": "COMMERCIAL CONTACTS",
	"eoffer.header.commitment.period": "Commitment period :",
	"eoffer.header.custOffNumber": "Customer offer number",
	"eoffer.header.customer": "Customer",
	"eoffer.header.entity.information": "Entities information",
	"eoffer.header.last.update.date": "Last update date",
	"eoffer.header.offer.name": "Offer name",
	"eoffer.header.offer.validity.date": "Offer validity date :",
	"eoffer.header.suppOffNumber": "Supplier offer number",
	"eoffer.header.technical.contacts": "TECHNICAL CONTACTS",
	"eoffer.header.terms.information": "Terms information",
	"eoffer.header.total": "Total",
	"eoffer.home": "eOffer",
	"eoffer.home.active": "Offers",
	"eoffer.home.cockpit": "My eOffer cockpit",
	"eoffer.home.request": "New",
	"eoffer.home.tool": "Request an offer",
	"eoffer.idd.not.found": "IDD parameters not found",
	"eoffer.in.calculation": "In calculation",
	"eoffer.incot.not.found": "Incoterm parameters not found",
	"eoffer.incoterms": "Incoterms",
	"eoffer.interpretation.delivery.date": "Interpretation delivery date",
	"eoffer.mandatory.currency.reference": "Currency is mandatory",
	"eoffer.mandatory.delivery.address": "Delivery address is mandatory",
	"eoffer.mandatory.enduser.reference": "End-user is mandatory",
	"eoffer.mandatory.idd.reference": "IDD is mandatory",
	"eoffer.mandatory.incot.reference": "Incoterm is mandatory",
	"eoffer.mandatory.priceUnit.reference": "Pricing unit is mandatory",
	"eoffer.mandatory.quantity": "Quantity is mandatory",
	"eoffer.mandatory.requestedDeliveryTime": "RDT is mandatory",
	"eoffer.mandatory.rfq.reference": "RFQ reference is mandatory",
	"eoffer.mandatory.soldTo.reference": "Sold-to is mandatory",
	"eoffer.mandatory.tmode.reference": "Transport mode is mandatory",
	"eoffer.merge.warning": "Some items have been merged. They have been detected as identical products.",
	"eoffer.message.offer.not.saved": "Unable to save offer",
	"eoffer.message.offer.not.submit": "Unable to submit offer",
	"eoffer.message.offer.saved": "Offer saved",
	"eoffer.mill": "Mill",
	"eoffer.mill.supplier.choice": "At supplier’s choice",
	"eoffer.minimum.quantity": "Minimum 1 quantity is required",
	"eoffer.next": "Next",
	"eoffer.offer": "Offer",
	"eoffer.offer.and.order": "Offer overview",
	"eoffer.offer.card": "Offer Card",
	"eoffer.offer.dashboard.not.retrived": "Unable to retrieve offer dashboard data",
	"eoffer.offer.plural": "Offers",
	"eoffer.offer.request": "Offers request",
	"eoffer.offer.terms": "Select your offer request terms",
	"eoffer.offerLine": "Offer line",
	"eoffer.offerLine.plural": "Offer lines",
	"eoffer.offers.draft": "Offers - Drafts",
	"eoffer.paymentTerms": "Payment conditions",
	"eoffer.pc.label.weightDiameterMax": "Max",
	"eoffer.pc.label.weightDiameterMin": "Min",
	"eoffer.pc.label.weightDiameterUnit": "Unit",
	"eoffer.period": "Period",
	"eoffer.period.end": "Period (end)",
	"eoffer.period.in.month.value": "{{value}} month",
	"eoffer.period.month": "Period (in month)",
	"eoffer.period.orderBook": "Period for historical order book",
	"eoffer.period.quarter.initial.letter": "Q",
	"eoffer.period.selection.needed": "Selection Needed",
	"eoffer.period.semester.initial.letter": "H",
	"eoffer.period.start": "Period (start)",
	"eoffer.prefered.delivery.mill": "Prefered delivery mill",
	"eoffer.previous": "Previous",
	"eoffer.price": "Price",
	"eoffer.pricing.unit": "Pricing unit",
	"eoffer.product": "Product",
	"eoffer.product.card": "View product details",
	"eoffer.product.family": "Product family",
	"eoffer.product.family.infos.text": "Please select a Customer, a Delivery address and a end user to access to products list",
	"eoffer.product.family.plural": "Product families",
	"eoffer.product.load.content": "Unable to load product content",
	"eoffer.product.not.found": "Product description not available",
	"eoffer.product.plural": "Products",
	"eoffer.quantity": "Quantity",
	"eoffer.quantity.error": "Please enter a valid quantity.",
	"eoffer.quantity.ton": "Quantity (tons)",
	"eoffer.quit.with.save": "Save & quit",
	"eoffer.quit.without.save": "Quit without saving",
	"eoffer.referenceAm": "Reference AM",
	"eoffer.refresh": "Refresh",
	"eoffer.remove.product": "Continue and remove selected product",
	"eoffer.request.new.offer": "Request a new offer",
	"eoffer.request.new.offer.from.draft": "Request a new offer from this one",
	"eoffer.requested": "Requested",
	"eoffer.requested.delivery.time": "Requested delivery time",
	"eoffer.reset.requested.delivery.time": "Continue and reset delivery times",
	"eoffer.review.selections.and.submit": "Review your selections and submit",
	"eoffer.rfq.id": "Your unique RFQ ID is",
	"eoffer.rfq.reference": "Your RFQ reference",
	"eoffer.save": "Save",
	"eoffer.save.offer.draft": "Save offer request as draft",
	"eoffer.save.offer.question": "Quit wizard without saving offer, do you want to continue ?",
	"eoffer.searchfield.extendable": "Quick search",
	"eoffer.select.period.info": "Click below to select a period from 1 month up to 1 calendar year",
	"eoffer.select.price": "Select price commitment period for this offer",
	"eoffer.selector": "Selector",
	"eoffer.set.entities": "Set entities for this offer",
	"eoffer.shipto": "Delivery address",
	"eoffer.simulation.shipto.enduser.error": "Error due to force other [shipto/enduser] after simulation.",
	"eoffer.soldto": "Customer",
	"eoffer.status": "Status",
	"eoffer.status.accepted": "Accepted",
	"eoffer.status.accepted.plural": "Accepted",
	"eoffer.status.canceled": "Canceled",
	"eoffer.status.canceled.plural": "Canceled",
	"eoffer.status.draft": "Draft",
	"eoffer.status.draft.plural": "Drafts",
	"eoffer.status.offered": "Offered",
	"eoffer.status.offered.plural": "Offered",
	"eoffer.status.rejected": "Rejected",
	"eoffer.status.requested": "Requested",
	"eoffer.status.requested.plural": "Requested",
	"eoffer.steelGrade": "Grade",
	"eoffer.subcategory": "Subcategory",
	"eoffer.submission.feedback": "You can track the status of your RFQ via your offer request dashboard",
	"eoffer.submit": "Submit",
	"eoffer.supplier.offer.number": "Supplier Offer Number",
	"eoffer.table.customer": "Customer",
	"eoffer.table.enduser": "End user",
	"eoffer.table.header.colTopSide": "Colour top side",
	"eoffer.table.header.custMatRef": "Customer article reference",
	"eoffer.table.header.custOffRef": "Customer offer number",
	"eoffer.table.header.delivery.mill": "Prefered delivery mill",
	"eoffer.table.header.dim": "Dim (mm)",
	"eoffer.table.header.dimension": "Dimension (mm)",
	"eoffer.table.header.dimensions": "Dimensions",
	"eoffer.table.header.feasibility": "Feasibility",
	"eoffer.table.header.last.update": "Last update date",
	"eoffer.table.header.orderCount": "Items",
	"eoffer.table.header.period": "Period",
	"eoffer.table.header.price": "Price",
	"eoffer.table.header.qttOrdered": "Quantity",
	"eoffer.table.header.quantity": "Quantity (tons)",
	"eoffer.table.header.rfqRef": "RFQ reference",
	"eoffer.table.header.standsteelGrade": "Standard steel grade",
	"eoffer.table.header.status": "Status",
	"eoffer.table.header.steelGrade": "Grade",
	"eoffer.table.item.number": "Item number",
	"eoffer.table.morw": "Month or week",
	"eoffer.table.price.unit": "Price (unit)",
	"eoffer.table.price.value": "Price (value)",
	"eoffer.table.quantity.unit": "Quantity (unit)",
	"eoffer.table.quantity.value": "Quantity (value)",
	"eoffer.table.shipto": "Ship to",
	"eoffer.title.my.offers": "My offers",
	"eoffer.title.productlist.filter": "Choose the product you want to request on",
	"eoffer.title.section.coilWeightInPercent": "Coil weight in %",
	"eoffer.title.section.dimensionUnit": "Dimension unit",
	"eoffer.title.section.length": "Length",
	"eoffer.title.section.organicCoating": "Organic coating",
	"eoffer.tonnes": "Tonnes",
	"eoffer.total.quantity.for.period.draft": "Total quantity for the period",
	"eoffer.track.status": "You can track the status of your RFQ via your",
	"eoffer.transport.mode": "Transport Mode",
	"eoffer.validityDate": "Validity",
	"eoffer.weightAndInvoicing": "Weight and invoices",
	"eoffer.wizard.cart": "Cart",
	"eoffer.wizard.delivery.address": "Delivery address",
	"eoffer.wizard.end": "Review-submit",
	"eoffer.wizard.error.products.families": "Products families not found",
	"eoffer.wizard.header.entity.information": "Entities information",
	"eoffer.wizard.header.terms.information": "Terms information",
	"eoffer.wizard.parameters.error": "Unable to load offer parameters",
	"eoffer.wizard.period.error": "Date has been reset",
	"eoffer.wizard.period.selection.error": "Please select a date in the future and valid for the selected period",
	"eoffer.wizard.request": "Request offer",
	"eoffer.wizard.specs": "Product specifications",
	"eoffer.wizard.step.status": "Step {{step}} of 4",
	"eoffer.wizard.submit": "Submit your offer request",
	"eoffer.wizard.table.header.quantity": "Quantity (t)",
	"eoffer.wizard.terms": "Offer terms",
	"eorder.action.next": "Next",
	"eorder.action.save.draft": "Save order as draft",
	"eorder.add.item.confirm.action": "Do you want to confirm this action?",
	"eorder.add.item.confirm.change": "Do you want to confirm this change?",
	"eorder.add.item.different.family.warning": "Selected item(s) is(are) not of the same family as the one(s) in cart. We will clear the cart before adding the new requested one(s).",
	"eorder.add.item.different.form.warning": "Selected item(s) is(are) not of the same form as the one(s) in cart. We will clear the cart before adding the new requested one(s).",
	"eorder.add.item.empty.customer.warning": "Customer field is empty. Not possible to add any item to the cart.",
	"eorder.add.item.limit.exeeds.warning": "By adding [X] item(s) to the cart, the order will be too big for the current process (>100 items). Please reduce cart content or number of item(s) to be added and try again.",
	"eorder.add.item.success": "[X] item(s) properly added to cart",
	"eorder.confirm.message": "Confirm",
	"eorder.create.order.title": "Order information",
	"eorder.customer.change.warning": "Changing the Customer field will clear the current cart. A given order cannot mix items from different customers.",
	"eorder.draft.deleted.successfully": "Your draft order has properly been deleted",
	"eorder.draft.edit.message.text": "You will be able to edit it in",
	"eorder.draft.last.update.date": "Last update date",
	"eorder.draft.list.link": "your draft list.",
	"eorder.draft.norequest": "No draft request",
	"eorder.draft.order-card.edit": "Edit this draft",
	"eorder.draft.order-card.no-item.text": "No draft item",
	"eorder.draft.order-card.placed.text": "Draft items list -",
	"eorder.draft.order-card.title": "Draft order details",
	"eorder.draft.product.family": "Family",
	"eorder.draft.product.number": "Nb of Product(s)",
	"eorder.draft.requested.quantity": "Requested quantity",
	"eorder.draft.saved.successfully": "Your draft has been saved.",
	"eorder.fixed-columns": "Fixed columns",
	"eorder.grid.header.view.label": "View",
	"eorder.line.select.family.product": "To add an item into cart, choose the number of copy of a product, and click on the corresponding button Add to cart",
	"eorder.mandatory.currency": "Currency is mandatory",
	"eorder.mandatory.end.user": "End-user is mandatory",
	"eorder.mandatory.idd": "Interpretation delivery date is mandatory",
	"eorder.mandatory.pricingUnit": "Pricing unit is mandatory",
	"eorder.mandatory.shipTo.reference": "Ship-to is mandatory",
	"eorder.message.order.not.saved": "Unable to save order",
	"eorder.no.product.family": "No products found for the selected customer",
	"eorder.order": "Order request",
	"eorder.order.creation": "Order creation",
	"eorder.orders.request": "Orders request",
	"eorder.product.color.bottom": "Colour (Bottom)",
	"eorder.product.colour.top": "Colour (Top)",
	"eorder.product.custmaterialnum": "Customer Material Number",
	"eorder.product.data.commercial.steelgrade.id": "commercialSteelGradeID",
	"eorder.product.data.customer.article": "customerArticle",
	"eorder.product.dimension": "Dimensions",
	"eorder.product.empty.row": "No active product linked to this template",
	"eorder.product.family.infos.title": "Please select the proper customer for this order request, to start to show available product list. All items in the cart should be related to the same customer.",
	"eorder.product.fc.products.label": "Fully configured products",
	"eorder.product.grid.note.fc": "[Y] product(s).",
	"eorder.product.grid.note.nfc": "[X] template(s) and [Y] product(s). A template is an item with empty variables to let you create a new product",
	"eorder.product.lastused": "Last used",
	"eorder.product.lastused.default": "Never",
	"eorder.product.metalliccoating": "Metallic Coating",
	"eorder.product.organiccoating.datasheet.top": "Organic Coating Data Sheet (Top)",
	"eorder.product.organicdatasheet.bottom": "Organic Coating Data Sheet (Bottom)",
	"eorder.product.removablefilm": "Removable Protective Film",
	"eorder.product.steelgrade": "Steel Grade",
	"eorder.product.surfaceaspect": "Surface Aspect",
	"eorder.product.template.add.to.cart": "Add as empty product to cart",
	"eorder.product.type.fc": "Catalog product",
	"eorder.product.type.fm": "To be configured (with default values)",
	"eorder.product.type.nfc": "To be configured",
	"eorder.product.variables": "variables(s)",
	"eorder.product.variables.title": "Variables on this template:",
	"eorder.save.draft.confirmation": "Do you want to save [X] as a draft?",
	"eorder.save.draft.error.message": "Sorry, an error occured during saving process of your order draft. Please try later or send a message to your AM contact.",
	"eorder.save.draft.success.message": "A draft for your order request has been saved properly.",
	"eorder.select.product.spec": "Products list",
	"eorder.submit.error.msg.bad.data": "Bad data in the request.",
	"eorder.submit.error.msg.rqd.data.missing": "Mandatory data are missing",
	"eorder.submit.order.success.follow.up.link": "ORDER AND DELIVERY FOLLOW-UP.",
	"eorder.submit.order.success.follow.up.text": "You can follow the evolution of its status in your",
	"eorder.submit.order.success.text1": "Your order request",
	"eorder.submit.order.success.text2": "has been processed.",
	"eorder.wizard.header.customer": "Customer is mandatory",
	"eorder.wizard.header.customer-order-number": "Customer order number",
	"eorder.wizard.header.customer-order-number.error.invalid": "Invalid Customer order number",
	"eorder.wizard.header.customer-order-number.error.mandatory": "Customer order number is mandatory",
	"eorder.wizard.header.purchase-order-contract.error.invalid": "Invalid Contract number",
	"eorder.wizard.header.purchase-order-contract.error.mandatory": "Purchase order contract is mandatory",
	"eorder.wizard.order.currency": "Currency",
	"eorder.wizard.order.enduser": "End-user",
	"eorder.wizard.order.idd": "Interpretation delivery date",
	"eorder.wizard.order.pricingUnit": "Pricing unit",
	"eorder.wizard.order.purchase.contract": "Order purchase contract",
	"eorder.wizard.order.shipto.name": "Delivery address",
	"eorder.wizard.order.soldto.name": "Customer",
	"eorder.wizard.parameters.error": "Unable to load eOrder parameters",
	"eorder.wizard.product.action.delete": "Delete",
	"eorder.wizard.product.action.duplicate": "Duplicate",
	"eorder.wizard.product.card.error": "⚠ This item is no more valid or has issues to be loaded",
	"eorder.wizard.product.itemnumber": "Item Number",
	"eorder.wizard.product.modification.no.products": "No product.",
	"eorder.wizard.product.modification.order.title": "Order",
	"eorder.wizard.product.modification.title.cart": "Your cart",
	"eorder.wizard.product.modification.title.item": "item",
	"eorder.wizard.product.modification.title.items": "item(s)",
	"eorder.wizard.product.quantity": "Quantity (t)",
	"eorder.wizard.product.rdd": "RDD",
	"eorder.wizard.product.rdd.error": "Date in the past",
	"eorder.wizard.product.rdd.type": "RDD type",
	"eorder.wizard.product.service.level": "Service level",
	"eorder.wizard.product.steelgrade": "Steel grade",
	"eorder.wizard.product.thickness": "Thickness",
	"eorder.wizard.product.width": "Width",
	"eorder.wizard.quantity.error": "Please enter a valid quantity greater than or equal to 1.",
	"eorder.wizard.stepper.step.order.information": "Order information & product selection",
	"eorder.wizard.stepper.step.product.modification": "Product modification",
	"eorder.wizard.stepper.step.summary": "Order summary",
	"eorder.wizard.summary.header.contract.po": "Contract (PO)",
	"eorder.wizard.summary.header.currency.po": "Invoicing currency",
	"eorder.wizard.summary.header.order.title": "Order information",
	"eorder.wizard.summary.order.placed.text": "Order placed - ",
	"eorder.wizard.summary.terms.conditions.text": "By clicking on proceed to order you accept the terms and conditions of web order entry",
	"eorder.wizard.summary.total.quantity": "Total quantity (t)",
	"epassivefilm.P": "E-Passivation®",
	"epassivefilm.S": "Easyfilm®",
	"error.cancelling.issue": "Error while cancelling issue",
	"error.choose.pdf.manager": "Please install a pdf manager on your phone",
	"error.deleting.draft": "Error while deleting draft",
	"error.file.download": "An error occured during the download",
	"error.file.not.found": "This file doesn't exist",
	"error.inavlid.transport.cost": "Invalid Transport Cost",
	"error.place.atleast.one.bid": "Place atleast one bid before saving",
	"exception-report.amlno": "AMLNo",
	"exception-report.comment-by-am": "Historical exception report Arcelormittal comment",
	"exception-report.comment-by-customer": "Historical exception report customer comment",
	"exception-report.delete": "Your exception report demand has been successfully deleted",
	"exception-report.dialog.add-comment.title": "Add a comment to finalize your exception report on order",
	"exception-report.dialog.current-status.title": "The current status of your request on order",
	"exception-report.dialog.processing": "Processing",
	"exception-report.docNo": "DocumentNo",
	"exception-report.edit-request": "Edit comment",
	"exception-report.last.comment-by-am": "Exception report Arcelormittal last comment",
	"exception-report.last.comment-by-customer": "Exception report customer last comment",
	"exception-report.make-new-request": "Request exception report",
	"exception-report.order-card-header": "Special request",
	"exception-report.save": "Your exception report demand has been sent. You can follow your weekly request in the ORDER LIST",
	"exception-report.status": "Comment Status",
	"exception-report.yearweek": "YearWeek",
	"fabrication.process.H": "Tubing + HF",
	"fabrication.process.L": "Tubing + Laser",
	"fabrication.process.R": "Roll Forming",
	"fabrication.process.S": "Stamping",
	"fast.lane.entry": "Fast Lane",
	"fastlane.attachments": "Attachments",
	"fastlane.create.details.field.currency": "Choose your currency",
	"fastlane.delivery.address": "Delivery address is mandatory!",
	"fastlane.delivery.infos.title": "Please choose the delivery address for your items in the predefined list or customize one. In case of custom destination, you will have to provide some details.",
	"fastlane.error.nosoldto": "Sold-to not found",
	"fastlane.file.import.button": "Import",
	"fastlane.file.import.note": "Prefill all items by using a file",
	"fastlane.file.import.progressMessage": "Import in progress.",
	"fastlane.file.import.result.label": "Result",
	"fastlane.file.import.result.text": "Please upload a file",
	"fastlane.file.import.validate": "Validate",
	"fastlane.file.template.download.note": "Use proper format for file by downloading the template by clicking here",
	"fastlane.header.customer-request-name.error.mandatory": "Request name is mandatory!",
	"fastlane.header.wizard.customer-request-name": "Request name",
	"fastlane.import.popup.text.1": "Upload an XLS file to prefill in one run all your items. Please follow the template in order to allow automatic detection.",
	"fastlane.import.popup.text.2": "If some fields are too long for text fields, they will be cut (ex: Name for an item: limit = 80 chars)",
	"fastlane.import.popup.text.3": "If some fields require a list of values and the file contains a non existing value, it will be ignored.",
	"fastlane.import.popup.text.4": "A given item must have all mandatory fields provided",
	"fastlane.import.popup.text.5": "The list of all defects will be provided at the end of the process to let you validate or retry.",
	"fastlane.import.popup.title": "Prefill all items",
	"fastlane.info.commercial.data": "Commercial data",
	"fastlane.info.request.details": "Request details",
	"fastlane.itemlist.coil.inner.diameter": "Inner diameter",
	"fastlane.itemlist.coil.inner.diameter.508mm": "508 mm",
	"fastlane.itemlist.coil.inner.diameter.610mm": "610 mm",
	"fastlane.itemlist.coil.inner.diameter.NA": "N/A",
	"fastlane.itemlist.coil.inner.diameter.default": "Vertical",
	"fastlane.itemlist.coil.max_outer_diameter": "Max outer diameter",
	"fastlane.itemlist.global.quantity": "Quantity",
	"fastlane.itemlist.global.quantity.error": "Quantity is mandatory!",
	"fastlane.itemlist.global.select_unit.error": "Please select a unit",
	"fastlane.itemlist.global.unit": "Unit",
	"fastlane.itemlist.global.unit.error": "Unit is mandatory!",
	"fastlane.itemlist.item.additional.info": "Additional item information",
	"fastlane.itemlist.navig.duplicate": "Duplicate",
	"fastlane.itemlist.navig.reset": "Reset",
	"fastlane.itemlist.order.thickness": "Thickness",
	"fastlane.itemlist.product.blankWeight.error.invalid": "BlankWeight should be greater than 0",
	"fastlane.itemlist.product.blank_weight": "Blank weight",
	"fastlane.itemlist.product.blank_weight.error": "The weight of one unit is mandatory!",
	"fastlane.itemlist.product.coating.error.invalid": "Coating should be greater than 0",
	"fastlane.itemlist.product.coating.mandatory": "Coating is mandatory!",
	"fastlane.itemlist.product.coil_axis": "Coil axis",
	"fastlane.itemlist.product.coil_axis.default": "-- None --",
	"fastlane.itemlist.product.coil_axis.horizontal": "Horizontal",
	"fastlane.itemlist.product.coil_axis.vertical": "Vertical",
	"fastlane.itemlist.product.form_blank": "Form Blank",
	"fastlane.itemlist.product.item_form": "Form",
	"fastlane.itemlist.product.item_form.error": "Form is mandatory!",
	"fastlane.itemlist.product.item_name": "Name",
	"fastlane.itemlist.product.item_name.error": "Name for the item is mandatory!",
	"fastlane.itemlist.product.item_number": "Item number",
	"fastlane.itemlist.product.length.error": "Length is mandatory!",
	"fastlane.itemlist.product.length.error.invalid": "Length should be greater than 0",
	"fastlane.itemlist.product.maxOuterDiameter.error.invalid": "MaxOuterDiameter should be greater than 0",
	"fastlane.itemlist.product.quantity.error.invalid": "Quantity should be greater than 0",
	"fastlane.itemlist.product.select_form.error": "Please select a form",
	"fastlane.itemlist.product.slitting_coil": "Slitting Coil",
	"fastlane.itemlist.product.steel_grade": "Steel grade",
	"fastlane.itemlist.product.steel_grade.error": "Steel grade is mandatory!",
	"fastlane.itemlist.product.thickness.error": "Thickness is mandatory!",
	"fastlane.itemlist.product.thickness.error.invalid": "Thickness should be between 0.1 to 999",
	"fastlane.itemlist.product.width.error": "Width is mandatory!",
	"fastlane.itemlist.product.width.error.invalid": "Width should be greater than 0",
	"fastlane.itemlist.productcharacteristic.oilquantity": "Oiling",
	"fastlane.itemlist.quality.calculator.coil": "Coil",
	"fastlane.itemlist.quality.calculator.sheet": "Sheet",
	"fastlane.itemlist.unit.blanks": "Blanks",
	"fastlane.itemlist.unit.sheets": "Sheets",
	"fastlane.itemlist.unit.tons": "Tons",
	"fastlane.mandatory.delivery.address": "Delivery address is mandatory",
	"fastlane.prototype.dialog.week": "week",
	"fastlane.prototype.not.found": "Not found",
	"fastlane.prototyperequest.request": "Fast Lane request",
	"fastlane.request.title": "Request information",
	"fastlane.soldto.shipto.error": "Sorry, there is an issue in your service settings, please contact SteelUser administrator",
	"fastlane.submit.error.msg": "Something went wrong. Please contact your SteelUser administrator.",
	"fastlane.submit.error.msg.mandatoryfield": "Some mandatory fields are missing.",
	"fastlane.submit.error.msg.nosoldtoshipto": "Something is wrong with your settings for this service",
	"fastlane.submit.error.msg.notoken": "Your session is expired. Please log in the application.",
	"fastlane.submit.request.error.msg.title": "Error during validation of your request",
	"fastlane.template.addinfo.validation": "Additional Information cannot exceed 255 chars ([X] detected)",
	"fastlane.template.blankweight.validation": "Blank Weight is mandatory for Form Blank and must be a valid number greater or equal to 1 with 2 digits (truncated if more). ([X] detected)",
	"fastlane.template.coating.validation": "Coating is mandatory and cannot exceed 50 chars ([X] detected)",
	"fastlane.template.coilaxis.validation": "Coil Axis is mandatory and must be one of the followed values: -- None --, Horizontal, Vertical (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.currency.validation": "Currency is mandatory and must be one of the followed values: EUR, GPB, USD (“[X]” detected). EUR will be set by default",
	"fastlane.template.deliveryaddress.validation": "Delivery address is not mandatory, but if filled in, cannot exceed 150 chars ([X] detected)",
	"fastlane.template.description.validation": "Description is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.detected.items": "[X] items detected in the file",
	"fastlane.template.form.validation": "Form is mandatory and must be one of the followed values: Coil, Sheet, Slitting Coil, Form Blank (“[X]” detected). Coil will be set by default",
	"fastlane.template.format.error": "The file should be a template provided by ArcelorMittal. We are not able to analyse it, it may be a wrong file or a corrupted one. If you have doubt on it, communicate with your AM contact by sending them the file.",
	"fastlane.template.global.data.issue": "Global data with issues",
	"fastlane.template.global.error": "Global error(s) preventing any analysis of the document",
	"fastlane.template.incoterms.validation": "Incoterms is mandatory and must be one of the followed values: -- None --, DAP, CIF, CIP, FCA, DDP (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.innerdiameter.validation": "Inner Diameter is mandatory and must be one of the followed values: N/A, 508 mm, 610 mm (“[X]” detected). “N/A” will be set by default",
	"fastlane.template.item.issue.header": "[X] items with issues",
	"fastlane.template.itemname.validation": "Item Name is mandatory and cannot exceed 80 chars ([X] detected)",
	"fastlane.template.length.validation": "Length is mandatory for Sheet and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.line": "Line",
	"fastlane.template.mill.validation": "Mill is mandatory and must be one of the valid values. (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.oiling.validation": "Oiling cannot exceed 50 chars ([X] detected)",
	"fastlane.template.outerdiameter.validation": "Max Outer Diameter must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.packing.validation": "Packing cannot exceed 50 chars ([X] detected)",
	"fastlane.template.quantity.validation": "Quantity is mandatory and must be a valid positive number with max 2 or 0 digits based on unit selected (truncated if more). ([X] detected)",
	"fastlane.template.rddday.validation": "A Delivery Date has been provided in Day, but not in proper pattern (dd/mm/yyyy, ex: 02/02/2024). (“[X]” detected)",
	"fastlane.template.rddweek.validation": "A Delivery Date has been provided in Week, but not in proper pattern (Www/YYYY, ex: W01/2024). (“[X]” detected)",
	"fastlane.template.rddwnd.validation": "The day provided for Delivery Date should correspond to the week. (“[Y]” is not part of “[X]” Week)",
	"fastlane.template.request": "Request",
	"fastlane.template.requestname.validation": "Request name is mandatory and cannot exceed 120 chars ([X] detected)",
	"fastlane.template.steelgrade.validation": "Steelgrade is mandatory and cannot exceed 255 chars ([X] detected)",
	"fastlane.template.thickness.validation": "Thickness is mandatory and must be a valid positive number with max 2 digits (truncated if more). Should be less than or equal to 999. ([X] detected)",
	"fastlane.template.tmode.validation": "Transport Mode is mandatory and must be one of the followed values: -- None --, Train, Boat, Truck, Plane (“[X]” detected). “-- None --” will be set by default",
	"fastlane.template.unitbasic.validation": "Unit is mandatory and must be one of the followed values: Tons, Sheets, m², Blanks. (“[X]” detected). Default value will be set linked to Form.",
	"fastlane.template.unitform.validation": "“[X]” Quantity value is not valid for “[Y]” Form.",
	"fastlane.template.upload.confirmation.text1": "File properly imported in session.",
	"fastlane.template.upload.confirmation.text2": "Please recheck all items in session before confirming the request.",
	"fastlane.template.upload.warning.text": "You can validate this partial result or try to reupload the file by fixing issues",
	"fastlane.template.valid.items": "[X] items without any issue",
	"fastlane.template.width.validation": "Width is mandatory and must be a valid number greater or equal to 1 with 0 digits (truncated if any). ([X] detected)",
	"fastlane.template.xls.mime.type": "The file must be an Excel file. Please use the proper template provided by SteelUser application.",
	"fastlane.wizard.contact.person.mandatory": "Person of contact is mandatory!",
	"fastlane.wizard.contact.phone.number": "Phone number of this contact",
	"fastlane.wizard.currency": "Currency",
	"fastlane.wizard.custom.destination": "Custom destination",
	"fastlane.wizard.custom.destination.contact.person": "Person of contact at custom destination",
	"fastlane.wizard.decide.later": "-- Decide Later --",
	"fastlane.wizard.delivery.address": "Predefined delivery address",
	"fastlane.wizard.header.customer": "Customer is mandatory",
	"fastlane.wizard.header.customer-request-name": "Request name",
	"fastlane.wizard.header.customer-request-name.error.invalid": "Invalid Request name",
	"fastlane.wizard.header.global.description": "Description",
	"fastlane.wizard.header.no.item.list": "No item in this request",
	"fastlane.wizard.header.request.data": "Request data",
	"fastlane.wizard.items.details.addanitem": "Add an item",
	"fastlane.wizard.items.details.datetype": "Date type",
	"fastlane.wizard.items.details.datetype.errormsg": "Date type is mandatory!",
	"fastlane.wizard.items.details.datetype.rdd": "Requested delivery date",
	"fastlane.wizard.items.details.day": "Day",
	"fastlane.wizard.items.details.itemrequest": "Item requests",
	"fastlane.wizard.items.details.sheet.weight": "Sheet weight (in kg)",
	"fastlane.wizard.items.details.total.weight": "Total weight(in tons)",
	"fastlane.wizard.items.details.week": "Week",
	"fastlane.wizard.parameters.error": "Unable to load fastlane parameters",
	"fastlane.wizard.phone.number.mandatory": "Phone number is mandatory!",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant": "Desired ArcelorMittal plant",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant.errmsg": "Plant is mandatory!",
	"fastlane.wizard.product.transport.mode.errormsg": "Transport mode is mandatory!",
	"fastlane.wizard.shipto.name": "Delivery address",
	"fastlane.wizard.soldto.name": "Customer",
	"fastlane.wizard.stepper.step.items.details": "Items details",
	"fastlane.wizard.stepper.step.main.data": "Main data",
	"fastlane.wizard.stepper.step.transport.details": "Transport details",
	"fastlane.wizard.stepper.step.transport.summary": "Summary",
	"fastlane.wizard.summary.header.currency.po": "Invoicing currency",
	"fastlane.wizard.summary.submitBtn": "Submit your Fast Lane request",
	"fastlane.xlx.template": "XLS Template",
	"favorite-orders.title": "My flagged orders",
	"feasibility-status": "Feasibility",
	"feasibility.product-category": "Product category",
	"feasibiliy-characteristics": "Characteristics",
	"feasible-results": "Feasibility Results",
	"fields.number.error": "Thickness and width should be in number format",
	"filter.abandon": "Abandon",
	"filter.add": "Add",
	"filter.add.dimension": "Dimensions (in mm)",
	"filter.all": "All",
	"filter.apply": "Apply",
	"filter.atConsignment": "At consignment",
	"filter.batchid": "Batch ID",
	"filter.bottom-color": "Bottom color",
	"filter.cancel": "Cancel",
	"filter.cdd": "Confirmed Delivery Date",
	"filter.cddGtRdd": "CDD > RDD",
	"filter.coating": "Coating specification",
	"filter.confirmation.deleteall": "Do you really want to delete all filters ?",
	"filter.contractNumber": "Contract number",
	"filter.criteria.applied": "Applied filter",
	"filter.criteria.no.applied": "No filter applied",
	"filter.customerArticleReference": "Customer article reference",
	"filter.customerOrderNumber": "Customer Order Number",
	"filter.date": "Date...",
	"filter.date.from": "From",
	"filter.date.invalid": "The date must be valid",
	"filter.date.to": "To",
	"filter.deleteall": "Delete all",
	"filter.delivered": "Delivered",
	"filter.deliveryMode": "Delivery Mode",
	"filter.dimension": "Dimensions",
	"filter.dimensions.length": "Length",
	"filter.dimensions.thickness": "Thickness",
	"filter.dimensions.width": "Width",
	"filter.dispatchAdviceNumber": "Dispatch Advice Number",
	"filter.dispatchDate": "Dispatch Date",
	"filter.enddate.inferior": "This date must be superior to the previous",
	"filter.field.invalid": "Invalid value",
	"filter.field.required": "This field is required",
	"filter.filters": "Filters",
	"filter.format.day": "Day format",
	"filter.format.week": "Week format",
	"filter.grossOrdersWithMaterial": "Gross orders with material",
	"filter.inTransit": "In transit",
	"filter.is-not-a-number": "The value must be a number.",
	"filter.is-not-a-positive-number": "The value must be a positive number",
	"filter.length": "Length (m)",
	"filter.less-than": "Equal or less than",
	"filter.mill": "Mill",
	"filter.more-than": "Equal or more than",
	"filter.multiple-values": "Multiple values...",
	"filter.netOrdersWithMaterial": "Net orders with material",
	"filter.no-matching-value": "No matching value",
	"filter.no-value": "No value",
	"filter.no.predefined": "No predefined",
	"filter.number.from": "From",
	"filter.number.to": "To",
	"filter.ok": "Ok",
	"filter.operator.exact": "Exact",
	"filter.operator.range": "Range",
	"filter.order-number.item": "Item",
	"filter.order-number.reference": "Reference",
	"filter.order.item.number": "Item Number",
	"filter.order.reference": "Order Reference",
	"filter.orderWithCddGtRdd": "RDD < CDD",
	"filter.ordersWithMaterial": "Orders with material",
	"filter.placeholder.list": "Select in the list",
	"filter.placeholder.suggestive.list": "Search a value",
	"filter.predefined": "Predefined",
	"filter.readyToShip": "Ready to ship",
	"filter.reset": "Reset",
	"filter.schedule-business-order": "Schedule business order",
	"filter.scheduleBusinessOrdersWithMaterial": "Schedule Business Orders with material",
	"filter.shipment-section-n1": "Shipment section N-1",
	"filter.shipment-section-n2": "Shipment section N-2",
	"filter.spot-order": "Spot order",
	"filter.standardsteelgrade": "Standard Steelgrade",
	"filter.supplierOrderNumber": "Supplier order number",
	"filter.text": "Use ; as separating sign, * as wildcard",
	"filter.thickness": "Thickness (mm)",
	"filter.top-color": "Top color",
	"filter.week.to": "To",
	"filter.width": "Width (mm)",
	"filter.workInProgress": "Work in progress (WIP)",
	"filter.x-filter-applied": "{{value}} applied filter",
	"filter.x-filters-applied": "{{value}} applied filters",
	"filter.x-selected-values": "{{value}} selected values",
	"filter.yes": "Yes",
	"footer.alerts": "Alerts",
	"footer.home": "Home",
	"footer.message": "Message",
	"footer.search": "Search",
	"form.blanks": "Blanks",
	"form.coil": "Coil",
	"form.heavy.plate": "Heavy Plate",
	"form.indif.04": "Slab",
	"form.indif.06": "Coil",
	"form.indif.07": "Sheet",
	"form.indif.08": "Blanks",
	"form.indif.09": "Heavy Plate",
	"form.indif.10": "Thick Plate",
	"form.indif.12": "Slit coil",
	"form.indif.15": "Scrolled sheet",
	"form.indif.16": "Mixed Coil",
	"form.indif.17": "Welded Coil",
	"form.mixed.coil": "Mixed Coil",
	"form.scrolled.sheet": "Scrolled Sheet",
	"form.sheet": "Sheet",
	"form.slab": "Slab",
	"form.slit.coil": "Slit Coil",
	"form.thick.plate": "Thick Plate",
	"form.welded.coil": "Welded Coil",
	"full.product.catalogue": "Full product catalogue",
	"global-subcategory.BL": "Hot rolled black",
	"global-subcategory.CR": "Cold rolled",
	"global-subcategory.MS": "Metal studs",
	"global-subcategory.PI": "Hot rolled pickled and oiled",
	"global-subcategory.Z": "Hot dip galvanized",
	"global.action.cancelled": "Action cancelled",
	"global.business-type": "Business Type",
	"global.cancelled": "Cancelled",
	"global.clickhere": "Click here",
	"global.closed": "Closed",
	"global.copyto": "Copy to",
	"global.error": "An error occured while trying to get your list of products",
	"global.error.unexpected": "Unexpected error",
	"global.internal.server.error": "Internal Server Error",
	"global.internal.soldto.error": "Setting error on your account, you cannot do this order request (customer). Please connect with your AM contact.",
	"global.message": "Message",
	"global.message-error": "Message is mandatory!",
	"global.next": "Next",
	"global.no": "No",
	"global.none": "None",
	"global.open": "Open",
	"global.or": "OR",
	"global.search-filter": "Global Search",
	"global.search.fastlane-entry": "FastLane",
	"global.search.fastlane-requests": "FastLane requests",
	"global.send": "Send",
	"global.servicelevel": "Service Level",
	"global.subject": "Subject",
	"global.subject-error-msg": "Subject is mandatory!",
	"global.submit.error.unexpected": "An unexpected error occured during the submit process, please try later or connect with your AM contact.",
	"global.submit.service.error": "Your account has not the proper permissions to submit an order request. Please connect with your AM contact.",
	"global.unexpected.error.identified": "unexpected error identified",
	"global.warning": "Warning",
	"global.yes": "Yes",
	"guaranatee.aluminium.parts": "Aluminium for parts",
	"guarantee.Others": "Others",
	"guarantee.Poultry": "Poultry",
	"guarantee.acoustic": "Acoustic barriers",
	"guarantee.acoustic.concrete": "Is there a concrete base, which is in separating the Magnelis® coated elements from the ground?",
	"guarantee.acoustic.railroad": "Acoustic barriers for a railroad",
	"guarantee.acoustic.road.traffic": "Road Traffic Sound Reducing Device / acoustic barriers for roads",
	"guarantee.activity.building": "Activity inside the building",
	"guarantee.activity.specify": "Please specify the activity",
	"guarantee.add.parts": "Add parts",
	"guarantee.additional.comments": "Additional information or comments",
	"guarantee.additional.documents": "Additional documents",
	"guarantee.address": "City / Country",
	"guarantee.age.material": "Age of the material to be replaced",
	"guarantee.agricultural": "Agricultural",
	"guarantee.agricultural.questions": "Question for agricultural building",
	"guarantee.agricultural.specify": "Please specify",
	"guarantee.air.renewal": "specify the air renewal rate(in m3/h/animal)",
	"guarantee.allocation.building": "Allocation and destination of the building",
	"guarantee.altitude.above.900m": "Above 900 m",
	"guarantee.altitude.below.900m": "Below 900 m",
	"guarantee.aluminium": "Aluminium",
	"guarantee.ambiance": "Ambiance inside the building",
	"guarantee.ammonia": "specify the Ammonia concentration indoor(in ppm)",
	"guarantee.animals.density": "Density of animals per m²?",
	"guarantee.animals.inside.building": "Which animals are kept inside the building?",
	"guarantee.animals.shed": "Specify the number of animals in the shed",
	"guarantee.area": "Area name",
	"guarantee.atmospheric.corrosion": "Atmospheric corrosion",
	"guarantee.attachment": "Attached document",
	"guarantee.attachment.categorize.title": "Tag each document with the analysis it corresponds to:",
	"guarantee.attachment.category.label": "Document type",
	"guarantee.attachment.category.other": "Other",
	"guarantee.attachment.category.soil": "Soil analysis",
	"guarantee.attachment.category.water": "Water analysis",
	"guarantee.attachment.column.actions": "Actions",
	"guarantee.attachment.column.file": "File name",
	"guarantee.attachment.column.size": "Size",
	"guarantee.attachment.description": "Upload and tag your documents. Each file must be tagged with the analysis it corresponds to.",
	"guarantee.attachment.limit": "The maximum file size is 115 MB.",
	"guarantee.attachment.missing.soil": "Missing: document for soil analysis",
	"guarantee.attachment.missing.title": "Required document missing",
	"guarantee.attachment.missing.water": "Missing: document for water analysis",
	"guarantee.attachment.size": "Size of the attachment should not exceed 115mb",
	"guarantee.attachment.title": "Attachments",
	"guarantee.attachment.uploaded.title": "Uploaded documents",
	"guarantee.between.2kmand10km": "Located between 2km and 10km from the coast",
	"guarantee.between.300mand2km": "Located between 300m and 2km from the coast",
	"guarantee.breeding.animals": "Breeding of Animals",
	"guarantee.building.altitude": "Altitude",
	"guarantee.building.heated": "Is the building heated?",
	"guarantee.cancelled": "Cancelled",
	"guarantee.card.client.project.name": "Client project name",
	"guarantee.card.details": "Guarantee request details",
	"guarantee.card.info": "Guarantee information",
	"guarantee.card.title": "Guarantee Card - Guarantee request",
	"guarantee.cattle": "Cattle",
	"guarantee.certificate.issued": "Certificate issued",
	"guarantee.certificate.request": "Request Certificate",
	"guarantee.certificate.request.confirmation": "Do you confirm that you want to request the certificate for this guarantee request",
	"guarantee.certificate.request.failed": "Sorry, an unexpected error occurred during the process. Please try again later.",
	"guarantee.certificate.request.success": "Certificate request submitted successfully.",
	"guarantee.certificate.request.unavailable": "This guarantee is no longer available for a certificate request.",
	"guarantee.certificate.requested": "Certificate requested",
	"guarantee.characteristics": "Project Characteristics",
	"guarantee.chimney": "Chimney",
	"guarantee.choose.applicationtype": "Choose the type of guarantee you want to request?",
	"guarantee.cladding": "Cladding",
	"guarantee.cladding.double.skin": "Double skin",
	"guarantee.cladding.single.skin": "Single skin",
	"guarantee.cladding.specify.material.type": "In cladding (specify the type of material and the surface covered)",
	"guarantee.client.project.name": "Project name",
	"guarantee.coastal.marine": "In a coastal or marine environment",
	"guarantee.cold.structure": "Cold formed structural members of buildings (purlins, rails, …)",
	"guarantee.composite.floor": "Composite floor",
	"guarantee.concrete.foundations": "Concrete for foundations",
	"guarantee.condensation.rink": "Is there a condensation risk inside the building?",
	"guarantee.condition.material": "Condition of the material to be replaced",
	"guarantee.construction.new.building": "Complete construction of a new building",
	"guarantee.construction.site": "Construction site",
	"guarantee.construction.site.mandatory": "GPS location (Latitude and Longitude) is mandatory",
	"guarantee.contact": "(e.g. continuously hot-dip galvanized steel, batch galvanized steel, wood, etc.)",
	"guarantee.contact.orther.parts": "Which other materials are going to be used in contact with Magnelis® coated parts? Please specify, if applicable!",
	"guarantee.contact.parts": "Which coatings are going to be used for parts in contact with Magnelis® coated parts? Please specify, if applicable!",
	"guarantee.coordinates.decimal": "Coordinates in Decimal Degrees",
	"guarantee.coordinates.dms": "Coordinates in Degrees Minutes Seconds",
	"guarantee.coordinates.pair.mandatory": "Please fill in both Latitude and Longitude",
	"guarantee.corporate.name.mandatory": "Customer field is mandatory",
	"guarantee.current.status": "Current status",
	"guarantee.customer.information": "Customer information",
	"guarantee.customer.name": "Customer",
	"guarantee.customer.rejected": "Rejected by the customer",
	"guarantee.desert": "In the desert",
	"guarantee.designation": "Designation",
	"guarantee.direction.of.cladding.installation": "Direction of installation of the cladding",
	"guarantee.distance.3KM.seafront": "If the distance is less than 3km from the sea front, then please specify the distance",
	"guarantee.distance.lake": "Distance to lake or river (km)",
	"guarantee.distance.less than 300m": "Located in less than 300m from the coast",
	"guarantee.distance.seafront": "If the distance is less than 10km from the seafront, then please specify the distance",
	"guarantee.distance.seafrontkm": "Distance to seafront(km)",
	"guarantee.distance.site": "Distance from the site (km)",
	"guarantee.documents": "Guarantee Documents",
	"guarantee.documents.title": "Documents",
	"guarantee.double.skin.roof": "Double skin roof",
	"guarantee.draft": "Draft",
	"guarantee.draft.edit": "You will be able to edit it in your draft follow-up.",
	"guarantee.draft.saved.successfully": "Your draft has been saved",
	"guarantee.duckboard": "Through concrete grating/duckboard",
	"guarantee.duration.year": "{{value}} year",
	"guarantee.duration.years": "{{value}} years",
	"guarantee.duration.years.indoor": "Guarantee duration expected indoor (in years)",
	"guarantee.duration.years.outdoor": "Guarantee duration expected outdoor (in years)",
	"guarantee.emission.type": "Type of emissions",
	"guarantee.epassivation.type": "Epassivation type",
	"guarantee.epc": "Engineering, procurement & constructions (EPC)",
	"guarantee.epc.company.name": "Company name",
	"guarantee.equipment": "What equipment is available for the discharge of smoke, fumes, vapour and humidity?",
	"guarantee.extension.existing.building": "Extension to an existing building",
	"guarantee.extension.solar.plant": "Extension to an existing solar plant",
	"guarantee.extractor": "Extractor",
	"guarantee.fabrication": "Fabrication process",
	"guarantee.fastners": "Materials for fasteners",
	"guarantee.fertilizer": "Storage of fertilizer",
	"guarantee.floating.solar.installation": "Floating Solar Installation",
	"guarantee.floating.solar.magnelis": "Guarantee for Floating Solar Installations with Magnelis®",
	"guarantee.fodder": "Storage of fodder",
	"guarantee.forced": "forced ventilation",
	"guarantee.forced.ventilation": "Forced ventilation",
	"guarantee.gas.building": "Is there gas or vapour released inside the building?",
	"guarantee.gratings": "On gratings",
	"guarantee.ground.mounted": "Ground mounted / utility scale solar plant",
	"guarantee.heating.type": "Type of heating",
	"guarantee.horizontal.rails": "Horizontal rails of crash barriers",
	"guarantee.humidity.high": "High",
	"guarantee.humidity.low": "Low",
	"guarantee.humidity.medium": "Medium",
	"guarantee.humidity.rate.inside.building": "Humidity rate inside the building",
	"guarantee.humidity.saturated": "Saturated",
	"guarantee.humidity.specify": "Specify the humidity rate",
	"guarantee.humidity.very.high": "Very high",
	"guarantee.hydrogen.sulphide": "specify the Hydrogen Sulphide Concentration indoor(in ppm)",
	"guarantee.industrial": "Industrial",
	"guarantee.industrial.questions": "Question for industrial building and others",
	"guarantee.industry.type": "Type of industry",
	"guarantee.inside-building.activity": "Please specify the activity inside the building",
	"guarantee.installation.direction.horizontal": "Horizontal",
	"guarantee.installation.direction.vertical": "Vertical",
	"guarantee.last.modified.date": "Last update",
	"guarantee.lat.degree": "Degrees (0-89)",
	"guarantee.lat.degrees": "Lat degrees",
	"guarantee.lat.max": "Latitude (-90 to 90)",
	"guarantee.lat.minutes": "Lat minutes",
	"guarantee.lat.seconds": "Lat seconds",
	"guarantee.latitude": "Latitude",
	"guarantee.latlong.degree.pattern": "Max decimal places is upto 6",
	"guarantee.latlongmin.max": "Minutes (0-59)",
	"guarantee.latlongsec.max": "Seconds (0-59.9999)",
	"guarantee.latlongsec.pattern": "Max decimal places is upto 4",
	"guarantee.launch.analysis": "Launch analysis",
	"guarantee.long.degrees": "Long degrees",
	"guarantee.long.max": "Longitude (-180 to 180)",
	"guarantee.long.minutes": "Long minutes",
	"guarantee.long.seconds": "Long seconds",
	"guarantee.longdegress.max": "Degrees (0-179)",
	"guarantee.longitude": "Longitude",
	"guarantee.magnelis": "Magnelis® coating mass",
	"guarantee.magnelis.other": "Other",
	"guarantee.magnelis.poles": "Magnelis® coating mass for poles",
	"guarantee.magnelis.upper.structure": "Magnelis® coating mass for upper structure",
	"guarantee.magnelis.zm310": "Magnelis® ZM310 with a metallic coating of 310 g/m² on both sides",
	"guarantee.magnelis.zm430": "Magnelis® ZM430 with a metallic coating of 430 g/m² on both sides",
	"guarantee.magnelis.zm620": "Magnelis® ZM620 with a metallic coating of 620 g/m² on both sides",
	"guarantee.magnelis.zm800": "Magnelis® ZM800 with a metallic coating of 800 g/m² on both sides",
	"guarantee.magnelisbuilding.long": "Magnelis® for building application",
	"guarantee.magnelisbuilding.short": "Magnelis® Building",
	"guarantee.magnelisothers.long": "Magnelis® for other application",
	"guarantee.magnelisothers.short": "Magnelis® Other",
	"guarantee.magnelissolar.long": "Magnelis® for solar application",
	"guarantee.magnelissolar.short": "Magnelis® Solar",
	"guarantee.manure.management": "Manure management for buildings with animals",
	"guarantee.mineral.wool.insulation": "Mineral wool",
	"guarantee.mounting.system.producer": "Mounting system producer",
	"guarantee.msp.company.name": "Company name",
	"guarantee.name.copy": "copy",
	"guarantee.name.unique.error": "Unexpected error occurred during the process ({{errordetails}})",
	"guarantee.name.unique.reason.duplicate": "unicity of name",
	"guarantee.name.unique.reason.network": "unable to reach the server",
	"guarantee.natural.ventilation": "Natural ventilation",
	"guarantee.nature.content": "Nature and content of the interior ambience",
	"guarantee.nature.material": "Nature of the material to be replaced",
	"guarantee.new.solar.plant": "Complete construction of a new solar plant",
	"guarantee.no.duckboard": "No duckboard",
	"guarantee.no.parts.magnelis": "No Parts with Magnelis® coating",
	"guarantee.notypes.available": "No guarantee type available",
	"guarantee.open.building": "Open building",
	"guarantee.open.building.specify": "Specify",
	"guarantee.organiccoating.long": "Organic coated steels for building applications",
	"guarantee.other": "Other applications",
	"guarantee.other.application": "Please indicate the application",
	"guarantee.other.building": "Other (e.g. office, health, hotel, sports & leisure, parking …)",
	"guarantee.other.coatings": "Coated steel with other coatings",
	"guarantee.other.materials": "Other materials used in direct contact with Magnelis®",
	"guarantee.other.materials.used": "Other materials used",
	"guarantee.others.animals": "Others",
	"guarantee.others.please.specify": "Please specify",
	"guarantee.part.corrosion": "Corrosion type",
	"guarantee.part.magnelis": "Magnelis® coating mass (g/m2)",
	"guarantee.parts.magnelis": "Parts with Magnelis® coating",
	"guarantee.pdf.page": "Page",
	"guarantee.per.app": "In which application will the perforated sheet be used?",
	"guarantee.per.rich": "Please indicate the perforation scheme",
	"guarantee.perforated.sheet": "Perforated sheet",
	"guarantee.pigs": "Pigs",
	"guarantee.pir.insulation": "PIR",
	"guarantee.planned.operations": "Planned operation(s)",
	"guarantee.poles.magnelis": "Guarantee for poles made with Magnelis® projects with poles in soil",
	"guarantee.poles.soil": "Projects with poles in soil",
	"guarantee.power.generation": "Power generation",
	"guarantee.presence.animals": "Presence of animals inside the building",
	"guarantee.prevailing.wind": "Are the gas or smoke or pulverulent releases carried by prevailing winds?",
	"guarantee.project.characteristics": "Project characteristics",
	"guarantee.project.environment": "Project environment",
	"guarantee.project.for.floating.solar": "Project for floating solar",
	"guarantee.project.location": "Project location",
	"guarantee.project.name": "Project name",
	"guarantee.project.name.mandatory": "Project name is mandatory",
	"guarantee.project.size": "Project size",
	"guarantee.project.type": "Project type",
	"guarantee.proposal.ongoing": "Proposal ongoing",
	"guarantee.proposals": "Proposals and additional documents",
	"guarantee.proximity.buildings": "In proximity to building(s) housing animals or storing\tfermentation products",
	"guarantee.pu.insulation": "PU",
	"guarantee.purpose.building": "Please specify the purpose of the building",
	"guarantee.questions": "Questions for industrial and agricultural buildings",
	"guarantee.radio.na": "NA",
	"guarantee.radio.no": "NO",
	"guarantee.radio.yes": "YES",
	"guarantee.rainwater.systems": "Rainwater systems / Gutter",
	"guarantee.reason": "Reason",
	"guarantee.refineries.factories": "Mainly comprising refineries, incineration factories, coal or oil-fired power stations, distiling industries, cement works, paper mills, chemical plants...",
	"guarantee.register": "Product - guarantee request",
	"guarantee.register.magnelisbuilding": "Product - guarantee certificate request - Magnelis® for building application",
	"guarantee.register.magnelisothers": "Product - guarantee certificate request - Magnelis® for other applications",
	"guarantee.register.magnelissolar": "Product - guarantee certificate request - Magnelis® for solar application",
	"guarantee.relative.humidity": "Please specify the relative humidity",
	"guarantee.remarks": "Please specify any other remarks or details about your project :",
	"guarantee.request.author": "Author",
	"guarantee.request.certificate.id": "Certificate",
	"guarantee.request.date": "Date",
	"guarantee.request.drafts": "Guarantee request - draft list",
	"guarantee.request.duplicate": "Duplicate",
	"guarantee.request.followup": "You will be able to view it in your My guarantee requests.",
	"guarantee.request.id": "Guarantee ID",
	"guarantee.request.list": "My guarantee requests",
	"guarantee.request.requested.date": "Requested date",
	"guarantee.request.submitted.successfully": "Your guarantee request has been submitted successfully.",
	"guarantee.request.type": "Type",
	"guarantee.requested": "Guarantee requested",
	"guarantee.requested.type.indoor": "Indoor",
	"guarantee.requested.type.indoor.label": "Indoor Guarantee requested",
	"guarantee.requested.type.outdoor": "Outdoor",
	"guarantee.requested.type.outdoor.label": "Outdoor Guarantee requested",
	"guarantee.residential": "For residential use",
	"guarantee.retrofitting.existing.building": "Retrofitting/Repair of an existing building",
	"guarantee.retrofitting.solar.plant": "Retrofitting/Repair of an existing solar plant",
	"guarantee.road.restraint": "Road restraint systems",
	"guarantee.roofing": "Roofing",
	"guarantee.roofing-cladding.anti-condensation.felt": "Anti-condensation felt",
	"guarantee.roofing-cladding.color": "Color",
	"guarantee.roofing-cladding.desired.back.coat": "Desired back-coat",
	"guarantee.roofing-cladding.desired.coating": "Desired coating",
	"guarantee.roofing-cladding.external.skin": "External skin",
	"guarantee.roofing-cladding.insulation": "Insulation",
	"guarantee.roofing-cladding.internal.skin": "Internal skin",
	"guarantee.roofing-cladding.made.with.product": "Roofing and/or cladding made entirely with the product",
	"guarantee.roofing-cladding.metallic.coating.weight": "Metallic coating weight",
	"guarantee.roofing-cladding.overlapping": "Overlapping",
	"guarantee.roofing-cladding.perforation": "Perforation",
	"guarantee.roofing-cladding.pv.solar.roof": "PV / solar roof",
	"guarantee.roofing-cladding.substrate.thickness": "Substrate thickness",
	"guarantee.roofing-cladding.surface": "Surface",
	"guarantee.roofing.decking.roof": "Decking roof",
	"guarantee.roofing.roofslope": "Roofslope (%)",
	"guarantee.roofing.specify.material.type": "In roofing (specify the type of material and the surface covered)",
	"guarantee.rooftop.installation": "Rooftop installation",
	"guarantee.rrs.miscellaneous": "Miscellaneous parts of road restraint systems, submitted to atmospheric corrosion",
	"guarantee.rrs.poles": "Poles for road restraint systems",
	"guarantee.rrs.welded": "Are the parts, which will be made with Magnelis®, welded?",
	"guarantee.rural.area": "In a rural area more than 10 km from the coast",
	"guarantee.rural.area.20KM": "In a rural area more than 20 km from the coast",
	"guarantee.sandwich.panel": "Sandwich panels or built-up system",
	"guarantee.satisfied": "Satisfied",
	"guarantee.save.failed": "Guarantee submit failed.",
	"guarantee.save.failed.message": "Please try again later or contact ebusiness.support@arcelormittal.com",
	"guarantee.service.requests": "My guarantee requests",
	"guarantee.sheet.thickness": "Sheet thickness (mm)",
	"guarantee.silo": "Silo",
	"guarantee.silo.cylinder": "Cylinder of the silo",
	"guarantee.silo.liner": "Will the silo have a liner?",
	"guarantee.silo.parts": "Which parts of the silo will be made with Magnelis®",
	"guarantee.silo.products": "Which products will be stored in the silo?",
	"guarantee.silo.roof": "Roof of the silo",
	"guarantee.silo.soil": "Base of the silo, which is in contact with the soil or concret",
	"guarantee.single.skin.roof": "Single skin roof",
	"guarantee.soil.analysis": "Is a full soil analysis available?",
	"guarantee.soil.document": "If yes, please attach the soil analysis document in attachments (at the top of screen)",
	"guarantee.soil.information": "The soil analysis should contain at least the following information Granulometry, pH-value, moisture content, chloride content, sulphate content, sulphide content, resistivity, presence of ground water.Any other information about the soil, which is in accordance with DIN 50929-3:2018, will be useful.",
	"guarantee.soil.requirements.title": "Soil analysis requirements",
	"guarantee.specific.environment": "In a specific environment(combination of above exposure and certain additional effects, high temperature, high hygrometry, significant dust deposits, etc)",
	"guarantee.specify": "Please specify:",
	"guarantee.specify.perforation.scheme": "Specify the perforation scheme",
	"guarantee.stainless.steel": "Stainless steel",
	"guarantee.steel.parts": "Stainless steel for parts",
	"guarantee.storage.chemicals": "Presence and/or use and/or storage of chemical products",
	"guarantee.storage.fermentation": "Presence and/or storage of fermentation product",
	"guarantee.structure": "The structure is made entirely with Magnelis®",
	"guarantee.suggested.coating.mass": "Coating mass to be suggested by ArcelorMittal based on expected Guarantee duration",
	"guarantee.summary": "Summary",
	"guarantee.supplier.rejected": "Rejected by the supplier",
	"guarantee.surface.building": "For building applications: surface (m²):",
	"guarantee.tonnage.magnelis": "Tonnage of Magnelis® coated steel",
	"guarantee.type": "Type of guarantee",
	"guarantee.type.application": "Type of application",
	"guarantee.type.of.installation": "Type of installation",
	"guarantee.types.of.guarantee": "Types Of Guarantee",
	"guarantee.unknown": "Unknown",
	"guarantee.upper.structure": "Guarantee for upper structure made with Magnelis®",
	"guarantee.urban.agglomeration": "In an urban agglomeration and/or industrial environment",
	"guarantee.use.of.other.materials": "Use of other materials, notably cement, breeze blocks",
	"guarantee.ventilation.roof": "natural ventilation through blinds in roof",
	"guarantee.ventilation.walls": "natural ventilation through blinds in walls",
	"guarantee.wall.facade": "Wall / Facade",
	"guarantee.water.analysis": "Is a water analysis available?",
	"guarantee.water.document": "Please put in attachments (at the top of screen) the water analysis together with the guarantee request",
	"guarantee.water.information": "The water analysis should contain at least the following information: Chloride content, sulphate content, calcium content, magnesium content, alkalinity Ks4,3, pH-value, structure/water potential UH, conductivity. Any other information about the water, which is in accordance with DIN 50929-3:2018, will be useful.",
	"guarantee.water.requirements.title": "Water analysis requirements",
	"guarantee.with.partial.momentary.wetting": "With partial or momentary wetting with sea water and/or direct action of sea spray",
	"guarantee.without.direct.wetting": "Without direct wetting with sea water and/or direct action of sea spray",
	"guarantee.without.gratings": "Without gratings",
	"guarantee.zinc": "Zinc coated steel",
	"gurantee.duration.years": "Guarantee duration expected (in years)",
	"gurantee.other.coating.mass": "Other coating mass",
	"help.data.documents": "Documents",
	"help.documents": "Help documents",
	"highest.stocks.widget.title": "Top 5 highest stocks",
	"home.batch-list": "My batches",
	"home.customer.feedback": "Customer feedback",
	"home.dashboard": "Dashboard",
	"home.deliveryschedule": "Delivery Forecast or Delivery Tracking",
	"home.diplay.last.batches": "Display the last 20 consulted batches",
	"home.identify.batch": "Identify a batch",
	"home.last.seen.batch": "Last seen batches",
	"home.no.service": "Your profile can not manage any services. Please contact your SteelUser Relay to get full access to App service.",
	"home.no.service.alert": "No service",
	"home.order-tracking.commercial-documents": "My commercial documents",
	"home.order-tracking.my-schedule-business-order": "My schedule business order",
	"home.order-tracking.orders": "My orders",
	"home.ordertracking": "Order tracking",
	"home.quality-issues.issues": "My quality issues",
	"import.data": "Import data",
	"import.excel": "Import excel",
	"import.file.message": "Upload an XLS file to import data from existing file. Please follow the template in order to allow automatic detection.",
	"import.file.message.all.fields.mandatory": "All the fields are mandatory.",
	"incoterm.22": "CFR landed duty unpaid",
	"incoterm.23": "CFR liner terms duty unpaid",
	"incoterm.24": "CFR free out duty unpaid",
	"incoterm.25": "CIF landed duty unpaid",
	"incoterm.26": "CIF LINER TERMS DUTY UNPAID",
	"incoterm.27": "CIF FREE OUT",
	"incoterm.28": "CFR sous palan",
	"incoterm.33": "CFR FO Quick custom desp",
	"incoterm.CFR": "Cost and Freight",
	"incoterm.CIF": "Cost, Insurance, Freight",
	"incoterm.CIP": "Carriage and insurance paid to",
	"incoterm.CPT": "Carriage paid to",
	"incoterm.DAF": "Delivered at frontier",
	"incoterm.DAT": "Delivered at terminal",
	"incoterm.DDP": "Delivered duty paid",
	"incoterm.DDU": "Delivered duty unpaid",
	"incoterm.DEQ": "Carriage paid to quay",
	"incoterm.DES": "Delivered ex ship",
	"incoterm.FAS": "Free alongside ship",
	"incoterm.MAD": "Made available at the factory",
	"incoterm.RC": "Including transport to customer's premises",
	"incoterm.dap": "Delivered at place",
	"incoterm.exw": "Ex works",
	"incoterm.fca": "Free carrier",
	"incoterm.fob": "Free on board",
	"inner.greater.than.outer.error": "Field greater than outer Ø.",
	"internal.placeholder.choose.customer": "Enter the customer name",
	"issue.acceptedquantity": "Accepted quantity",
	"issue.acceptedquantity.value": "Accepted quantity (Value)",
	"issue.action.data.center": "Data center",
	"issue.action.filters": "Filters",
	"issue.attach.documents": "Add attachment",
	"issue.batch.cdd": "CDD",
	"issue.batch.commercial.documents": "Commercial documents",
	"issue.batch.customer.order.number": "Customer order number",
	"issue.batch.dimension": "Dimensions (mm)",
	"issue.batch.invoiced": "Invoiced",
	"issue.batch.no.result": "No result",
	"issue.batch.number": "Batch number",
	"issue.batch.quick.search": "Quick search",
	"issue.batch.status": "Status",
	"issue.batch.steelgrade": "Steelgrade",
	"issue.batch.view-details": "View details",
	"issue.batchesassociated": "Batches associated with this issue",
	"issue.calimed.quantity": "Claimed quantity",
	"issue.calimed.quantity.value": "Claimed quantity (Value)",
	"issue.cancel": "Your claim has been cancelled successfully",
	"issue.claim": "Claim",
	"issue.closingdate": "Closing date",
	"issue.contact.info": "Contact information",
	"issue.contact.label": "I want to be contacted by an ArcelorMittal contact.",
	"issue.contact.type": "Contact type",
	"issue.creditnote": "Credit note",
	"issue.creditnotedate": "Credit note date",
	"issue.currency": "Currency",
	"issue.customer.defect": "Customer defect",
	"issue.customer.reference": "Customer quality issue reference",
	"issue.decision": "Decision",
	"issue.defect.type": "Defect type",
	"issue.do.you.want.to.be.contacted": "Do you want to be contacted ?",
	"issue.draft": "Draft",
	"issue.draft.deleted": "Your draft  has  been deleted successfully",
	"issue.drag.and.drop.files": "Drag and drop your files here",
	"issue.filterbystatus": "Filter by status",
	"issue.followup.widget.title": "Quality feedback",
	"issue.inprocess": "In process",
	"issue.invoiced.batch": "Invoiced batches only",
	"issue.issuecard": "Quality issue card",
	"issue.issuedocuments": "Documents",
	"issue.issueinformation": "Issue information",
	"issue.ok.value": "OK",
	"issue.origin": "Origin",
	"issue.origin.ach": "ArcelorMittal Claim Entry System",
	"issue.origin.sta": "Steeluser",
	"issue.pending": "Pending",
	"issue.qualityfeedback": "Quality feedback",
	"issue.qualityissues": "Quality issues",
	"issue.qualityissues.drafts": "Quality issue - draft list",
	"issue.register": "Register a quality issue",
	"issue.requested.total.amount": "Requested total amount",
	"issue.requested.total.amount.value": "Requested total amount (Value)",
	"issue.save.as.drafts": "Save as draft",
	"issue.select.batches.action.next": "Next",
	"issue.select.current.batch": "Your current selected batch :",
	"issue.select.first.batch": "Select the first batch for your quality issue registration",
	"issue.select.other.batch": "Or select an other batch",
	"issue.send.claim": "Send",
	"issue.sending.sample": "Sending sample",
	"issue.shipments": "Shipments",
	"issue.submit.quality.feedback": "Submit your quality feedback",
	"issue.supplierdefect": "Supplier defect",
	"issue.supplierissuenumber": "ArcelorMittal issue number",
	"issue.total.amount.accepted": "Total amount accepted",
	"issue.total.amount.accepted.value": "Total amount accepted (Value)",
	"issue.type.of.request": "Type of request",
	"issue.unit": "Unit",
	"issue.widget.overviewofqi": "Overview of quality issues",
	"issue.widget.selector.feedbackselected": "You have selected: Quality Feedback Follow-up",
	"issue.widget.selector.validateadvice": "Click on validate to confirm your choice",
	"label.calculation": "Get calculation",
	"label.coil.calculator": "Coil calculator",
	"last.guarantee.requests": "Last guarantee requests",
	"latitude.N": "N",
	"latitude.S": "S",
	"legal-document.needforsteel.sales.framework": "ArcelorMittal Need4Steel® sales framework",
	"legal-documents.agree.to.sales.conditions": "Please agree our",
	"legal-documents.and": "and",
	"legal-documents.confirm.cart.with.sales.conditions": "When you confirm your cart you agree with our",
	"legal-documents.general.sales.conditions": "general sales conditions",
	"legal-documents.non.prime.sales.framework": "non prime sales framework",
	"legal.data.header": "Terms, conditions and policies",
	"line.select.family.period": "Choose a period to browse",
	"line.select.family.product": "Choose a product family to browse",
	"line.select.period.fiveyears": "5 years",
	"line.select.period.oneyear": "1 year",
	"line.select.period.sixmonths": "6 months",
	"line.select.period.threemonths": "3 months",
	"line.select.period.twoyear": "2 years",
	"line.select.tab.layout": "Choose your tab layout",
	"linked.soldto": "Linked Sold to",
	"loader.text": "Products are loading",
	"longitude.E": "E",
	"longitude.W": "W",
	"manage.services.add-services": "Add Services",
	"manage.services.drag-and-drop-items-on-the-right": "Drag and drop items from the right to add a service",
	"manual.data.customer": "Customer order number",
	"manual.data.enter.reference": "Please enter an order reference",
	"manual.data.not.found": "No batch found.",
	"manual.data.num": "Item",
	"manual.data.reference": "Reference",
	"manual.data.supplier": "Supplier order number",
	"manual.data.supplier.or.customer": "Please enter supplier order number or customer order number.",
	"materials.rts.widget.title": "Material ready to ship",
	"menu.closed.issues": "Closed quality issues",
	"menu.declare.choose.customer": "Choose a customer",
	"menu.declare.order-tracking": "Web order tracking",
	"menu.declare.order-tracking.deliveryschedule": "Delivery Forecast or Delivery Tracking",
	"menu.declare.order-tracking.ordertracking": "Order tracking",
	"menu.declare.quality.issue": "Declare a quality issue",
	"menu.drafts": "Drafts",
	"menu.logout": "LOG OUT",
	"menu.modify.quality.issue": "Modify a quality issue",
	"menu.order-services": "Order services",
	"menu.pending.issues": "Pending quality issues",
	"menu.product-services": "Product services",
	"menu.profile": "Profile",
	"menu.sales-services": "Sales services",
	"menu.settings": "Settings",
	"menu.sign.in": "Sign in",
	"modification.error.message": "Your modification will not be saved",
	"n4steel.contact-add-attachment": "Add attachment",
	"n4steel.contact-attachment-help": "Drag and drop your files here",
	"n4steel.contact-mail": "Contact ArcelorMittal Need4Steel®",
	"n4steel.contact-mail-from": "From",
	"n4steel.contact-mail-invalid-email": "Invalid format of e-mail address",
	"n4steel.contact-mail-mill": "Mill",
	"n4steel.contact-mail-offer": "Related offer",
	"n4steel.contact-mail-prefill-data": "Data automatically sent with the mail",
	"n4steel.upload.file.size.error.message": "Max 10MB per file and max 3 files.",
	"navig.confirm": "Confirm",
	"need4steel-logistic-routes.errormsg": "Max coil weight or Packing not compatible due to selected delivery address.",
	"need4steel-logistic-routes.packaging.errormsg": "Packaging is not compatible with delivery address.",
	"need4steel-order.history.errormsg": "No historical order from your ArcelorMittal Need4Steel® orderbook is matching the current offer options",
	"need4steel-order.history.import": "Import",
	"need4steel-order.history.notfound": "No order found",
	"need4steel-order.history.subtitle": "Please select products to import",
	"need4steel-order.history.title": "Order History",
	"need4steel-product-details-tooltip.no-price-msg": "Product data not available",
	"need4steel-product-details-tooltip.price-msg": "View product data",
	"need4steel-product-details.chemical-treatment": "Chemical Treatment",
	"need4steel-product-details.effectivedelivered": "€/t effective delivered",
	"need4steel-product-details.header-msg": "Product details -",
	"need4steel-product-details.max-outside-Diameter": "Max Outside Diameter (mm)",
	"need4steel-product-details.min-coil-weight": "Min coil weight (t)",
	"need4steel-product-details.proposed-price": "Proposed price",
	"need4steel-product-details.unrolledWelds": "Unrolled Welds",
	"need4steel-product-offers.additional-fields": "Additional Fields",
	"need4steel-product-section-details.min-coil-weight": "Min Coil Weight (t)",
	"need4steel-schedule.button": "Import from history",
	"need4steel-summary-details.effectivedelivered": "effective delivered",
	"need4steel.dialog.coil.weight": "Max coil weight (t)",
	"need4steel.dialog.coil.weight.range": "from {{minValue}} to {{maxValue}} t",
	"need4steel.dialog.coil.weight.range.title": "Max coil weight range",
	"need4steel.dialog.max.coilweight.range.content": "Maximum coil weight available",
	"need4steel.dialog.max.specific.weight.range.content": "Maximum specific weight available",
	"need4steel.dialog.range.steelgrade": "For grade",
	"need4steel.dialog.specific.weight.range": "from {{minValue}} to {{maxValue}} kg/mm",
	"need4steel.dialog.specific.weight.range.title": "Max specific weight range",
	"need4steel.dialog.thickness.content": "Please select a SteelGrade",
	"need4steel.dialog.thickness.list.content": "if obvious to have to select a value",
	"need4steel.dialog.thickness.range.content": "Available dimensions for thickness are",
	"need4steel.dialog.thickness.range.title": "Thickness range",
	"need4steel.dialog.width.content": "Please enter a proper value for Thickness",
	"need4steel.dialog.width.list.content": "Please select a proper value for Thickness",
	"need4steel.dialog.width.range.content": "Available dimensions for width",
	"need4steel.dialog.width.range.title": "Width range",
	"need4steel.dialog.width.range.title.content": "and thickness",
	"need4steel.offer.error.message": "Sorry, some errors occured while accessing to this offer. Please try again or send a message to your ArcelorMittal contact",
	"need4steel.offer.finishingline": "finishingLine",
	"need4steel.offer.simulation.error.message": "Sorry, some errors occured. Please try again or send a message to your ArcelorMittal contact",
	"need4steel.offers.order.button": "Order",
	"need4steel.offers.title": "ArcelorMittal Need4Steel® offers",
	"need4steel.product.details.product.coilweight": "Max Coil Weight (t)",
	"need4steel.product.details.specific.weight": "Max Specific Weight (kg/mm)",
	"need4steel.product.thickness.tolerance": "thicknessTolerance",
	"need4steel.soldto.shipto.error.message": "Sorry, there is an issue in your service settings, please contact SteelUser administrator",
	"need4steel.submit.credit.limit.error.msg": "☹ ArcelorMittal Need4Steel® order request impossible: not sufficient credit limit available. Please contact us at need4steel@arcelormittal.com",
	"need4steel.submit.error.msg": "Something went wrong, please contact SteelUser administrator",
	"need4steel.submit.exchange.rate.mandatory.error.msg": "Exchange Rate is mandatory",
	"need4steel.submit.exchange.rate.refreshed.error.msg": "Exchange Rate has been refreshed during your order process, please review it before submit it again",
	"need4steel.submit.order.error.msg.title": "Error during validation of your order",
	"need4steel.submit.order.success.msg.row1": "Your order has been processed",
	"need4steel.submit.order.success.msg.row2": "You can follow your order status in the",
	"need4steel.submit.order.success.msg.row2.link": "ORDER AND DELIVERY FOLLOW-UP.",
	"need4steel.trademark": "®",
	"need4steel.wizard.coil.error": "Please enter a valid value less than or equal to 1000.",
	"need4steel.wizard.estimated": "Estimated:",
	"need4steel.wizard.exchange-rate.rate": "Exchange rate",
	"need4steel.wizard.exchange-rate.reference-date": "Reference date",
	"need4steel.wizard.header.Delivery-address": "Delivery address is mandatory",
	"need4steel.wizard.header.customer": "Customer is mandatory",
	"need4steel.wizard.header.customer-order-number": "Customer order number",
	"need4steel.wizard.header.customer-order-number.error.invalid": "Invalid Customer order number",
	"need4steel.wizard.header.customer-order-number.error.mandatory": "Customer order number is mandatory",
	"need4steel.wizard.header.delivery.date": "Delivery date",
	"need4steel.wizard.header.mill": "Mill",
	"need4steel.wizard.header.shipto": "Delivery address",
	"need4steel.wizard.header.soldto": "Customer",
	"need4steel.wizard.header.transport-mode": "Transport mode",
	"need4steel.wizard.maxcoilweight.range.error": "Please enter a valid Max Coil Weight.",
	"need4steel.wizard.maxspecificweight.range.error": "Please enter a valid Max Specific Weight.",
	"need4steel.wizard.no.weight.option.error.message": "Template settings issue: no weight options",
	"need4steel.wizard.product.coil.weight": "t max coil weight",
	"need4steel.wizard.product.max.specific.weight": "kg/mm max specific weight",
	"need4steel.wizard.product.price.calculate.offline": "Please ensure to have internet access to request for a price",
	"need4steel.wizard.product.specific.weight": "Max specific weight (kg/mm)",
	"need4steel.wizard.product.weight.type.label": "Weight type selection",
	"need4steel.wizard.step.product.title": "Specify product",
	"need4steel.wizard.stepper.product.action.delete": "Delete",
	"need4steel.wizard.stepper.product.action.duplicate": "Duplicate",
	"need4steel.wizard.stepper.product.action.reset": "Reset",
	"need4steel.wizard.stepper.product.add": "Add product",
	"need4steel.wizard.stepper.product.coil": "# (Coil)",
	"need4steel.wizard.stepper.product.coilweight": "Max coil weight (t)",
	"need4steel.wizard.stepper.product.itemnumber": "Item Number",
	"need4steel.wizard.stepper.product.steelgrade": "Steel grade",
	"need4steel.wizard.stepper.product.thickness": "Thickness (mm)",
	"need4steel.wizard.stepper.product.total.weight": "Total weight",
	"need4steel.wizard.stepper.product.width": "Width (mm)",
	"need4steel.wizard.stepper.step.product.specification": "Product specifications",
	"need4steel.wizard.stepper.step.summary": "Summary",
	"need4steel.wizard.summary.confirm.to.order.button": "Confirm order",
	"need4steel.wizard.summary.proceed.order.button": "Proceed to order",
	"need4steel.wizard.summary.product.coils": "No. of coils",
	"need4steel.wizard.summary.product.dimension": "Dimensions (mm)",
	"need4steel.wizard.summary.product.price": "Price (€/t)",
	"need4steel.wizard.summary.product.selection": "Product selection",
	"need4steel.wizard.summary.product.total.weight": "Total weight (t)",
	"need4steel.wizard.summary.terms.conditions.text": "By clicking on proceed to order you accept the terms and conditions of the ArcelorMittal Need4Steel®",
	"need4steel.wizard.thickness.range.error": "Please enter a valid Thickness.",
	"need4steel.wizard.thickness.tolerance.field": "Thickness Tolerance",
	"need4steel.wizard.width.range.error": "Please enter a valid Width.",
	"new.offer.request.message": "Do you know the quantity you need for each item specifications?",
	"news.detail": "View details",
	"news.last-news": "Latest news",
	"news.news-list": "News list",
	"news.view-all": "View all",
	"no.data.error": "No data found in the feasibility sheet",
	"no.guarantee.documents": "No Guarantee Documents",
	"no.legal.documents": "No Documents Found",
	"no.product.family": "No family of products was found.",
	"no.result": "no result found",
	"notifications.daily": "Daily",
	"notifications.immediatly": "Immediately",
	"notifications.management": "Notifications Management",
	"notifications.monthly": "Monthly",
	"notifications.weekly": "Weekly",
	"number.of.items.in.order": "Too much item to add into this order.",
	"number.of.items.infos.message": "Please enter the number of copy of this product that you want as item into this order",
	"number.of.items.label": "Nb of items",
	"number.of.items.limit.in.order": "We can only accept 100 items into one given order. Please review your selection.",
	"offer-dashboard-card.accepted": "Accepted",
	"offer-dashboard-card.annually": "Annually",
	"offer-dashboard-card.monthly": "Monthly",
	"offer-dashboard-card.offered": "Offered",
	"offer-dashboard-card.order": "Order",
	"offer-dashboard-card.other-period": "Other Period",
	"offer-dashboard-card.quarterly": "Quarterly",
	"offer-dashboard-card.remaining-to-order": "Remaining to order",
	"offer-dashboard-card.requested": "Requested",
	"offer-dashboard-card.semesterly": "Semesterly",
	"offer-dashboard-card.view-details": "View details",
	"offer-period.from": "From",
	"offer-period.reset": "Reset",
	"offer-period.to": "To",
	"offer.card.table.header.quantity": "Quantity (t)",
	"offer.current.total.tons": "t",
	"offer.dashboard.services": "My services",
	"offer.end.date": "End date",
	"offer.enduser.update.cart.warning": "This end user is not compatible with some selected products. They will be  automatically removed from the cart.",
	"offer.multiple.families": "Multiple",
	"offer.new.request.title": "New Request",
	"offer.product.disabled.tooltip": "This product is not compatible with current selected delivery address or end user",
	"offer.product.family": "Product family",
	"offer.quantity.framework": "Choose the quantities per family, on which you want to receive an offer ",
	"offer.quantity.spot": "Choose the quantities per item, on which you want to receive an offer ",
	"offer.shipto.update.cart.warning": "This delivery address is not compatible with some selected products. They will be  automatically removed from the cart.",
	"offer.sub.family": "Sub family",
	"offer.template.disabled.tooltip": "This template is not compatible with current selected delivery address or end user",
	"offer.transport.condition": "Transport condition",
	"offer.type.no": "No",
	"offer.type.yes": "Yes",
	"offer.weight": "Weight",
	"offers.action.next": "Next",
	"offers.commercial.terms": "Commercial terms",
	"offers.commitment.period": "Commitment period",
	"offers.create.details.customer.offer-name": "Customer RFQ number",
	"offers.create.details.customer.offer-name.error.mandatory": "Customer RFQ number is mandatory",
	"offers.create.details.field.currency": "Choose your currency",
	"offers.create.details.field.offer-name": "Offer request name",
	"offers.create.details.field.offer-name.error.mandatory": "Offer request name is mandatory",
	"offers.create.details.section.entities": "Entities",
	"offers.create.details.section.offer-period": "Offer terms and commitment period",
	"offers.create.path.cart": "set your quantity",
	"offers.create.path.confirmation": "submit your offer request",
	"offers.create.request.offer": "Request an offer",
	"offers.create.section.offer-period": "Terms and commitment period",
	"offers.product.list": "Products list",
	"offers.proposals.price.nooffer": "No available offer",
	"offers.proposals.price.period": "Related Period",
	"offers.proposals.price.title": "Last proposals of price",
	"offers.request.info": "Offer request information",
	"offers.soldTo.selection.text": "Please select the proper customer for this offer request, to start to show available products list. All items in the cart should be related to the same customer.",
	"offers.sqmeters": "Square meters",
	"offers.wizard.stepper.customization": "Customization",
	"offers.wizard.stepper.request.and.selection": "Offer request & selection",
	"offers.wizard.stepper.step.offer-summary": "Summary",
	"offers.wizard.stepper.step.quantity": "Quantity",
	"offline.alert": "Alert",
	"ok.value": "OK",
	"order-card.batches-at-reshipper": "At reshipper",
	"order-card.batches-available": "Batches - Available",
	"order-card.batches-blocked": "Batches - Stock blocked",
	"order-card.batches-called": "Called",
	"order-card.batches-consignment-stock": "Consignment stock",
	"order-card.batches-delivered": "Batches - Delivered",
	"order-card.batches-land-transit": "Land transit",
	"order-card.batches-on-vessel": "On vessel",
	"order-card.batches-overseas-transit": "Overseas transit",
	"order-card.batches-ready-to-ship": "Ready to ship",
	"order-card.batches-transit-to-customer": "In transit to customer",
	"order-card.commercial-documents": "Commercial documents",
	"order-card.data-not-found": "Order data not found",
	"order-card.document": "Document",
	"order-card.due-to-technical-issue": "Due to a technical issue, we are not able to display this data",
	"order-card.gross": "Gross: {{value}}",
	"order-card.name": "Name",
	"order-card.net": "Net: {{value}}",
	"order-card.no-rows-to-show": "No rows to show",
	"order-card.proforma": "Proforma",
	"order-card.type": "Type",
	"order-card.we-are-actively-working": "We are actively working to restore service.",
	"order-card.wip-quantity": "Quantity (t)",
	"order-card.work-in-progress": "Work in progress",
	"order-item-status.completely-produced": "Completely produced",
	"order-tracking.card.batches-in-stock": "Batches in stock",
	"order-tracking.card.callables-batches.days": "{{value}} days",
	"order-tracking.card.callables-batches.view-details": "View all details",
	"order-tracking.card.delivery-date.cdd": "CDD",
	"order-tracking.card.delivery-date.first-batch": "1ST BATCH IN STOCK",
	"order-tracking.card.delivery-date.last-batch": "LAST BATCH IN STOCK",
	"order-tracking.card.delivery-date.rdd": "RDD",
	"order-tracking.card.delivery-date.view-details": "View all details",
	"order-tracking.card.delivery-status": "Delivery status",
	"order-tracking.cdd": "CDD",
	"order-tracking.choice": "Choice",
	"order-tracking.customerArticleReference": "Customer article reference",
	"order-tracking.delivered": "Delivered",
	"order-tracking.delivered-t": "Delivered (t)",
	"order-tracking.dimension": "Dimensions (mm)",
	"order-tracking.final.use": "Final use",
	"order-tracking.form": "Form",
	"order-tracking.in.production": "In production",
	"order-tracking.in.production-t": "In production (t)",
	"order-tracking.in.stock": "In stock",
	"order-tracking.in.stock-t": "In stock (t)",
	"order-tracking.in.transit": "In transit",
	"order-tracking.in.transit-t": "In transit (t)",
	"order-tracking.list": "List",
	"order-tracking.no.connection": "The Web Order tracking service is not available",
	"order-tracking.no.result": "No result",
	"order-tracking.overview": "Overview",
	"order-tracking.product": "Product",
	"order-tracking.product.category": "Product category",
	"order-tracking.product.description": "Product description",
	"order-tracking.running.orders": "Running orders",
	"order-tracking.standard-steel-grade": "Steelgrade Standard",
	"order-tracking.standard.steelgrade": "Steel grade",
	"order-tracking.steelgrade": "Steel grade",
	"order.avail-t": "Avail (t)",
	"order.bill.to": "Bill to",
	"order.book.only": "Order book only",
	"order.callable.gross.weight": "Callable gross weight",
	"order.called.gross.weight": "Called gross weight",
	"order.card": "Order card",
	"order.card.all.documents": "All documents of this order",
	"order.card.certificate.display.all": "Display all certificates",
	"order.card.dates": "Dates",
	"order.card.detail.information": "See detailed order information",
	"order.card.dispatch.advice.display.all": "Display all dispatch advices",
	"order.card.document.certificates": "Certificates",
	"order.card.document.date": "Date",
	"order.card.document.dispatch.advices": "Dispatch advices",
	"order.card.document.display.batches": "Display all batches",
	"order.card.document.invoices": "Invoices",
	"order.card.document.number": "Document number",
	"order.card.document.order.acknowledgments": "Order Acknowledgments",
	"order.card.document.show": "Show document",
	"order.card.document.type": "Type",
	"order.card.followup": "Order follow-up",
	"order.card.in-consignment": "In consignment",
	"order.card.in-consignment-t": "In consignment (t)",
	"order.card.information": "Order information",
	"order.card.invoice.display.all": "Display all invoices",
	"order.card.last.certificate": "Latest certificate",
	"order.card.last.dispatch.advice": "Latest dispatch advice",
	"order.card.last.documents": "Last documents",
	"order.card.last.invoice": "Latest invoice",
	"order.card.last.order.acknowledgment": "Latest order acknowledgment",
	"order.card.order.acknowledgment.display.all": "Display all order acknowledgments",
	"order.card.product": "Product",
	"order.card.xcarb": "XCarb®",
	"order.cdd-week": "CDD (week)",
	"order.certificate": "Certificate",
	"order.chemical.passivation": "Chemical Passivation",
	"order.choice": "Choice",
	"order.coating": "Coating",
	"order.coating-side": "Coating side",
	"order.color-bottom-side": "Color bottom side",
	"order.color-top-side": "Color top side",
	"order.color.category.bottom.side": "Color Category Bottom Side",
	"order.color.category.top.side": "Color Category Top Side",
	"order.confirmed.delivery.date": "Confirmed delivery date",
	"order.contract.number": "Contract number",
	"order.creation.date": "Creation date",
	"order.customer": "Customer",
	"order.customer-template-reference": "Customer template reference",
	"order.customer.article.reference": "Customer article reference",
	"order.customer.order.number": "Customer order number",
	"order.daysInStock": "Number of days in stock",
	"order.delivered-t": "Delivered (t)",
	"order.delivery": "Delivery",
	"order.delivery.address": "Delivery address",
	"order.delivery.mode": "Delivery mode",
	"order.dim-mm": "Dim (mm)",
	"order.easy-film-bottom": "Easy film bottom",
	"order.easy-film-top": "Easy film top",
	"order.easy.film.bottom": "EasyFilm Bottom",
	"order.easy.film.top": "EasyFilm Top",
	"order.ebusiness.order.number": "eBusiness order reference",
	"order.end.user": "End user",
	"order.enduser": "Enduser",
	"order.entry": "Order entry",
	"order.final-use": "Final use",
	"order.firm": "Firm",
	"order.first.batch.available": "First batch available",
	"order.first.batch.in.stock": "First batch in stock",
	"order.form": "Form",
	"order.grade": "Grade",
	"order.incoterm": "Incoterm",
	"order.incoterm2": "Incoterm2",
	"order.internal-diameter": "Internal diameter (mm)",
	"order.interpretation.delivery.date": "Interpretation delivery date",
	"order.item.reference.soldto.party": "Item sold to party",
	"order.item.status": "Order item status",
	"order.last.batch.available": "Last batch available",
	"order.last.batch.in.stock": "Last batch in stock",
	"order.last.updated": "Last updated",
	"order.maximum-outside-diameter": "Maximum outside diameter (mm)",
	"order.mill": "Mill",
	"order.mill.order.number": "Mill order number",
	"order.minimum-outside-diameter": "Minimum outside diameter(mm)",
	"order.no-documents": "No documents available",
	"order.oil-reference": "Oil reference",
	"order.oil-side": "Oil side",
	"order.oil.reference": "Oil Reference",
	"order.ord-t": "Ord (t)",
	"order.order-status": "Order status",
	"order.ordered": "Ordered",
	"order.ordered-t": "Ordered (t)",
	"order.orders": "Orders",
	"order.packing": "Packing",
	"order.paint.marking.for.sh": "Paint Marking",
	"order.pattern.for.sh": "Pattern",
	"order.place.delivery": "Place of Delivery",
	"order.prevision.item": "Prevision item (late specification)",
	"order.protection": "Protection",
	"order.provisional": "Provisional",
	"order.provisional.item": "Provisional / Firm item",
	"order.rdd": "RDD",
	"order.reason": "Order reason",
	"order.responsible.order.manager": "Responsible order manager",
	"order.sales.quarter": "Sales quarter",
	"order.service.level": "Service level",
	"order.service.request": "Service request",
	"order.ship.to": "Ship to",
	"order.sortby": "Sort By",
	"order.spangle": "Spangle",
	"order.standard": "Steel grade standard",
	"order.status": "Order status",
	"order.steelgrade": "Steelgrade",
	"order.stock-alert": "Stock alert",
	"order.sub.category": "Sub Category",
	"order.submit": "Submit",
	"order.supplier": "Supplier",
	"order.supplier-rfq-number": "Supplier RFQ number",
	"order.supplier.order.number": "Supplier order number",
	"order.surface-aspect": "Surface aspect",
	"order.thickness": "Thickness",
	"order.transport-mode": "Transport mode",
	"order.transport.mode": "Transport mode",
	"order.ultrasonic.testing": "Ultrasonic Testing",
	"order.width": "Width",
	"order.wip": "In production",
	"order.wip-t": "WIP (t)",
	"order.wip.forecast.stock": "Forecasted stock entry",
	"order.wip.quantity": "Quantity",
	"order.woe.version": "WOE version",
	"order.z.test.certificat": "Z-test Certificat",
	"orderview.sort.cdd": "cdd",
	"orderview.sort.order": "order",
	"orderview.sort.product": "product",
	"organization-type.agency": "Agency",
	"organization-type.buyer": "Buyer",
	"organization-type.lab": "Laboratory",
	"organization-type.selag": "Seller Agency",
	"organization-type.seller": "Seller",
	"organization-type.super-user": "Super User",
	"organization-users.one-admin": "One administrator should be selected",
	"organization-users.one-admin-only": "Only one administrator should be selected",
	"organization-users.roles-error": "An error occurred during the update of the user, changes are not saved",
	"organization-users.roles-saved": "Roles have been correctly updated",
	"organization.card.administrator.comment": "Current responsible for this organization",
	"organization.card.administrator.email": "Email",
	"organization.card.administrator.name": "Name",
	"organization.card.details": "Details",
	"organization.card.details.administrator": "Administrator",
	"organization.card.details.identity": "Identity",
	"organization.card.identity.address": "Address",
	"organization.card.identity.city": "City",
	"organization.card.identity.country": "Country",
	"organization.card.identity.country.AD": "Andorra",
	"organization.card.identity.country.AE": "Unit.Arab Emir.",
	"organization.card.identity.country.AF": "Afghanistan",
	"organization.card.identity.country.AG": "Antigua/Barbuda",
	"organization.card.identity.country.AI": "Anguilla",
	"organization.card.identity.country.AL": "Albania",
	"organization.card.identity.country.AM": "Armenia",
	"organization.card.identity.country.AN": "Dutch Antilles",
	"organization.card.identity.country.AO": "Angola",
	"organization.card.identity.country.AQ": "Antarctica",
	"organization.card.identity.country.AR": "Argentina",
	"organization.card.identity.country.AS": "Samoa",
	"organization.card.identity.country.AT": "Austria",
	"organization.card.identity.country.AU": "Australia",
	"organization.card.identity.country.AW": "Aruba",
	"organization.card.identity.country.AZ": "Azerbaijan",
	"organization.card.identity.country.BA": "Bosnia Herzeg.",
	"organization.card.identity.country.BB": "Barbados",
	"organization.card.identity.country.BD": "Bangladesh",
	"organization.card.identity.country.BE": "Belgium",
	"organization.card.identity.country.BF": "Burkina Faso",
	"organization.card.identity.country.BG": "Bulgaria",
	"organization.card.identity.country.BH": "Bahrain",
	"organization.card.identity.country.BI": "Burundi",
	"organization.card.identity.country.BJ": "Benin",
	"organization.card.identity.country.BM": "Bermuda",
	"organization.card.identity.country.BN": "Brunei",
	"organization.card.identity.country.BO": "Bolivia",
	"organization.card.identity.country.BR": "Brazil",
	"organization.card.identity.country.BS": "Bahamas",
	"organization.card.identity.country.BT": "Bhutan",
	"organization.card.identity.country.BU": "Burma",
	"organization.card.identity.country.BV": "Bouvet Island",
	"organization.card.identity.country.BW": "Botswana",
	"organization.card.identity.country.BY": "Belarus",
	"organization.card.identity.country.BZ": "Belize",
	"organization.card.identity.country.CA": "Canada",
	"organization.card.identity.country.CC": "Cocos Islands",
	"organization.card.identity.country.CD": "R�p. d�m. Congo",
	"organization.card.identity.country.CF": "Centr.Afr.Rep.",
	"organization.card.identity.country.CG": "Congo",
	"organization.card.identity.country.CH": "Switzerland",
	"organization.card.identity.country.CI": "Ivory Coast",
	"organization.card.identity.country.CK": "Cook Islands",
	"organization.card.identity.country.CL": "Chile",
	"organization.card.identity.country.CM": "Cameroon",
	"organization.card.identity.country.CN": "China",
	"organization.card.identity.country.CO": "Colombia",
	"organization.card.identity.country.CR": "Costa Rica",
	"organization.card.identity.country.CS": "do not use(S/M)",
	"organization.card.identity.country.CU": "Cuba",
	"organization.card.identity.country.CV": "Cape Verdian",
	"organization.card.identity.country.CX": "Christmas Islnd",
	"organization.card.identity.country.CY": "Cyprus",
	"organization.card.identity.country.CZ": "Czech Republic",
	"organization.card.identity.country.DE": "Germany",
	"organization.card.identity.country.DJ": "Djibouti",
	"organization.card.identity.country.DK": "Denmark",
	"organization.card.identity.country.DM": "Dominica",
	"organization.card.identity.country.DO": "Dominican Rep.",
	"organization.card.identity.country.DZ": "Algeria",
	"organization.card.identity.country.EC": "Ecuador",
	"organization.card.identity.country.EE": "Estonia",
	"organization.card.identity.country.EG": "Egypt",
	"organization.card.identity.country.EH": "West Sahara",
	"organization.card.identity.country.ER": "Eritrea",
	"organization.card.identity.country.ES": "Spain",
	"organization.card.identity.country.ET": "Ethiopia",
	"organization.card.identity.country.FI": "Finland",
	"organization.card.identity.country.FJ": "Fiji",
	"organization.card.identity.country.FK": "Falkland Islnds",
	"organization.card.identity.country.FM": "Micronesia",
	"organization.card.identity.country.FO": "Faroe Islands",
	"organization.card.identity.country.FR": "France",
	"organization.card.identity.country.GA": "Gabon",
	"organization.card.identity.country.GB": "Great Britain",
	"organization.card.identity.country.GD": "Grenada",
	"organization.card.identity.country.GE": "Georgia",
	"organization.card.identity.country.GF": "French Guyana",
	"organization.card.identity.country.GH": "Ghana",
	"organization.card.identity.country.GI": "Gibraltar",
	"organization.card.identity.country.GL": "Greenland",
	"organization.card.identity.country.GM": "Gambia",
	"organization.card.identity.country.GN": "Guinea",
	"organization.card.identity.country.GP": "Guadeloupe",
	"organization.card.identity.country.GQ": "Equatorial Gui.",
	"organization.card.identity.country.GR": "Greece",
	"organization.card.identity.country.GS": "S. Sandwich Ins",
	"organization.card.identity.country.GT": "Guatemala",
	"organization.card.identity.country.GU": "Guam",
	"organization.card.identity.country.GW": "Guinea-Bissau",
	"organization.card.identity.country.GY": "Guyana",
	"organization.card.identity.country.HK": "Hong Kong",
	"organization.card.identity.country.HM": "Heard/McDon.Isl",
	"organization.card.identity.country.HN": "Honduras",
	"organization.card.identity.country.HR": "Croatia",
	"organization.card.identity.country.HT": "Haiti",
	"organization.card.identity.country.HU": "Hungary",
	"organization.card.identity.country.ID": "Indonesia",
	"organization.card.identity.country.IE": "Ireland",
	"organization.card.identity.country.IL": "Israel",
	"organization.card.identity.country.IN": "India",
	"organization.card.identity.country.IO": "Brit.Ind.Oc.Ter",
	"organization.card.identity.country.IQ": "Iraq",
	"organization.card.identity.country.IR": "Iran",
	"organization.card.identity.country.IS": "Iceland",
	"organization.card.identity.country.IT": "Italy",
	"organization.card.identity.country.JM": "Jamaica",
	"organization.card.identity.country.JO": "Jordan",
	"organization.card.identity.country.JP": "Japan",
	"organization.card.identity.country.KE": "Kenya",
	"organization.card.identity.country.KG": "Kirghizstan",
	"organization.card.identity.country.KH": "Cambodia",
	"organization.card.identity.country.KI": "Kiribati",
	"organization.card.identity.country.KM": "Comoro Is.",
	"organization.card.identity.country.KN": "St.Chr.",
	"organization.card.identity.country.KP": "North Korea",
	"organization.card.identity.country.KR": "South Korea",
	"organization.card.identity.country.KW": "Kuwait",
	"organization.card.identity.country.KY": "Cayman Islands",
	"organization.card.identity.country.KZ": "Kazakhstan",
	"organization.card.identity.country.LA": "Laos",
	"organization.card.identity.country.LB": "Lebanon",
	"organization.card.identity.country.LC": "St. Lucia",
	"organization.card.identity.country.LI": "Liechtenstein",
	"organization.card.identity.country.LK": "Sri Lanka",
	"organization.card.identity.country.LR": "Liberia",
	"organization.card.identity.country.LS": "Lesotho",
	"organization.card.identity.country.LT": "Lithuania",
	"organization.card.identity.country.LU": "Luxembourg",
	"organization.card.identity.country.LV": "Latvia",
	"organization.card.identity.country.LY": "Libya",
	"organization.card.identity.country.MA": "Morocco",
	"organization.card.identity.country.MC": "Monaco",
	"organization.card.identity.country.MD": "Moldavia",
	"organization.card.identity.country.ME": "Montenegro",
	"organization.card.identity.country.MF": "Saint Martin",
	"organization.card.identity.country.MG": "Madagascar",
	"organization.card.identity.country.MH": "Marshall island",
	"organization.card.identity.country.MK": "North Macedonia",
	"organization.card.identity.country.ML": "Mali",
	"organization.card.identity.country.MM": "Myanmar",
	"organization.card.identity.country.MN": "Mongolia",
	"organization.card.identity.country.MO": "Macao",
	"organization.card.identity.country.MP": "North Mariana",
	"organization.card.identity.country.MQ": "Martinique",
	"organization.card.identity.country.MR": "Mauritania",
	"organization.card.identity.country.MS": "Montserrat",
	"organization.card.identity.country.MT": "Malta",
	"organization.card.identity.country.MU": "Mauritius",
	"organization.card.identity.country.MV": "Maldives",
	"organization.card.identity.country.MW": "Malawi",
	"organization.card.identity.country.MX": "Mexico",
	"organization.card.identity.country.MY": "Malaysia",
	"organization.card.identity.country.MZ": "Mozambique",
	"organization.card.identity.country.NA": "Namibia",
	"organization.card.identity.country.NC": "New Caledonia",
	"organization.card.identity.country.NE": "Niger",
	"organization.card.identity.country.NF": "Norfolk Island",
	"organization.card.identity.country.NG": "Nigeria",
	"organization.card.identity.country.NI": "Nicaragua",
	"organization.card.identity.country.NL": "Netherlands",
	"organization.card.identity.country.NO": "Norway",
	"organization.card.identity.country.NP": "Nepal",
	"organization.card.identity.country.NR": "Nauru",
	"organization.card.identity.country.NU": "Niue",
	"organization.card.identity.country.NZ": "New Zealand",
	"organization.card.identity.country.O1": "Other NON-CORE",
	"organization.card.identity.country.O2": "Other TASIA",
	"organization.card.identity.country.O3": "Other TAEX",
	"organization.card.identity.country.O4": "Other TANY",
	"organization.card.identity.country.OM": "Oman",
	"organization.card.identity.country.OT": "Other countries",
	"organization.card.identity.country.PA": "Panama",
	"organization.card.identity.country.PE": "Peru",
	"organization.card.identity.country.PF": "Fren.Polynesia",
	"organization.card.identity.country.PG": "Papua Nw Guinea",
	"organization.card.identity.country.PH": "Philippines",
	"organization.card.identity.country.PK": "Pakistan",
	"organization.card.identity.country.PL": "Poland",
	"organization.card.identity.country.PM": "St.Pier",
	"organization.card.identity.country.PN": "Pitcairn Islnds",
	"organization.card.identity.country.PR": "Puerto Rico",
	"organization.card.identity.country.PS": "Palest. territ.",
	"organization.card.identity.country.PT": "Portugal",
	"organization.card.identity.country.PW": "Palau",
	"organization.card.identity.country.PY": "Paraguay",
	"organization.card.identity.country.QA": "Qatar",
	"organization.card.identity.country.RE": "Reunion",
	"organization.card.identity.country.RO": "Romania",
	"organization.card.identity.country.RS": "Serbia",
	"organization.card.identity.country.RU": "Russian Fed.",
	"organization.card.identity.country.RW": "Ruanda",
	"organization.card.identity.country.SA": "Saudi Arabia",
	"organization.card.identity.country.SB": "Solomon Islands",
	"organization.card.identity.country.SC": "Seychelles",
	"organization.card.identity.country.SD": "Sudan",
	"organization.card.identity.country.SE": "Sweden",
	"organization.card.identity.country.SG": "Singapore",
	"organization.card.identity.country.SH": "St. Helena",
	"organization.card.identity.country.SI": "Slovenia",
	"organization.card.identity.country.SJ": "Svalbard",
	"organization.card.identity.country.SK": "Slovakia",
	"organization.card.identity.country.SL": "Sierra Leone",
	"organization.card.identity.country.SM": "San Marino",
	"organization.card.identity.country.SN": "Senegal",
	"organization.card.identity.country.SO": "Somalia",
	"organization.card.identity.country.SR": "Suriname",
	"organization.card.identity.country.ST": "S.Tome",
	"organization.card.identity.country.STL": "Stateless",
	"organization.card.identity.country.SV": "El Salvador",
	"organization.card.identity.country.SY": "Syria",
	"organization.card.identity.country.SZ": "Swaziland",
	"organization.card.identity.country.TC": "Turks&Caicos Is",
	"organization.card.identity.country.TD": "Chad",
	"organization.card.identity.country.TF": "French S.Territ",
	"organization.card.identity.country.TG": "Togo",
	"organization.card.identity.country.TH": "Thailand",
	"organization.card.identity.country.TJ": "Tadschikistan",
	"organization.card.identity.country.TK": "Tokelau Islands",
	"organization.card.identity.country.TL": "Timor-Leste",
	"organization.card.identity.country.TM": "Turkmenistan",
	"organization.card.identity.country.TN": "Tunisia",
	"organization.card.identity.country.TO": "Tonga",
	"organization.card.identity.country.TP": "East Timor",
	"organization.card.identity.country.TR": "Turkey",
	"organization.card.identity.country.TT": "Trinidad",
	"organization.card.identity.country.TV": "Tuvalu",
	"organization.card.identity.country.TW": "Taiwan",
	"organization.card.identity.country.TZ": "Tanzania",
	"organization.card.identity.country.UA": "Ukraine",
	"organization.card.identity.country.UG": "Uganda",
	"organization.card.identity.country.UM": "Minor Outl.Ins.",
	"organization.card.identity.country.US": "USA",
	"organization.card.identity.country.UY": "Uruguay",
	"organization.card.identity.country.UZ": "Uzbekistan",
	"organization.card.identity.country.VA": "Vatican City",
	"organization.card.identity.country.VC": "St. Vincent",
	"organization.card.identity.country.VE": "Venezuela",
	"organization.card.identity.country.VG": "Brit.Virgin Is.",
	"organization.card.identity.country.VI": "US Virgin Is.",
	"organization.card.identity.country.VN": "Vietnam",
	"organization.card.identity.country.VU": "Vanuatu",
	"organization.card.identity.country.WF": "Wallis",
	"organization.card.identity.country.WS": "Samoa Islands",
	"organization.card.identity.country.XK": "Kosovo",
	"organization.card.identity.country.YE": "Yemen",
	"organization.card.identity.country.YT": "Mayotte",
	"organization.card.identity.country.YU": "Yugoslavia",
	"organization.card.identity.country.ZA": "South Africa",
	"organization.card.identity.country.ZM": "Zambia",
	"organization.card.identity.country.ZR": "Zaire",
	"organization.card.identity.country.ZW": "Zimbabwe",
	"organization.card.identity.name": "Name",
	"organization.card.identity.postCode": "Post code",
	"organization.card.identity.state": "County or state",
	"organization.card.identity.suppliers": "Suppliers",
	"organization.card.identity.vat": "VAT number",
	"organization.card.manage-transactional-visibilities": "Manage transactional visibilities",
	"organization.card.organizationcard": "Organization card",
	"organization.card.services": "Services",
	"organization.card.services.no-data": "You don't have any services",
	"organization.card.services.tab.desc": "Description",
	"organization.card.services.tab.name": "Name",
	"organization.card.services.title": "Service list",
	"organization.card.services.title.desc": "List of all services available for this organization in the related supplier context",
	"organization.card.transactional-visibilities": "Transactional visibilities",
	"organization.card.users": "Users",
	"organization.card.visibilities": "Visibilities",
	"organization.details-card.flow-chart": "Flow chart",
	"organization.details-card.flow-chart.current-organization": "Current organization",
	"organization.details-card.flow-chart.customer": "Customer",
	"organization.details-card.flow-chart.desc": "Place of this organization in the landscape",
	"organization.details-card.flow-chart.supplier": "Supplier",
	"organization.is-payer": "isPayer",
	"organization.is-shipto": "isShipTo",
	"organization.is-soldto": "isSoldTo",
	"organization.status.deactivated": "Deactivated",
	"organization.status.deleted": "Deleted",
	"organization.user-accept": "Accept",
	"organization.user-id": "Id",
	"organization.user-manage": "Manage",
	"organization.user-reject": "Reject",
	"organization.user-status-in-organization": "Status in organization",
	"organization.users.list.desc": "List of all available users in this organization",
	"organizationrole.api": "API",
	"organizationrole.dsu": "Administrator",
	"organizationrole.hlpdk": "HelpDesk",
	"organizationrole.subscription": "Notification",
	"organizationrole.user": "User",
	"overview.survey-answer": "I answer",
	"overview.survey-no-answer": "No, thank you",
	"overview.survey.please": "Please",
	"overview.survey.questions": "answer these 3 questions after your navigation (estimated time 20 sec)",
	"overview.viewby": "View By",
	"product.added.to.cart": "product(s) have been properly added to the cart",
	"product.card.new.specification": "New Specification",
	"product.error": "unexpected error while trying to look for the product",
	"product.feasibility.not-feasible": "not feasible",
	"product.feasibility.ok": "Product OK",
	"product.feasibility.pending": "Feasibility request in progress",
	"product.feasibility.refused": "This product is not feasible",
	"product.feasibility.technical-error": "Technical Error",
	"product.message.product.not.saved": "Unable to save product",
	"product.message.template.product.not.saved": "Unable to create new product",
	"product.most.used.values": "Most used values",
	"product.no.original.value": "No original value",
	"product.not.exist": "This product does not exist",
	"product.original.value": "Original value",
	"product.other.values": "Other existing values",
	"product.pc.label.max": "Max",
	"product.pc.label.min": "Min",
	"product.pc.label.unit": "Unit",
	"product.product.submitted": "Product submitted",
	"product.quality.dashboard": "Product quality dashboard",
	"product.save.template.product": "Save as new specification",
	"product.save.template.product.and.add.to.cart": "Save and add to cart",
	"product.table.header.add": "Add",
	"product.table.header.view": "View",
	"product.template": "Product template",
	"product.template.isbeingsimulated": "New spec is being validated …",
	"product.title.group.certificate": "Certificate",
	"product.title.group.coating": "Coating",
	"product.title.group.dimensions": "Dimensions",
	"product.title.group.insulationResistanceTest": "Insulation resistance test",
	"product.title.group.labelling": "Labelling",
	"product.title.group.management": "Management",
	"product.title.group.packing": "Packing",
	"product.title.group.productionProcess": "Production process",
	"product.title.group.specifications": "Specifications",
	"product.title.group.stamping": "Stamping",
	"product.title.group.surface": "Surface",
	"product.title.group.surfaceTreatment": "Surface treatment",
	"product.title.group.use": "Use",
	"product.title.group.weightDiameter": "Weight / diameter",
	"product.title.group.welds": "Welds",
	"product.title.section.bottom": "Bottom",
	"product.title.section.bundleHeight": "Bundle height",
	"product.title.section.bundleWeight": "Bundle weight",
	"product.title.section.coilWeight": "Coil weight",
	"product.title.section.customerArticle": "Customer article",
	"product.title.section.diameter": "Diameter",
	"product.title.section.edge": "Edge",
	"product.title.section.insideDiameter": "Inside Diameter",
	"product.title.section.numberSheetsPerBundle": "Number of sheets per bundle",
	"product.title.section.numberSlitCoilsPerPackage": "Number of slit coils per package",
	"product.title.section.outsideDiameter": "Outside diameter",
	"product.title.section.packageHeight": "Package height",
	"product.title.section.packageHeightWithPalet": "Package height included palet",
	"product.title.section.packageWeight": "Package weight (more than one coil per package)",
	"product.title.section.removableProtectiveFilm": "Removable protective film",
	"product.title.section.slabWeightInTon": "Slab weight in ton",
	"product.title.section.specificWeight": "Specific weight",
	"product.title.section.thickness": "Thickness",
	"product.title.section.top": "Top",
	"product.title.section.weight": "Weight",
	"product.title.section.width": "Width",
	"profile.no.access": "Please ensure to have internet accesses and log in to the application to view profile.",
	"profile.select": "Profile - Select",
	"profile.select.visibility": "Select a company/visibility",
	"profile.visibility.all": "All",
	"progress.message": "Your transaction is in progress",
	"progress.message.fastlane": "Your transaction is in progress",
	"promote.user.message": "User to promote :",
	"prototype-card": "Prototype card",
	"prototype-card-details.proposed-price": "Proposed price",
	"prototype-card-details.proposed-price.na": "N/A",
	"prototype-card.data-not-found": "The prototype does not exist",
	"prototype.card.deliveryweek": "Delivery week",
	"prototype.card.product.source": "source",
	"prototype.card.proposal": "Proposal",
	"prototype.card.proposal.deliveries": "Proposed deliveries",
	"prototype.card.proposal.product.information": "Proposed product",
	"prototype.card.proposed.quantities": "Proposed quantities",
	"prototype.card.proposed.readyForDispatch": "Ready for dispatch at PO receipt",
	"prototype.card.request.deliveries": "Requested deliveries",
	"prototype.card.request.information": "Requested product",
	"prototype.card.request.quantities": "Requested quantities",
	"prototype.card.sheetweight": "Sheet weight",
	"prototype.card.status.accepted": "Accepted",
	"prototype.card.status.materialnotfound": "Material not available",
	"prototype.card.status.notavailable": "Not available",
	"prototype.card.status.refusedbycustomer": "Refused by customer",
	"prototype.card.status.requested": "Requested",
	"prototype.production-po-reception-date": "PO reception date",
	"prototype.production.po-delivery": "Delivery",
	"prototype.production.po.order": "Order",
	"prototype.status.accepted": "Accepted",
	"prototype.status.closed": "Closed",
	"prototype.status.confirmed": "Confirmed",
	"prototype.status.decision": "Decision",
	"prototype.status.proposal": "Proposal",
	"prototype.status.refused": "Refused",
	"prototype.tracker.status": "Prototype status",
	"qty-by-family.title.note": "Please provide quantities for the related periods for this family",
	"quality.feedback.card.closed.issues": "Closed issues",
	"quality.feedback.card.closed.paid": "Paid",
	"quality.feedback.card.closed.rejected": "Rejected",
	"quality.feedback.card.details": "View details",
	"quality.feedback.card.open.issues": "Open issues",
	"quality.feedback.card.subtitle": "Closed claims details",
	"quality.feedback.card.title": "Quality feedback",
	"quality.first.selected.batch": "Your batches delivered or ready-to-ship for order",
	"quality.guarantee.request": "Guarantee request",
	"quality.information": "Quality Information",
	"quality.issue.save.failed": "Quality issue submit failed.",
	"quality.issues.draft.edit": "You will be able to edit it in your draft follow-up.",
	"quality.issues.draft.saved.successfully": "Your draft has been saved",
	"quality.issues.followup": "You will be able to view it in your My Quality issues follow-up.",
	"quality.issues.save.failed.message": "Please try again later or contact ebusiness.support@arcelormittal.com",
	"quality.issues.submitted.successfully": "Your quality issue has been submitted successfully.",
	"quality.max.selected.batch": "Selected batches (6 batches maximum)",
	"quapp.action.add.attach": "Add an attachment",
	"quapp.action.add.attach.progress": "Added in progress",
	"quapp.action.cancel": "Cancel Quality issue",
	"quapp.action.change": "Change",
	"quapp.action.delete": "Delete",
	"quapp.action.edit": "Edit",
	"quapp.action.go.back": "Go back",
	"quapp.action.save": "Save",
	"quapp.action.select.file": "Select your file",
	"quapp.action.send": "Send",
	"quapp.action.view": "View",
	"quapp.actor.am": "ArcelorMittal",
	"quapp.actor.customer": "Customer",
	"quapp.alert": "Alert",
	"quapp.attach.audio": "Audio",
	"quapp.attach.file": "File (PDF, excel, ...)",
	"quapp.attach.picture": "Picture",
	"quapp.attach.record.sound": "Record sound",
	"quapp.attach.record.video": "Record a video",
	"quapp.attach.take.picture": "Take a picture",
	"quapp.attach.video": "Video",
	"quapp.detector": "Detector",
	"quapp.error": "Error",
	"quapp.loading": "Loading",
	"quapp.logout.warning1": "Warning!",
	"quapp.logout.warning2": "By signing-out of the application, you will loose all non-synchronized issues!",
	"quapp.logout.warning3": "You have currently {{value}} non-synchronized action(s).",
	"quapp.logout.warning4": "Would-you really like to log out?",
	"quapp.notif.claim.cancelled": "{{value}} has been cancelled",
	"quapp.notif.claim.comment": "Comment: {{comment}}",
	"quapp.notif.claim.paid": "{{value}} has been paid ({{amount}} {{currency}}, {{quantity}} {{unit}})",
	"quapp.notif.claim.refused": "{{value}} has been refused",
	"quapp.notif.claim.warning": "{{value}} has been registered as warning",
	"quapp.notif.label": "Claim updated:",
	"quapp.notif.title": "SteelUser",
	"quapp.notification": "Notification",
	"quapp.page.not.found": "Page not found",
	"quapp.process.closed": "Accepted or refused",
	"quapp.process.closed.paid": "Paid",
	"quapp.process.closed.refused": "Refused",
	"quapp.process.closed.warning": "Registered as Warning",
	"quapp.process.create": "Waiting for connection",
	"quapp.process.inprogress": "Being processed by ArcelorMittal",
	"quapp.process.push": "Pushed to ArcelorMittal",
	"quapp.process.push-cancel": "Cancellation pushed to ArcelorMittal",
	"quapp.process.push-update": "Modification pushed to ArcelorMittal",
	"quapp.process.registered": "Registered by ArcelorMittal",
	"quapp.reader": "Reader",
	"quapp.validator": "Validator",
	"quapp.warning": "Warning",
	"readonly.user.error": "You are not allowed to take any action in simulation mode, you can only consult the customer's view",
	"remove.notification": "Remove Notification",
	"remove.unrecognized.batch": "is not recognized batch. Please select valid batch.",
	"request-feasibility": "Request feasibility",
	"request.card.information": "Request information",
	"reset.order": "Reseting your order",
	"reset.order.confirmation": "Do you want to proceed anyway ?",
	"reset.order.warning.add.product.another.family": "Warning: You already have one or more product(s) in your cart from an other family. Adding this product will reset the current cart (all selected products).",
	"reset.order.warning.customer.change": "Warning: Changing customer of an order will reset the current cart (all selected products).",
	"saBusinessStatus.closed": "Closed",
	"saBusinessStatus.high.risk.external": "High Risk External",
	"saBusinessStatus.high.risk.internal": "High Risk Internal",
	"saBusinessStatus.high.runner": "High runner",
	"saBusinessStatus.low.runner": "Low runner",
	"saBusinessStatus.on.hold": "On Hold",
	"saBusinessStatus.running": "Running",
	"saBusinessStatus.running.out": "Running-out",
	"saBusinessStatus.start.up": "Start-up",
	"sb.Cancel": "Cancel",
	"sb.Download": "Download",
	"sb.choose.options": "Choose Options",
	"sb.detailed.report": "Detailed Report",
	"sb.period": "Period",
	"sb.type": "Type",
	"scan.barcode": "Barcode",
	"scan.batch.choose": "Choose this batch",
	"scan.browser.title": "Batch recognition",
	"scan.customer": "Customer",
	"scan.dimensions": "Dimensions",
	"scan.get.closer": "Get closer to the label",
	"scan.go-batch-card": "Go to batch card",
	"scan.invoiced": "Invoiced",
	"scan.looking.batch.data": "Looking for Batch data...",
	"scan.looking.multi.batch.data": "Looking for related batches",
	"scan.material-scan": "Material scan",
	"scan.mill.order": "Mill order",
	"scan.quantity": "Quantity",
	"scan.quantity.optional": "Quantity (optional)",
	"scan.quantity.placeholder": "Type shipped quantity",
	"scan.select.batch": "Select your batch",
	"scan.serial.number": "Serial number",
	"scan.serial.number.placeholder": "Type serial number",
	"scan.supplier.order": "Supplier order",
	"scan.tip.disable-tips": "Disable tips",
	"scan.tip.message": "Can't scan a barcode? Check the settings (top right button) to check that you enabled the right scan mode for your barcode.",
	"scan.tip.ok": "Ok",
	"scan.tip.title": "Tip",
	"scan.title": "Scan the labels",
	"scan.weight": "Weight",
	"schedule-business-order-card.commercial-documents": "Commercial documents",
	"schedule-business-order-filter.customer-article-reference": "Customer article reference",
	"schedule-business-order-filter.thickness": "Thickness (mm)",
	"schedule-business-order-filter.width": "Width (mm)",
	"schedule-business-order.SA-unit": "SA unit",
	"schedule-business-order.card": "SA order card",
	"schedule-business-order.cem-partner": "CEM partner",
	"schedule-business-order.certificate": "Certificate",
	"schedule-business-order.choice": "Choice",
	"schedule-business-order.country-of-scf": "Country of SCF",
	"schedule-business-order.customer-expected-cumul": "Customer expected cumul",
	"schedule-business-order.customer-realized-cumul": "Customer realized cumul",
	"schedule-business-order.customer.article.reference": "Customer article reference",
	"schedule-business-order.customer.order.number": "Customer order number",
	"schedule-business-order.delivery": "Delivery",
	"schedule-business-order.delivery.address": "Delivery address",
	"schedule-business-order.delivery.mode": "Delivery mode",
	"schedule-business-order.final-use": "Final use",
	"schedule-business-order.form": "Form",
	"schedule-business-order.icon": "icon",
	"schedule-business-order.in-transit-stock": "In transit stock",
	"schedule-business-order.incoterm": "Incoterm",
	"schedule-business-order.internal-diameter": "Internal diameter (mm)",
	"schedule-business-order.interpretation-delivery-date": "Interpretation delivery date",
	"schedule-business-order.lead-delay": "Lead/Delay",
	"schedule-business-order.needs": "Needs",
	"schedule-business-order.oil-reference": "Oil reference",
	"schedule-business-order.order-follow-up-schedule": "Order follow-up schedule",
	"schedule-business-order.order-reason": "Order reason",
	"schedule-business-order.packing": "Packing",
	"schedule-business-order.pds-instruction": "PDS instruction",
	"schedule-business-order.plant-stock": "Plant stock",
	"schedule-business-order.product": "Product information",
	"schedule-business-order.product.category": "Product category",
	"schedule-business-order.protection": "Protection",
	"schedule-business-order.realized-cumul": "Realized cumul",
	"schedule-business-order.reference-of-alignment": "Reference of alignment",
	"schedule-business-order.sa-business-status": "SA business status",
	"schedule-business-order.sfc-country": "SFC country",
	"schedule-business-order.shortdescription": "Short description",
	"schedule-business-order.situation-overview": "Situation overview",
	"schedule-business-order.standard": "Standard",
	"schedule-business-order.standard.steelgrade": "Standard steelgrade",
	"schedule-business-order.stock": "Stock",
	"schedule-business-order.stock-blocked": "Stock blocked",
	"schedule-business-order.stock-partner": "Stock partner",
	"schedule-business-order.supplier.order.number": "Supplier order number",
	"schedule-business-order.surface-aspect": "Surface aspect",
	"schedule-business-order.time-of-alignment": "Time of alignment",
	"schedule-business-order.transport-mode": "Transport mode",
	"schedule-business-order.wip": "WIP",
	"search.batches": "Batches",
	"search.by": "search by",
	"search.certificates": "Certificates",
	"search.claim": "Claims",
	"search.count.batches": "{{value}} batches",
	"search.count.closed": "{{value}} closed issues",
	"search.count.drafts": "{{value}} drafts",
	"search.count.orders": "{{value}} orders",
	"search.count.pending": "{{value}} pending issues",
	"search.dispatch.advices": "Dispatch advices",
	"search.display": "Display",
	"search.guarantees": "Guarantees",
	"search.invoices": "Invoices",
	"search.order.acknowledgments": "Order acknowledgments",
	"search.placeholder": "Search...",
	"search.see.result": "See result",
	"search.see.results": "See {{value}} results",
	"search.shipment": "Shipment",
	"search.shipments": "Shipments",
	"section.filters": "Filters",
	"see.all.batches": "See all batches",
	"see.all.documents": "See all documents",
	"select.auction.title": "Select your auction",
	"select.new.administrator": "The removal of this user will need to select a new administrator for this Organization :",
	"select.product.spec": "Filter your product catalogue",
	"sent.closed.no.issue": "No closed issue",
	"sent.hide.process": "Hide Process",
	"sent.issue": "Quality issue",
	"sent.pending.no.issue": "No pending issue",
	"sent.search.issues": "Search issues",
	"sent.show.process": "Show Process",
	"sent.since": "Since {{value}}",
	"sent.status": "STATUS",
	"service.parameters.value": "Value",
	"services.Back": "BACK TO ADDING A SERVICE",
	"services.management": "Services management",
	"services.settings": "Settings",
	"settings.account": "My account",
	"settings.actions": "Actions",
	"settings.activity": "Activity",
	"settings.activity-desc": "Last activity",
	"settings.add-all-services": "Add all services",
	"settings.all-services-added": "All services added to user",
	"settings.any": "Any",
	"settings.boolean.off": "Off",
	"settings.boolean.on": "On",
	"settings.business-id": "Business ID",
	"settings.change-simulated-user": "Change simulated user",
	"settings.city": "City",
	"settings.company": "Company",
	"settings.date-format-dd/mm/yyyy": "dd/mm/yyyy",
	"settings.date-format-mm/dd/yyyy": "mm/dd/yyyy",
	"settings.delegation.changement": "Change my delegated organization",
	"settings.download.aggregated": "Aggregated",
	"settings.download.duplicate": "Duplicate",
	"settings.drag-drop-services-here": "Drag and drop the services you want to add here",
	"settings.drag-services-here": "Drag services here to remove from user",
	"settings.email": "Email",
	"settings.faq": "FAQ",
	"settings.firstname": "Firstname",
	"settings.gender": "Gender",
	"settings.general": "General settings",
	"settings.general.date-format": "Date format",
	"settings.general.helper": "Settings for mobile applications and web part",
	"settings.general.time-format": "Time format",
	"settings.generalSalesCondition": "General Sales Conditions",
	"settings.identity": "Identity",
	"settings.identity.desc": "Personal data",
	"settings.informational-visibilities": "Informational Visibilities",
	"settings.last-connection-date": "Last connection date",
	"settings.lastname": "Lastname",
	"settings.legal-information": "Legal information",
	"settings.legal-information.property": "SteelUser App is the property of ArcelorMittal FCE SA domiciled at 24-26 Boulevard d'Avranches L-1160 Luxembourg, Luxembourg.",
	"settings.legal-information.questions": "Please address all questions or comments about this App to our e-services team :",
	"settings.legal-information.require-registration": "The use of the app requires registration",
	"settings.login": "Login",
	"settings.logout": "Logout",
	"settings.manage-info-visibilities": "Manage info visibilities",
	"settings.manage-services": "Manage services",
	"settings.name": "Name",
	"settings.order.customer": "Customer order number",
	"settings.order.number": "Order Number",
	"settings.order.supplier": "Supplier order number",
	"settings.order.tracking": "Order tracking",
	"settings.ordertracking.sorting.list": "Default sorting of list",
	"settings.organisation": "Organisation",
	"settings.organizations": "Organizations",
	"settings.organizations.desc": "Memberships",
	"settings.organizations.name": "Name",
	"settings.organizations.role": "Role",
	"settings.organizations.visibilities.address": "Address",
	"settings.organizations.visibilities.name": "Name / City",
	"settings.other": "Other settings",
	"settings.password-doesn't-match-rules": "Password doesn't match below rules",
	"settings.password-updated-successfully": "Password updated successfully",
	"settings.phone": "Cell phone",
	"settings.phone-number": "Phone number",
	"settings.privacy-policy": "Privacy policy",
	"settings.privacypolicy.ContactUs": "Contact Us?",
	"settings.privacypolicy.ContactUsAddress": "Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxembourg, Luxembourg",
	"settings.privacypolicy.ContactUsByEmail": "or via email at",
	"settings.privacypolicy.ContactUsPlease": "Please address all questions or comments about this Privacy Policy to:",
	"settings.privacypolicy.GeneralInformation": "General Information",
	"settings.privacypolicy.GeneralInformationProperty": "SteelUser is the property of ArcelorMittal France. ArcelorMittal France, a French company registered in the Trade and Companies Register of Bobigny with no. 562 094 425, having its head office at Immeuble “Le Cézanne, 6, rue André Campra, F-93200 Saint-Denis, France hosts the SteelUser.com site, coordinates site maintenance and deals with the integration functions. By registering as a member of SteelUser, you can perform (buying, online order follow up, access to sales documents, etc.) transactions on the Internet in full security and confidentiality.",
	"settings.privacypolicy.GeneralInformationWebservices": "SteelUser platform offers ArcelorMittal customers advanced web-services such as online order follow-up, commercial documents consultation, auctions of non-prime materials, web order entry and technical data consultation. It simplifies and speeds-up the relationships between steel buyers and ArcelorMittal.",
	"settings.privacypolicy.HypertextLinksContent": "The hyperlinks on SteelUser platform which lead to other existing resources on the Internet, in particular to its partners, have received previous express, written authorization. Users of SteelUser may set up a hyperlink to this site without the express, previous authorization of ArcelorMittal.",
	"settings.privacypolicy.PersonalInformation": "Personal information that you choose to submit",
	"settings.privacypolicy.PersonalInformationContent": "The purpose of SteelUser platform is to support some business processes between ArcelorMittal, namely order management, follow-up on litigations, auctions, release of commercial and technical documentation about ArcelorMittal products. These business functions involve the management of the users’actions as representatives of ArcelorMittal’s customers. Therefore, SteelUser registration form requests you to give us your references (customer name, last name & first name, contacts details and function). If you do not provide mandatory personal information with respect to a particular activity, you will not be able to engage in that activity.",
	"settings.privacypolicy.PrivacyPolicy": "Privacy policy",
	"settings.privacypolicy.PrivacyPolicyContent": "Protecting your privacy and personal data is important to us. ArcelorMittal has adopted a data protection procedure (“Binding Corporate Rules”). This procedure provides a global and simplified legal basis for all databases and applications sharing personal data within the group. The ArcelorMittal data protection procedure is a group-wide procedure ensuring a minimum standard of protection for personal data shared at global level, similar to the protection offered under EU rules. ArcelorMittal data protection procedure (“Binding Corporate Rules”) together with main policies is published on",
	"settings.privacypolicy.Property": "Intellectual and Industrial Property",
	"settings.privacypolicy.PropertyContent": "The content of SteelUser platform (including, without character limitation, text, graphical images, audio/ video files, HTML code, buttons, commercial brands, software, emblems) is property of ArcelorMittal, unless otherwise indicated. It respects the rights relating to third parties. The content cannot be commercialized, distributed, transmitted, copied, modified in any way without the previous consent in writing to ArcelorMittal. The unauthorized use of the content of SteelUser platform is strictly prohibited. Doing so constitutes a breach of the legislation including intellectual property, commercial, trade names or any other type of rights of the industrial property. Users will be able to download, visualize or print a copy of this page on a personal computer exclusively for personal and private use.",
	"settings.privacypolicy.Protection": "Protection of Personal Data",
	"settings.privacypolicy.Protection2years": "In case of user’s inactivity during 2 years, SteelUser access will be automatically removed. Personal information that is no longer required to fulfil the identified purposes are destroyed, erased, or made anonymous. ArcelorMittal developed guidelines and implemented procedures to govern the destruction of personal information.",
	"settings.privacypolicy.ProtectionAbuse": "The users must refrain, with regard to nominative data which they can access in any database, from abuse of any kind, and from all acts likely to undermine people´s private life or reputation.",
	"settings.privacypolicy.ProtectionCommunication": "ArcelorMittal communicates to users that their personal data will not be passed on to third parties. If necessary, permission will be sought explaining reasons and activities to which the information will be used once and if permission is given. Their data will be dealt with absolute confidentiality. If for any reason, the consent of the user for the treatment and cession of its data can be revoked by contacting the referenced address at the end of this section. When requested information, we understand that the user agrees to (i) that ArcelorMittal can share its information within its subsidiaries (companies are indexed in the web page www.arcelormittal.com) and (ii) allows ArcelorMittal, to use this information in the future to inform the user about questions or matters of interest for the user relating to ArcelorMittal and its products.",
	"settings.privacypolicy.ProtectionResponsible": "Where we have given user (or where user has chosen) a password which enables user to access certain parts of SteelUser site, the user is responsible for keeping this password confidential. We ask user not to share a password with anyone. The user agrees to (a) immediately notify us of any unauthorized use of his password or account or any other breach of security, and (b) ensure that the user exits from your account at the end of each session. It is the user’s responsibility to control the dissemination and use of his password, control access to and use of his account, and notify us when the user desires to cancel his account on this site. We are not responsible or liable for any loss or damage arising from the failure to comply with this provision.",
	"settings.privacypolicy.ProtectionSecrecy": "ArcelorMittal is committed to the fulfillment of its obligation of secrecy of personal data information. Its duty is to treat them with confidentiality and assume the necessary safety measures of a technical and organizational nature to avoid the alteration, loss or unauthorized access of such information.",
	"settings.privacypolicy.ResponsabilitiesContent": "ArcelorMittal implements SteelUser platform to offer users available, verified data and/or tools, but ArcelorMittal is not responsible for errors, lack of availability of data, and/or the presence of a virus on SteelUser.",
	"settings.privacypolicy.UseCookiesInstalled": "By visiting SteelUser, the user agrees that cookies may be installed in his navigation software. The cookies make it possible to save information relevant to the user´s navigation on the site. They are It is used by SteelUser only to ensure the proper functioning of the private sections of the site.",
	"settings.privacypolicy.UseCookiesNavigation": "The parameters of the navigation software make it possible for the user to be aware of the presence of the cookie, and to refuse them if desired in the following way:",
	"settings.privacypolicy.UseCookiesRefusing": "The user is informed, however, that refusing cookies will make it impossible for him to access the private sections of the site, in particular, he will not be able to conduct on-line transactions.",
	"settings.privacypolicy.UseDataProvidedConsultrectify": "Some users will take on the role of administrator, and will manage the member profiles for their company. Administrators must inform these users of the right said users have to access, modify, and suppress the profiles which concern them. Every SteelUser user has the right to consult and rectify his nominative data, which he may exercise by writing to the following address: Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxembourg, Luxembourg or by email at",
	"settings.privacypolicy.UseDataProvidedResponses": "The user is informed that responses entered into SteelUser, especially with regard to those required in order to access the private sections of the said site as a member, may be used by ArcelorMittal, and transferred to the services in charge of industrial and commercial operations, which are essential to the consideration and processing of transactions.",
	"settings.privacypolicy.UseGoogleAnalytics": "Use of Google Analytics",
	"settings.privacypolicy.UseGoogleAnalyticsContent": "Google Analytics cookies are used to collect information about how visitors use our site. We use the information to compile reports and to help us improve the site.  The cookies collect information in an anonymous form, including the number of visitors to the site, where visitors have come to the site from and the pages they visited. To get information about how Google uses data please refer to the following URL:",
	"settings.privacypolicy.Worldwidetransfer": "Worldwide Transfer of Personal Data",
	"settings.privacypolicy.amwebsite": "ArcelorMittal web site",
	"settings.privacypolicy.creditsforpictures": "Credits for pictures",
	"settings.privacypolicy.hypertextlinks": "Hypertext Links",
	"settings.privacypolicy.ifyouareusing": "If you are using",
	"settings.privacypolicy.responsabilities": "Responsabilities",
	"settings.privacypolicy.tableofcontent": "Table of content",
	"settings.privacypolicy.usecookies": "Use of cookies",
	"settings.privacypolicy.usedataprovided": "Use of Data provided",
	"settings.privacypolicy.worldwidetransfercontent": "SteelUser may be accessed by ArcelorMittal entities world-wide. Personal data will be used only for the purposes described in this Privacy Policy. An adequate level of protection shall be ensured and appropriate security measures shall be taken in order to protect such personal data against accidental or unlawful destruction or accidental loss, alteration, unauthorized disclosure or access. By using SteelUser you consent to any such transfer.",
	"settings.product": "Product",
	"settings.product.article": "Customer Article Reference",
	"settings.product.standard.dimension": "Standard SteelGrade + Dimensions",
	"settings.product.steelgrade": "Steelgrade",
	"settings.profile": "Profile",
	"settings.remove-service": "Remove service",
	"settings.remove-service-confirmation": "Do you really want to delete this service",
	"settings.requested.email": "Requested Email",
	"settings.sales.framework": "Sales Framework",
	"settings.save-changes": "Save changes",
	"settings.scan": "Scan",
	"settings.scan.beep": "Beep",
	"settings.scan.display-tip": "Display tip",
	"settings.scan.mode": "Scan mode",
	"settings.scan.mode.laser": "Laser mode / single value",
	"settings.scan.mode.matrix": "Matrix / multiple zones",
	"settings.select.download-type": "Select how you want to download data:",
	"settings.select.language": "Select your language:",
	"settings.select.order.number": "Select how you want to display order references:",
	"settings.select.ordertracking.sortlist": "Select how you want to sort your list in Order Tracking:",
	"settings.select.product": "Select how you want to display the product:",
	"settings.select.scan.beep": "Do you want to hear a beep every time the values are recognized:",
	"settings.select.scan.mode": "Select with which method you want to scan:",
	"settings.select.weight": "Select how you want to display the weight:",
	"settings.services-mangement": "Services management",
	"settings.snackbar.downloadType": "Now your download type is {{downloadType}}.",
	"settings.snackbar.language": "Now your language will be {{lang}}.",
	"settings.snackbar.order": "Now your order reference display is {{order}}.",
	"settings.snackbar.product": "Now your product display is {{product}}.",
	"settings.snackbar.visibility": "Now you will be able to see data for {{visibility}} for the supplier {{supplier}}.",
	"settings.snackbar.weight": "Now your weight display is {{weight}}.",
	"settings.supplier": "Supplier",
	"settings.survey.wot.overview": "the new order and delivery overview page",
	"settings.terms.of.use": "Terms Of Use",
	"settings.time-format-12:00": "12:00",
	"settings.time-format-24:00": "24:00",
	"settings.update.validate": "Validate",
	"settings.user-update-error": "An error occurred during the update of the user, changes are not saved",
	"settings.visibility": "Visibilities",
	"settings.visibility.changeimpact": "Changing this value will impact other Steeluser systems.",
	"settings.visibility.data": "I currently see data for (Organization - Supplier)",
	"settings.visibility.helper": "Choose you scope for mobile application and web part",
	"settings.visibility.info": "The visibility is shared between all Steeluser plateform (mobile and web).",
	"settings.weight": "Weight",
	"settings.weight.gross": "Gross",
	"settings.weight.net": "Net",
	"share.view.share": "Share",
	"shareview.success.message": "shared successfully",
	"shipment-card.data-not-found": "Shipment data not found",
	"shipment.card": "Shipment card",
	"shipment.card.information": "Shipment information",
	"shipment.dispatch-advice": "Dispatch advice",
	"shipment.dispatch-advice-date": "Dispatch advice date",
	"shipment.dispatch-advice-number": "Dispatch advice number",
	"shipment.dispatch-date": "Dispatch date",
	"shipment.filter.batch-number": "Batch number",
	"shipment.filter.customer": "Customer",
	"shipment.filter.customer-article-reference": "Customer article reference",
	"shipment.filter.customer-order-number": "Customer order number",
	"shipment.filter.dispatch-advice-date": "Dispatch advice date",
	"shipment.filter.dispatch-advice-number": "Dispatch advice number",
	"shipment.filter.dispatch-date": "Dispatch date",
	"shipment.filter.mill": "Mill",
	"shipment.filter.ship-to": "Ship to",
	"shipment.filter.sold-to": "Sold to",
	"shipment.filter.standard-steelgrade": "Standard steelgrade",
	"shipment.filter.supplier-order-number": "Supplier order number",
	"shipment.filter.thickness": "Thickness",
	"shipment.filter.transport-mode": "Transport mode",
	"shipment.filter.transport-reference": "Transport reference",
	"shipment.filter.width": "Width",
	"shipment.first": "First",
	"shipment.last": "Last",
	"shipment.shipped-qty-gross": "Shipped qty gross (t)",
	"shipment.step": "Step",
	"shipment.tmode.byairplane": "by airplane",
	"shipment.tmode.byinlandwaterways": "by inland waterways",
	"shipment.tmode.byrail": "by rail",
	"shipment.tmode.byrail.feve": "by rail (FEVE)",
	"shipment.tmode.byrailroad": "by rail and road",
	"shipment.tmode.byroad": "by road",
	"shipment.tmode.bysea": "maritime",
	"shipment.tmode.bytrain": "train",
	"shipment.tmode.notspecified": "not specified",
	"shipment.to": "Shipment to",
	"shipment.transport-reference": "Transport reference",
	"simulated.customer.updated": "Simulated customer has been updated.",
	"snackbar.add.existing.user.validation.mail-external": "User has been correctly created.",
	"snackbar.add.user.validation.mail-external": "User has been correctly created. An email has been sent to the new user to activate the account.",
	"snackbar.add.user.validation.mail-internal": "User has been correctly created. An email has been sent to the admin for validation.",
	"snackbar.offline": "You need to be connected to change a setting",
	"snackbar.survey": "Thank you for you time, your feedback is really important for us.",
	"sortby.cdd.asc": "CDD asc",
	"sortby.cdd.desc": "CDD desc",
	"sortby.order.asc": "Order asc",
	"sortby.order.desc": "Order desc",
	"sortby.product.asc": "Product asc",
	"sortby.product.desc": "Product desc",
	"srvmg.requestor.description": "Act as a SOX Requestor",
	"srvmg.requestor.label": "Requestor",
	"srvmg.validator.description": "Act as a SOX Validator",
	"srvmg.validator.label": "Validator",
	"standard-steelgrade": "Standard steelgrade",
	"start.date": "Start date",
	"status-group.blocked": "Blocked",
	"status-group.in-consignment": "Available - In consignment",
	"status-group.in-prod": "In Production",
	"status-group.in-transit": "Available - In transit",
	"status-group.rtt": "Available - Ready To Ship",
	"steelgrade-feasibility": "Steelgrade",
	"stock-alert.green": "Green",
	"stock-alert.orange": "Orange",
	"stock-alert.red": "Red",
	"submit.guarantee.request": "Submit your guarantee request",
	"supplier.comment": "Supplier Comment",
	"suppliergroup.amds": "ArcelorMittal Distribution Solutions",
	"suppliergroup.aperam": "Aperam",
	"suppliergroup.fce": "ArcelorMittal FCE",
	"survey.agree": "agree",
	"survey.amount.of.time": "time i spent to find information",
	"survey.answer.dialog.title": "Please rate the usability of",
	"survey.clarity.information": "clarity of information",
	"survey.disagree": "disagree",
	"survey.ease.find.information": "ease to find information",
	"survey.evaluate.statement": "Evaluate the 3 following statements",
	"survey.header.title": "Help us to improve",
	"survey.statements": "I am satisfied with the",
	"survey.strongly": "Strongly",
	"table.no.results": "no result",
	"table.results": "{{value}} results",
	"term.policy": "Terms and policy",
	"title.product.catalogue": "Add a new product to your catalogue",
	"title.product.order": "Choose the product you want to order",
	"tmode.byair": "By air",
	"tmode.bysea": "By sea",
	"tmode.default": "_Default",
	"tmode.inlandwaterway": "Inland Waterway",
	"tmode.lorry": "Lorry",
	"tmode.lorryrailway": "Lorry + Railway",
	"tmode.othertospecify": "Other (to specify)",
	"tmode.rail": "Rail",
	"tmode.railwaylorry": "Railway + lorry",
	"total.quantity.period": "Total quantity for the period",
	"transport.mode": "Transport mode",
	"transport.mode.boat": "Boat",
	"transport.mode.plane": "Plane",
	"transport.mode.train": "Train",
	"transport.mode.truck": "Truck",
	"transversal.dashboard": "Dashboard",
	"transversal.dashboard.plural": "Dashboards",
	"transversal.data-administration": "Administration",
	"transversal.data-center": "Data center",
	"transversal.data-center-batches": "Batches",
	"transversal.data-center-documents": "Commercial documents",
	"transversal.data-center-order": "Orders",
	"transversal.data-center.batches": "Data center: Batches",
	"transversal.data-center.plural": "Datacenters",
	"transversal.data-center.prototype": "Prototypes",
	"transversal.data-center.users": "Users",
	"transversal.delegated-to": "Delegated to",
	"transversal.eoffer": "eOffer",
	"transversal.equality": "eQuality",
	"transversal.go-back-to-old-steeluser": "Access to old SteelUser",
	"transversal.guarantee-documents": "Guarantee documents",
	"transversal.home": "Home",
	"transversal.in-a-delegation": "(in a delegation)",
	"transversal.lastbatches": "Last batches",
	"transversal.legal": "Legal",
	"transversal.order-tracking": "Order Tracking",
	"transversal.order.delivery": "Order and delivery",
	"transversal.quality": "Quality",
	"transversal.schedule-busiess-order": "Schedule business orders",
	"transversal.services": "Services",
	"transversal.shipments": "Shipments",
	"transversal.simulation-of": "Simulation of",
	"transversal.steeluser": "SteelUser",
	"unit.kg": "kg",
	"unit.m2": "m²",
	"unit.pc": "Pieces",
	"unit.to": "Metric tons",
	"unrecognized.batch": "Unrecognized Batch",
	"upload.file.count.error.message": "-max-count- files maximum per item",
	"upload.file.error.message": "An error occured during uploading process",
	"upload.file.maxitem.error.message": "3 files maximum per item",
	"upload.file.mime.type.error.message": "PDF, DOC, XLS, PPT or images only allowed. Upload type is MIME--TYPE",
	"upload.file.name.error.message": "Invalid file name - Use alphanumeric, hyphens, spaces, underscores and at least 5 characters",
	"upload.file.size.error.message": "Max file size is 20MB",
	"upload.file.space.error.message": "Sorry: not enough space to add automatically template file as attachment",
	"upload.or": "or",
	"user.belong.to": "I belong to",
	"user.card.about-cookies": "Cookies are small text files that can be used by websites to make the user experience more efficient.The law stipulates that we may only store cookies on your device if they are strictly necessary for the operation of this site. For all other types of cookies, we need your permission. This site uses different types of cookies. Some cookies are placed by the third party services that appear on our pages. At any time, you can change or withdraw your consent as soon as you see the Cookie Statement on our website. For more information about who we are, how you can contact us and how we can handle personal data please see our Privacy policy.",
	"user.card.about-cookies.title": "About Cookies",
	"user.card.accept": "Accept",
	"user.card.account-info": "Account information",
	"user.card.allowed": "Allowed",
	"user.card.apply": "Apply",
	"user.card.audience-measurement-cookies": "We use audience measurement cookies whose purpose is limited to the sole measurement of the website or application audience performance measurement, detection of navigation problems, optimisation of Technical performance or ergonomics, estimation of the power of the neccessary servers, analysis of the content constructed for the exclusive account of Arcelor Mittal",
	"user.card.audience-measurement-cookies.title": "Audience measurement cookies",
	"user.card.cookies-exempt-from-consents.one": "The cookies keeping the choice expressed by the users on the plotter respository.",
	"user.card.cookies-exempt-from-consents.three": "The user interface customisation cookies (e.g. for the choice of language or presentation of a service), where such a customisation is an intrinsic and expected element of the service.",
	"user.card.cookies-exempt-from-consents.title": "Cookies that are exempt from consents",
	"user.card.cookies-exempt-from-consents.two": "The cookies intended for authentication to a service, including those intended to ensure the security of the authentication mechanism, for example by limiting robotic Or unexpected access attempts.",
	"user.card.details": "Details",
	"user.card.not-allowed": "Not Allowed",
	"user.card.notifications": "Notifications",
	"user.card.notifications.no-data": "You don't have any notifications",
	"user.card.notifications.tab.description": "Description",
	"user.card.notifications.tab.details": "Details",
	"user.card.notifications.tab.frequency": "Frequency",
	"user.card.notifications.tab.service": "Service",
	"user.card.notifications.tab.subscription": "Subscription",
	"user.card.notifications.title": "Notifications",
	"user.card.notifications.title.desc": "List of alerts for this user",
	"user.card.personalcard": "Personal card",
	"user.card.personalize-privacy-settings.title": "Personalize your privacy settings",
	"user.card.privacy-settings": "Privacy Settings",
	"user.card.reject": "Reject",
	"user.card.security": "Security",
	"user.card.security.1-lowercase-letter-rule": "1 lowercase letter (a, b, c, d, e)",
	"user.card.security.1-number-rule": "1 number (1, 2, 3, 4)",
	"user.card.security.1-special-character-rule": "1 special character (:, /, !, _, -, #, @)",
	"user.card.security.1-uppercase-letter-rule": "1 uppercase letter (A, B, C, D, E)",
	"user.card.security.15-character-rule": "15 characters minimum",
	"user.card.security.change-login-title": "Change your login",
	"user.card.security.change-password-title": "Change your password",
	"user.card.security.confirm-password-match": "Confirm password should match with new password",
	"user.card.security.password-must-contain-title": "To be valid the password must contain at least:",
	"user.card.security.username-error": "Please enter valid username",
	"user.card.security.your-current-password": "Your current password",
	"user.card.security.your-login": "Your login",
	"user.card.security.your-new-password": "Your new password",
	"user.card.security.your-repeat-new-password": "Repeat your new password",
	"user.card.services": "Services",
	"user.card.services.no-data": "You don't have any services",
	"user.card.services.tab.desc": "Description",
	"user.card.services.tab.name": "Name",
	"user.card.services.tab.settings": "Settings",
	"user.card.services.title": "Service list",
	"user.card.services.title.desc": "List of all services available for this user in the related supplier context",
	"user.card.settings": "Settings",
	"user.expired": "Expired",
	"user.expiryDate": "Expiry date",
	"user.gender.mr": "Mr.",
	"user.gender.mrs": "Mrs.",
	"user.gender.ms": "Miss",
	"user.language": "Language",
	"user.need.connection": "You need to be authentified to access to this part.",
	"user.no.connection": "You need to have a valid connection to access to this part.",
	"user.no.role": "Your profile can not manage quality issue. Please contact your SteelUser Relay to get full access to Quality App service.",
	"user.no.service": "Your profile can not manage quality issue. Please contact your SteelUser Relay to get full access to Quality App service.",
	"user.notifications.add.subscription": "Add",
	"user.notifications.btn.add.subscription": "Add Subscription",
	"user.notifications.dialog.subscription": "Add a Subscription",
	"user.notifications.dropdown.frequency": "Frequency",
	"user.notifications.dropdown.services": "Services",
	"user.notifications.dropdown.subscription": "Subscription",
	"user.notifications.select.frequency": "Please select a frequency",
	"user.notifications.select.service": "Please select a service",
	"user.notifications.select.subscription": "Please select a subscription",
	"user.see.data": "I currently see data for",
	"user.supplier": "My supplier",
	"user.user": "User",
	"user.validation": "User is required",
	"user.validationDaysLeft": "ValidationDaysLeft",
	"userServiceInfo.services.management": "Active Services",
	"userServiceInfo.services.settings": "Settings",
	"users.details-card.actions": "Actions",
	"users.list": "Users list",
	"view.shared.success": "Do you really want to delete this draft {{value}} ?",
	"view.validation": "View is required",
	"viewby.cdd.asc": "CDD asc",
	"viewby.cdd.desc": "CDD desc",
	"viewby.mill.asc": "Mill asc",
	"viewby.mill.desc": "Mill desc",
	"viewby.product.asc": "Product asc",
	"viewby.product.desc": "Product desc",
	"viewby.step": "Step",
	"wait.message": "Please DO NOT PRESS back button or refresh button in your browser",
	"wait.message.fastlane": "Please DO NOT PRESS back button or refresh button in your browser",
	"wait.user.validation": "Waiting for user validation",
	"want.to.cancel.issue": "Do you really want to cancel this issue",
	"want.to.close": "Are you sure you want to close?",
	"want.to.delete.draft": "Do you really want to delete this draft",
	"want.to.delete.notification": "Do you really want to delete this notification",
	"warning-product-category": "Please select a product category.",
	"warning-standard-steelgrade": "Please select a standard steelgrade.",
	"warning-steelgrade": "Please select a steelgrade.",
	"warning-sub-category": "Please select a sub category.",
	"warning-thickness": "Please enter thickness.",
	"warning-width": "Please enter width.",
	"warning.closed.orders": "You are writing a comment on a closed order",
	"warning.maximum.1000": "Cannot download more than 1000 records at a time",
	"warning.maximum.30": "Cannot download more than 30 records at a time",
	"woe.noitems": "No Item",
	"workflow-steps.next.error": "Something went wrong, please contact SteelUser administrator",
	"xcarb-document.card": "XCarb® Document",
	"xcarb.label": "XCarb®"
};
